/* eslint-disable */
/**
 * AUTO-GENERATED by scripts/assemble-bible-registry.mjs — do not edit by hand.
 * Regenerate via the generate-bible-registry-part*.mjs + assemble scripts.
 */
import type { BibleRegistryEntry } from "../bibleRegistry.types";

export const BIBLE_REGISTRY_ENTRIES: BibleRegistryEntry[] = [
  {
    id: "creation",
    book: "genesis",
    section: "Creation",
    displayName: "Creation",
    bibleReference: "Genesis 1:1–2:3",
    chronologicalOrder: 0,
    parentChapterId: null,
    unlockRequirement: null,
    status: "available",
    estimatedGameplayType: ["Cutscene", "Exploration"],
    description: "The seven days of creation — God speaks the world into being.",
    titleKey: "journey.chapter.creation.title",
    referenceKey: "journey.chapter.creation.reference",
  },
  {
    id: "creation-day-1",
    book: "genesis",
    section: "Creation",
    displayName: "Creation Day 1 — Light",
    bibleReference: "Genesis 1:1–5",
    chronologicalOrder: 1,
    parentChapterId: null,
    unlockRequirement: "creation",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "God creates light and separates day from night.",
  },
  {
    id: "creation-day-2",
    book: "genesis",
    section: "Creation",
    displayName: "Creation Day 2 — Sky",
    bibleReference: "Genesis 1:6–8",
    chronologicalOrder: 2,
    parentChapterId: null,
    unlockRequirement: "creation-day-1",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "God forms the expanse and separates the waters.",
  },
  {
    id: "creation-day-3",
    book: "genesis",
    section: "Creation",
    displayName: "Creation Day 3 — Land and Plants",
    bibleReference: "Genesis 1:9–13",
    chronologicalOrder: 3,
    parentChapterId: null,
    unlockRequirement: "creation-day-2",
    status: "comingSoon",
    estimatedGameplayType: "Exploration",
    description: "Dry land appears; vegetation fills the earth.",
  },
  {
    id: "creation-day-4",
    book: "genesis",
    section: "Creation",
    displayName: "Creation Day 4 — Sun, Moon, and Stars",
    bibleReference: "Genesis 1:14–19",
    chronologicalOrder: 4,
    parentChapterId: null,
    unlockRequirement: "creation-day-3",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Lights in the heavens mark seasons, days, and years.",
  },
  {
    id: "creation-day-5",
    book: "genesis",
    section: "Creation",
    displayName: "Creation Day 5 — Sea Creatures and Birds",
    bibleReference: "Genesis 1:20–23",
    chronologicalOrder: 5,
    parentChapterId: null,
    unlockRequirement: "creation-day-4",
    status: "comingSoon",
    estimatedGameplayType: "Exploration",
    description: "Waters swarm with life; birds fill the sky.",
  },
  {
    id: "creation-day-6",
    book: "genesis",
    section: "Creation",
    displayName: "Creation Day 6 — Animals and Humanity",
    bibleReference: "Genesis 1:24–31",
    chronologicalOrder: 6,
    parentChapterId: null,
    unlockRequirement: "creation-day-5",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Land animals are made; humanity is created in God's image.",
  },
  {
    id: "creation-day-7",
    book: "genesis",
    section: "Creation",
    displayName: "Creation Day 7 — Sabbath Rest",
    bibleReference: "Genesis 2:1–3",
    chronologicalOrder: 7,
    parentChapterId: null,
    unlockRequirement: "creation-day-6",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "God rests and blesses the seventh day.",
  },
  {
    id: "garden-of-eden",
    book: "genesis",
    section: "Eden",
    displayName: "Garden of Eden",
    bibleReference: "Genesis 2:4–25",
    chronologicalOrder: 8,
    parentChapterId: null,
    unlockRequirement: "creation-day-7",
    status: "available",
    estimatedGameplayType: ["Story", "Exploration"],
    description: "Adam and Eve in the garden; the first vocation and covenant setting.",
    titleKey: "journey.chapter.gardenOfEden.title",
    referenceKey: "journey.chapter.gardenOfEden.reference",
  },
  {
    id: "adam",
    book: "genesis",
    section: "Eden",
    displayName: "Adam",
    bibleReference: "Genesis 2:7–20",
    chronologicalOrder: 9,
    parentChapterId: null,
    unlockRequirement: "garden-of-eden",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "The first man formed from the dust; named steward of creation.",
  },
  {
    id: "eve",
    book: "genesis",
    section: "Eden",
    displayName: "Eve",
    bibleReference: "Genesis 2:18–25",
    chronologicalOrder: 10,
    parentChapterId: null,
    unlockRequirement: "adam",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "The first woman; companion and equal partner to Adam.",
  },
  {
    id: "the-fall",
    book: "genesis",
    section: "Eden",
    displayName: "The Fall",
    bibleReference: "Genesis 3",
    chronologicalOrder: 11,
    parentChapterId: null,
    unlockRequirement: "eve",
    status: "available",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Temptation, disobedience, curse, and expulsion from Eden.",
    titleKey: "journey.chapter.theFall.title",
    referenceKey: "journey.chapter.theFall.reference",
  },
  {
    id: "cain-and-abel",
    book: "genesis",
    section: "Early Humanity",
    displayName: "Cain and Abel",
    bibleReference: "Genesis 4:1–16",
    chronologicalOrder: 12,
    parentChapterId: null,
    unlockRequirement: "the-fall",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Offerings, jealousy, murder, and the mark of Cain.",
    titleKey: "journey.chapter.cainAndAbel.title",
    referenceKey: "journey.chapter.cainAndAbel.reference",
  },
  {
    id: "cain-genealogy",
    book: "genesis",
    section: "Early Humanity",
    displayName: "Genealogy of Cain",
    bibleReference: "Genesis 4:17–24",
    chronologicalOrder: 13,
    parentChapterId: null,
    unlockRequirement: "cain-and-abel",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Cain's line: cities, crafts, and Lamech's song of violence.",
  },
  {
    id: "seth-and-enos",
    book: "genesis",
    section: "Early Humanity",
    displayName: "Seth and Enosh",
    bibleReference: "Genesis 4:25–26",
    chronologicalOrder: 14,
    parentChapterId: null,
    unlockRequirement: "cain-genealogy",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Another line is raised; people begin to call on the name of the Lord.",
  },
  {
    id: "early-generations",
    book: "genesis",
    section: "Early Humanity",
    displayName: "The Early Generations",
    bibleReference: "Genesis 5",
    chronologicalOrder: 15,
    parentChapterId: null,
    unlockRequirement: "seth-and-enos",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Adam to Noah — the generations and long lives before the flood.",
    titleKey: "journey.chapter.earlyGenerations.title",
    referenceKey: "journey.chapter.earlyGenerations.reference",
  },
  {
    id: "genealogy-of-adam",
    book: "genesis",
    section: "Early Humanity",
    displayName: "Genealogy of Adam",
    bibleReference: "Genesis 5:1–32",
    chronologicalOrder: 16,
    parentChapterId: null,
    unlockRequirement: "early-generations",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Full Adamite genealogy through Seth to Noah.",
  },
  {
    id: "enoch",
    book: "genesis",
    section: "Early Humanity",
    displayName: "Enoch",
    bibleReference: "Genesis 5:21–24",
    chronologicalOrder: 17,
    parentChapterId: null,
    unlockRequirement: "genealogy-of-adam",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Teaching"],
    description: "Enoch walked with God and was taken — he did not see death.",
  },
  {
    id: "methuselah",
    book: "genesis",
    section: "Early Humanity",
    displayName: "Methuselah",
    bibleReference: "Genesis 5:25–27",
    chronologicalOrder: 18,
    parentChapterId: null,
    unlockRequirement: "enoch",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "The longest-lived patriarch in the biblical record.",
  },
  {
    id: "lamech-father-of-noah",
    book: "genesis",
    section: "Early Humanity",
    displayName: "Lamech, Father of Noah",
    bibleReference: "Genesis 5:28–31",
    chronologicalOrder: 19,
    parentChapterId: null,
    unlockRequirement: "methuselah",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Lamech names Noah and hopes for relief from cursed ground.",
  },
  {
    id: "noah",
    book: "genesis",
    section: "Flood",
    displayName: "Noah",
    bibleReference: "Genesis 6:1–9:29",
    chronologicalOrder: 20,
    parentChapterId: null,
    unlockRequirement: "lamech-father-of-noah",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Corruption fills the earth; Noah finds favor with God.",
    titleKey: "journey.chapter.noah.title",
    referenceKey: "journey.chapter.noah.reference",
  },
  {
    id: "sons-of-god-and-nephilim",
    book: "genesis",
    section: "Flood",
    displayName: "Sons of God and Nephilim",
    bibleReference: "Genesis 6:1–4",
    chronologicalOrder: 21,
    parentChapterId: null,
    unlockRequirement: "noah",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Mysterious unions and mighty ones of old before the flood.",
  },
  {
    id: "ark-construction",
    book: "genesis",
    section: "Flood",
    displayName: "Building the Ark",
    bibleReference: "Genesis 6:11–22",
    chronologicalOrder: 22,
    parentChapterId: null,
    unlockRequirement: "sons-of-god-and-nephilim",
    status: "comingSoon",
    estimatedGameplayType: ["Puzzle", "Journey"],
    description: "Noah builds the ark according to God's exact instructions.",
  },
  {
    id: "flood",
    book: "genesis",
    section: "Flood",
    displayName: "The Flood",
    bibleReference: "Genesis 7:1–8:19",
    chronologicalOrder: 23,
    parentChapterId: null,
    unlockRequirement: "ark-construction",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Judgment by water; the ark preserves life.",
  },
  {
    id: "noahic-covenant",
    book: "genesis",
    section: "Flood",
    displayName: "The Noahic Covenant",
    bibleReference: "Genesis 8:20–9:17",
    chronologicalOrder: 24,
    parentChapterId: null,
    unlockRequirement: "flood",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Altar, rainbow, and God's covenant with all living creatures.",
  },
  {
    id: "noahs-sons",
    book: "genesis",
    section: "Flood",
    displayName: "Noah's Sons",
    bibleReference: "Genesis 9:18–29",
    chronologicalOrder: 25,
    parentChapterId: null,
    unlockRequirement: "noahic-covenant",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Ham, Shem, and Japheth; the vineyard and Canaan's curse.",
  },
  {
    id: "table-of-nations",
    book: "genesis",
    section: "Flood",
    displayName: "Table of Nations",
    bibleReference: "Genesis 10",
    chronologicalOrder: 26,
    parentChapterId: null,
    unlockRequirement: "noahs-sons",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Genealogy", "Interactive Map"],
    description: "The nations descending from Noah's sons after the flood.",
  },
  {
    id: "tower-of-babel",
    book: "genesis",
    section: "Flood",
    displayName: "Tower of Babel",
    bibleReference: "Genesis 11:1–9",
    chronologicalOrder: 27,
    parentChapterId: null,
    unlockRequirement: "table-of-nations",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Puzzle"],
    description: "One language, one city, pride, and the scattering of peoples.",
    titleKey: "journey.chapter.towerOfBabel.title",
    referenceKey: "journey.chapter.towerOfBabel.reference",
  },
  {
    id: "genealogy-of-shem",
    book: "genesis",
    section: "Flood",
    displayName: "Genealogy of Shem",
    bibleReference: "Genesis 11:10–26",
    chronologicalOrder: 28,
    parentChapterId: null,
    unlockRequirement: "tower-of-babel",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Shem to Terah — the line that leads to Abraham.",
  },
  {
    id: "terah-and-haran",
    book: "genesis",
    section: "Flood",
    displayName: "Terah and Haran",
    bibleReference: "Genesis 11:27–32",
    chronologicalOrder: 29,
    parentChapterId: null,
    unlockRequirement: "genealogy-of-shem",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Terah's household leaves Ur; Haran becomes a waypoint.",
  },
  {
    id: "abraham",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Abraham",
    bibleReference: "Genesis 12–25",
    chronologicalOrder: 30,
    parentChapterId: null,
    unlockRequirement: "terah-and-haran",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Call, covenant, and pilgrimage of Abram/Abraham.",
    titleKey: "journey.chapter.abraham.title",
    referenceKey: "journey.chapter.abraham.reference",
  },
  {
    id: "call-of-abram",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Call of Abram",
    bibleReference: "Genesis 12:1–9",
    chronologicalOrder: 31,
    parentChapterId: null,
    unlockRequirement: "abraham",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Leave your country; I will make you a great nation.",
  },
  {
    id: "abram-in-egypt",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Abram in Egypt",
    bibleReference: "Genesis 12:10–20",
    chronologicalOrder: 32,
    parentChapterId: null,
    unlockRequirement: "call-of-abram",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Famine, deception about Sarai, and Pharaoh's rebuke.",
  },
  {
    id: "abram-and-lot-separate",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Abram and Lot Separate",
    bibleReference: "Genesis 13",
    chronologicalOrder: 33,
    parentChapterId: null,
    unlockRequirement: "abram-in-egypt",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Interactive Map"],
    description: "Land choice; Lot toward Sodom; Abram receives renewed promise.",
  },
  {
    id: "abram-rescues-lot",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Abram Rescues Lot",
    bibleReference: "Genesis 14",
    chronologicalOrder: 34,
    parentChapterId: null,
    unlockRequirement: "abram-and-lot-separate",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "War of the kings; Melchizedek blesses Abram.",
  },
  {
    id: "melchizedek",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Melchizedek",
    bibleReference: "Genesis 14:18–20",
    chronologicalOrder: 35,
    parentChapterId: null,
    unlockRequirement: "abram-rescues-lot",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Priest-king of Salem brings bread, wine, and blessing.",
  },
  {
    id: "covenant-of-the-pieces",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Covenant of the Pieces",
    bibleReference: "Genesis 15",
    chronologicalOrder: 36,
    parentChapterId: null,
    unlockRequirement: "melchizedek",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Teaching"],
    description: "Stars, land promise, and the smoking firepot covenant.",
  },
  {
    id: "hagar-and-ishmael",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Hagar and Ishmael",
    bibleReference: "Genesis 16",
    chronologicalOrder: 37,
    parentChapterId: null,
    unlockRequirement: "covenant-of-the-pieces",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Sarai's plan; Hagar flees; Ishmael is promised a great nation.",
  },
  {
    id: "abrahamic-covenant-circumcision",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Covenant of Circumcision",
    bibleReference: "Genesis 17",
    chronologicalOrder: 38,
    parentChapterId: null,
    unlockRequirement: "hagar-and-ishmael",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Name changes; everlasting covenant sealed by circumcision.",
  },
  {
    id: "three-visitors",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Three Visitors at Mamre",
    bibleReference: "Genesis 18:1–15",
    chronologicalOrder: 39,
    parentChapterId: null,
    unlockRequirement: "abrahamic-covenant-circumcision",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Hospitality and the promise of Isaac's birth.",
  },
  {
    id: "abraham-intercedes-for-sodom",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Abraham Intercedes for Sodom",
    bibleReference: "Genesis 18:16–33",
    chronologicalOrder: 40,
    parentChapterId: null,
    unlockRequirement: "three-visitors",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "Will you destroy the righteous with the wicked?",
  },
  {
    id: "sodom-and-gomorrah",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Sodom and Gomorrah",
    bibleReference: "Genesis 19",
    chronologicalOrder: 41,
    parentChapterId: null,
    unlockRequirement: "abraham-intercedes-for-sodom",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Angels rescue Lot; judgment falls on the cities of the plain.",
  },
  {
    id: "lot-and-his-daughters",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Lot and His Daughters",
    bibleReference: "Genesis 19:30–38",
    chronologicalOrder: 42,
    parentChapterId: null,
    unlockRequirement: "sodom-and-gomorrah",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Moab and Ammon arise from a tragic aftermath.",
  },
  {
    id: "abraham-and-abimelech",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Abraham and Abimelech",
    bibleReference: "Genesis 20",
    chronologicalOrder: 43,
    parentChapterId: null,
    unlockRequirement: "lot-and-his-daughters",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Another deception about Sarah; covenant at Gerar.",
  },
  {
    id: "birth-of-isaac",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Birth of Isaac",
    bibleReference: "Genesis 21:1–7",
    chronologicalOrder: 44,
    parentChapterId: null,
    unlockRequirement: "abraham-and-abimelech",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "The child of promise is born to Abraham and Sarah.",
  },
  {
    id: "hagar-sent-away",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Hagar and Ishmael Sent Away",
    bibleReference: "Genesis 21:8–21",
    chronologicalOrder: 45,
    parentChapterId: null,
    unlockRequirement: "birth-of-isaac",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Conflict at the feast; God hears the boy in the wilderness.",
  },
  {
    id: "treaty-at-beersheba",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Treaty at Beersheba",
    bibleReference: "Genesis 21:22–34",
    chronologicalOrder: 46,
    parentChapterId: null,
    unlockRequirement: "hagar-sent-away",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Abraham and Abimelech swear an oath; the well of the oath.",
  },
  {
    id: "binding-of-isaac",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "The Binding of Isaac (Akedah)",
    bibleReference: "Genesis 22",
    chronologicalOrder: 47,
    parentChapterId: null,
    unlockRequirement: "treaty-at-beersheba",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "God tests Abraham; the ram is provided on Moriah.",
  },
  {
    id: "sarahs-death-and-burial",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Sarah's Death and Burial",
    bibleReference: "Genesis 23",
    chronologicalOrder: 48,
    parentChapterId: null,
    unlockRequirement: "binding-of-isaac",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Machpelah purchased — first foothold in the promised land.",
  },
  {
    id: "isaac-and-rebekah",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Isaac and Rebekah",
    bibleReference: "Genesis 24",
    chronologicalOrder: 49,
    parentChapterId: null,
    unlockRequirement: "sarahs-death-and-burial",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Dialogue"],
    description: "A servant seeks a wife; Rebekah comes from Mesopotamia.",
  },
  {
    id: "abrahams-later-sons",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Abraham's Later Sons",
    bibleReference: "Genesis 25:1–6",
    chronologicalOrder: 50,
    parentChapterId: null,
    unlockRequirement: "isaac-and-rebekah",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Keturah's children and their eastern settlements.",
  },
  {
    id: "death-of-abraham",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Death of Abraham",
    bibleReference: "Genesis 25:7–11",
    chronologicalOrder: 51,
    parentChapterId: null,
    unlockRequirement: "abrahams-later-sons",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Abraham dies full of years; Isaac and Ishmael bury him.",
  },
  {
    id: "genealogy-of-ishmael",
    book: "genesis",
    section: "Patriarchs — Abraham",
    displayName: "Genealogy of Ishmael",
    bibleReference: "Genesis 25:12–18",
    chronologicalOrder: 52,
    parentChapterId: null,
    unlockRequirement: "death-of-abraham",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Twelve princes of Ishmael.",
  },
  {
    id: "isaac",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Isaac",
    bibleReference: "Genesis 21–28",
    chronologicalOrder: 53,
    parentChapterId: null,
    unlockRequirement: "genealogy-of-ishmael",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "The promised son walks the path of the covenant.",
    titleKey: "journey.chapter.isaac.title",
    referenceKey: "journey.chapter.isaac.reference",
  },
  {
    id: "jacob-and-esau-birth",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Birth of Jacob and Esau",
    bibleReference: "Genesis 25:19–28",
    chronologicalOrder: 54,
    parentChapterId: null,
    unlockRequirement: "isaac",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Twins struggle in the womb; nations begin to diverge.",
  },
  {
    id: "esau-sells-birthright",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Esau Sells His Birthright",
    bibleReference: "Genesis 25:29–34",
    chronologicalOrder: 55,
    parentChapterId: null,
    unlockRequirement: "jacob-and-esau-birth",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "A bowl of stew for a birthright.",
  },
  {
    id: "isaac-and-abimelech",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Isaac and Abimelech",
    bibleReference: "Genesis 26",
    chronologicalOrder: 56,
    parentChapterId: null,
    unlockRequirement: "esau-sells-birthright",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Dialogue"],
    description: "Wells, conflict, and the Lord appearing at Beersheba.",
  },
  {
    id: "stolen-blessing",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "The Stolen Blessing",
    bibleReference: "Genesis 27",
    chronologicalOrder: 57,
    parentChapterId: null,
    unlockRequirement: "isaac-and-abimelech",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Rebekah and Jacob deceive Isaac; Esau weeps for a blessing.",
  },
  {
    id: "jacob-flees-to-haran",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Jacob Flees to Haran",
    bibleReference: "Genesis 27:41–28:9",
    chronologicalOrder: 58,
    parentChapterId: null,
    unlockRequirement: "stolen-blessing",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Esau's rage drives Jacob toward Laban.",
  },
  {
    id: "jacobs-ladder",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Jacob's Ladder",
    bibleReference: "Genesis 28:10–22",
    chronologicalOrder: 59,
    parentChapterId: null,
    unlockRequirement: "jacob-flees-to-haran",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Interactive Vision"],
    description: "Bethel — heaven opened and the covenant restated.",
  },
  {
    id: "jacob",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Jacob",
    bibleReference: "Genesis 25–35",
    chronologicalOrder: 60,
    parentChapterId: null,
    unlockRequirement: "jacobs-ladder",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "The deceiver becomes Israel through wrestling and return.",
    titleKey: "journey.chapter.jacob.title",
    referenceKey: "journey.chapter.jacob.reference",
  },
  {
    id: "jacob-serves-laban",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Jacob Serves Laban",
    bibleReference: "Genesis 29–30",
    chronologicalOrder: 61,
    parentChapterId: null,
    unlockRequirement: "jacob",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Puzzle"],
    description: "Leah, Rachel, children, and wages of speckled flocks.",
  },
  {
    id: "twelve-sons-born",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Birth of the Twelve Sons",
    bibleReference: "Genesis 29:31–30:24",
    chronologicalOrder: 62,
    parentChapterId: null,
    unlockRequirement: "jacob-serves-laban",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "The tribal fathers of Israel are born in Paddan-aram.",
  },
  {
    id: "jacob-flees-laban",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Jacob Flees Laban",
    bibleReference: "Genesis 31",
    chronologicalOrder: 63,
    parentChapterId: null,
    unlockRequirement: "twelve-sons-born",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Decision"],
    description: "Household gods, pursuit, and a covenant heap at Mizpah.",
  },
  {
    id: "jacob-prepares-to-meet-esau",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Jacob Prepares to Meet Esau",
    bibleReference: "Genesis 32:1–21",
    chronologicalOrder: 64,
    parentChapterId: null,
    unlockRequirement: "jacob-flees-laban",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Journey"],
    description: "Gifts, camps, and fear before reunion.",
  },
  {
    id: "jacob-wrestles",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Jacob Wrestles with God",
    bibleReference: "Genesis 32:22–32",
    chronologicalOrder: 65,
    parentChapterId: null,
    unlockRequirement: "jacob-prepares-to-meet-esau",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Peniel — Jacob becomes Israel.",
  },
  {
    id: "jacob-esau-reunion",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Jacob and Esau Reunited",
    bibleReference: "Genesis 33",
    chronologicalOrder: 66,
    parentChapterId: null,
    unlockRequirement: "jacob-wrestles",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Brothers meet; Jacob settles near Shechem.",
  },
  {
    id: "dinah-and-shechem",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Dinah and Shechem",
    bibleReference: "Genesis 34",
    chronologicalOrder: 67,
    parentChapterId: null,
    unlockRequirement: "jacob-esau-reunion",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Violation, deceit, and Simeon and Levi's violence.",
  },
  {
    id: "return-to-bethel",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Return to Bethel",
    bibleReference: "Genesis 35:1–15",
    chronologicalOrder: 68,
    parentChapterId: null,
    unlockRequirement: "dinah-and-shechem",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Idols buried; God appears again as El Shaddai.",
  },
  {
    id: "deaths-of-rachel-and-isaac",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Deaths of Rachel and Isaac",
    bibleReference: "Genesis 35:16–29",
    chronologicalOrder: 69,
    parentChapterId: null,
    unlockRequirement: "return-to-bethel",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Benjamin born; Rachel dies; Isaac is buried by his sons.",
  },
  {
    id: "genealogy-of-esau",
    book: "genesis",
    section: "Patriarchs — Isaac & Jacob",
    displayName: "Genealogy of Esau (Edom)",
    bibleReference: "Genesis 36",
    chronologicalOrder: 70,
    parentChapterId: null,
    unlockRequirement: "deaths-of-rachel-and-isaac",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Chiefs and kings of Edom before any king ruled Israel.",
  },
  {
    id: "joseph",
    book: "genesis",
    section: "Joseph",
    displayName: "Joseph",
    bibleReference: "Genesis 37–50",
    chronologicalOrder: 71,
    parentChapterId: null,
    unlockRequirement: "genealogy-of-esau",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "From pit to palace — providence through betrayal and famine.",
    titleKey: "journey.chapter.joseph.title",
    referenceKey: "journey.chapter.joseph.reference",
  },
  {
    id: "joseph-sold",
    book: "genesis",
    section: "Joseph",
    displayName: "Joseph Sold into Slavery",
    bibleReference: "Genesis 37",
    chronologicalOrder: 72,
    parentChapterId: null,
    unlockRequirement: "joseph",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Dreams, coat, pit, and sale to Midianite traders.",
  },
  {
    id: "judah-and-tamar",
    book: "genesis",
    section: "Joseph",
    displayName: "Judah and Tamar",
    bibleReference: "Genesis 38",
    chronologicalOrder: 73,
    parentChapterId: null,
    unlockRequirement: "joseph-sold",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Levirate failure, deception, and Perez in the messianic line.",
  },
  {
    id: "joseph-in-potiphars-house",
    book: "genesis",
    section: "Joseph",
    displayName: "Joseph in Potiphar's House",
    bibleReference: "Genesis 39",
    chronologicalOrder: 74,
    parentChapterId: null,
    unlockRequirement: "judah-and-tamar",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Faithfulness, false accusation, and prison.",
  },
  {
    id: "joseph-interprets-dreams-prison",
    book: "genesis",
    section: "Joseph",
    displayName: "Dreams in Prison",
    bibleReference: "Genesis 40",
    chronologicalOrder: 75,
    parentChapterId: null,
    unlockRequirement: "joseph-in-potiphars-house",
    status: "comingSoon",
    estimatedGameplayType: "Puzzle",
    description: "Cupbearer and baker; Joseph interprets; forgotten.",
  },
  {
    id: "pharaohs-dreams",
    book: "genesis",
    section: "Joseph",
    displayName: "Pharaoh's Dreams",
    bibleReference: "Genesis 41",
    chronologicalOrder: 76,
    parentChapterId: null,
    unlockRequirement: "joseph-interprets-dreams-prison",
    status: "comingSoon",
    estimatedGameplayType: ["Puzzle", "Story"],
    description: "Seven years of plenty and famine; Joseph rises to power.",
  },
  {
    id: "josephs-brothers-in-egypt",
    book: "genesis",
    section: "Joseph",
    displayName: "Brothers Come to Egypt",
    bibleReference: "Genesis 42–43",
    chronologicalOrder: 77,
    parentChapterId: null,
    unlockRequirement: "pharaohs-dreams",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Decision"],
    description: "Grain, tests, and Benjamin brought down.",
  },
  {
    id: "joseph-revealed",
    book: "genesis",
    section: "Joseph",
    displayName: "Joseph Revealed",
    bibleReference: "Genesis 44–45",
    chronologicalOrder: 78,
    parentChapterId: null,
    unlockRequirement: "josephs-brothers-in-egypt",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Judah's plea; Joseph weeps and reveals himself.",
  },
  {
    id: "jacob-to-egypt",
    book: "genesis",
    section: "Joseph",
    displayName: "Jacob Goes to Down to Egypt",
    bibleReference: "Genesis 46",
    chronologicalOrder: 79,
    parentChapterId: null,
    unlockRequirement: "joseph-revealed",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Interactive Genealogy"],
    description: "Seventy persons; visions at Beersheba; reunion.",
  },
  {
    id: "settlement-in-goshen",
    book: "genesis",
    section: "Joseph",
    displayName: "Settlement in Goshen",
    bibleReference: "Genesis 47",
    chronologicalOrder: 80,
    parentChapterId: null,
    unlockRequirement: "jacob-to-egypt",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Joseph administers famine policy; Jacob blesses Pharaoh.",
  },
  {
    id: "jacob-blesses-ephraim-manasseh",
    book: "genesis",
    section: "Joseph",
    displayName: "Jacob Blesses Ephraim and Manasseh",
    bibleReference: "Genesis 48",
    chronologicalOrder: 81,
    parentChapterId: null,
    unlockRequirement: "settlement-in-goshen",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "The younger preferred; adoption into Israel.",
  },
  {
    id: "jacob-blesses-twelve-tribes",
    book: "genesis",
    section: "Joseph",
    displayName: "Jacob Blesses the Twelve Tribes",
    bibleReference: "Genesis 49",
    chronologicalOrder: 82,
    parentChapterId: null,
    unlockRequirement: "jacob-blesses-ephraim-manasseh",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Teaching"],
    description: "Tribal destinies spoken over the sons of Israel.",
  },
  {
    id: "deaths-of-jacob-and-joseph",
    book: "genesis",
    section: "Joseph",
    displayName: "Deaths of Jacob and Joseph",
    bibleReference: "Genesis 49:29–50:26",
    chronologicalOrder: 83,
    parentChapterId: null,
    unlockRequirement: "jacob-blesses-twelve-tribes",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Burial in Canaan; Joseph's bones await the exodus.",
  },
  {
    id: "israel-in-egypt",
    book: "exodus",
    section: "Israel in Egypt",
    displayName: "Israel in Egypt",
    bibleReference: "Exodus 1",
    chronologicalOrder: 84,
    parentChapterId: null,
    unlockRequirement: "deaths-of-jacob-and-joseph",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "A new Pharaoh oppresses the growing nation.",
  },
  {
    id: "birth-of-moses",
    book: "exodus",
    section: "Israel in Egypt",
    displayName: "Birth of Moses",
    bibleReference: "Exodus 2:1–10",
    chronologicalOrder: 85,
    parentChapterId: null,
    unlockRequirement: "israel-in-egypt",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Hidden among reeds; drawn out by Pharaoh's daughter.",
  },
  {
    id: "moses-flees-to-midian",
    book: "exodus",
    section: "Israel in Egypt",
    displayName: "Moses Flees to Midian",
    bibleReference: "Exodus 2:11–25",
    chronologicalOrder: 86,
    parentChapterId: null,
    unlockRequirement: "birth-of-moses",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Murder, flight, Zipporah, and God hearing Israel's cry.",
  },
  {
    id: "burning-bush",
    book: "exodus",
    section: "Israel in Egypt",
    displayName: "The Burning Bush",
    bibleReference: "Exodus 3:1–4:17",
    chronologicalOrder: 87,
    parentChapterId: null,
    unlockRequirement: "moses-flees-to-midian",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Dialogue"],
    description: "I AM WHO I AM — Moses is commissioned.",
  },
  {
    id: "moses-returns-to-egypt",
    book: "exodus",
    section: "Israel in Egypt",
    displayName: "Moses Returns to Egypt",
    bibleReference: "Exodus 4:18–31",
    chronologicalOrder: 88,
    parentChapterId: null,
    unlockRequirement: "burning-bush",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Signs, Zipporah, and Aaron joins the mission.",
  },
  {
    id: "first-confrontation-pharaoh",
    book: "exodus",
    section: "Israel in Egypt",
    displayName: "First Confrontation with Pharaoh",
    bibleReference: "Exodus 5–6",
    chronologicalOrder: 89,
    parentChapterId: null,
    unlockRequirement: "moses-returns-to-egypt",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Story"],
    description: "Bricks without straw; God renews the covenant name.",
  },
  {
    id: "genealogy-of-moses-and-aaron",
    book: "exodus",
    section: "Israel in Egypt",
    displayName: "Genealogy of Moses and Aaron",
    bibleReference: "Exodus 6:14–27",
    chronologicalOrder: 90,
    parentChapterId: null,
    unlockRequirement: "first-confrontation-pharaoh",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Levi's line that produces Israel's deliverers.",
  },
  {
    id: "ten-plagues",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "The Ten Plagues",
    bibleReference: "Exodus 7–11",
    chronologicalOrder: 91,
    parentChapterId: null,
    unlockRequirement: "genealogy-of-moses-and-aaron",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Judgment on Egypt's gods through escalating plagues.",
  },
  {
    id: "plague-blood",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague of Blood",
    bibleReference: "Exodus 7:14–25",
    chronologicalOrder: 92,
    parentChapterId: null,
    unlockRequirement: "ten-plagues",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Nile turns to blood.",
  },
  {
    id: "plague-frogs",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague of Frogs",
    bibleReference: "Exodus 8:1–15",
    chronologicalOrder: 93,
    parentChapterId: null,
    unlockRequirement: "plague-blood",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Frogs cover the land.",
  },
  {
    id: "plague-gnats",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague of Gnats",
    bibleReference: "Exodus 8:16–19",
    chronologicalOrder: 94,
    parentChapterId: null,
    unlockRequirement: "plague-frogs",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Dust becomes gnats; magicians fail.",
  },
  {
    id: "plague-flies",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague of Flies",
    bibleReference: "Exodus 8:20–32",
    chronologicalOrder: 95,
    parentChapterId: null,
    unlockRequirement: "plague-gnats",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Swarms; Goshen is spared.",
  },
  {
    id: "plague-livestock",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague on Livestock",
    bibleReference: "Exodus 9:1–7",
    chronologicalOrder: 96,
    parentChapterId: null,
    unlockRequirement: "plague-flies",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Egyptian livestock dies.",
  },
  {
    id: "plague-boils",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague of Boils",
    bibleReference: "Exodus 9:8–12",
    chronologicalOrder: 97,
    parentChapterId: null,
    unlockRequirement: "plague-livestock",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Soot becomes boils on man and beast.",
  },
  {
    id: "plague-hail",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague of Hail",
    bibleReference: "Exodus 9:13–35",
    chronologicalOrder: 98,
    parentChapterId: null,
    unlockRequirement: "plague-boils",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Fire and hail devastate Egypt.",
  },
  {
    id: "plague-locusts",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague of Locusts",
    bibleReference: "Exodus 10:1–20",
    chronologicalOrder: 99,
    parentChapterId: null,
    unlockRequirement: "plague-hail",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Locusts devour what hail left.",
  },
  {
    id: "plague-darkness",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Plague of Darkness",
    bibleReference: "Exodus 10:21–29",
    chronologicalOrder: 100,
    parentChapterId: null,
    unlockRequirement: "plague-locusts",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Darkness that can be felt for three days.",
  },
  {
    id: "plague-firstborn",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Death of the Firstborn",
    bibleReference: "Exodus 11:1–12:30",
    chronologicalOrder: 101,
    parentChapterId: null,
    unlockRequirement: "plague-darkness",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "The final plague breaks Pharaoh's will.",
  },
  {
    id: "passover",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Passover",
    bibleReference: "Exodus 12:1–28",
    chronologicalOrder: 102,
    parentChapterId: null,
    unlockRequirement: "plague-firstborn",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Lamb, blood on the doorposts, and a perpetual memorial.",
  },
  {
    id: "exodus-from-egypt",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "The Exodus from Egypt",
    bibleReference: "Exodus 12:31–42",
    chronologicalOrder: 103,
    parentChapterId: null,
    unlockRequirement: "passover",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Israel departs in haste with the spoils of Egypt.",
  },
  {
    id: "consecration-of-firstborn",
    book: "exodus",
    section: "Plagues and Passover",
    displayName: "Consecration of the Firstborn",
    bibleReference: "Exodus 13:1–16",
    chronologicalOrder: 104,
    parentChapterId: null,
    unlockRequirement: "exodus-from-egypt",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Remember the strong hand that brought you out.",
  },
  {
    id: "pillar-of-cloud-and-fire",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Pillar of Cloud and Fire",
    bibleReference: "Exodus 13:17–22",
    chronologicalOrder: 105,
    parentChapterId: null,
    unlockRequirement: "consecration-of-firstborn",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "God leads Israel by cloud and fire.",
  },
  {
    id: "red-sea",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Crossing the Red Sea",
    bibleReference: "Exodus 14",
    chronologicalOrder: 106,
    parentChapterId: null,
    unlockRequirement: "pillar-of-cloud-and-fire",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Waters part; Egypt's army is overthrown.",
  },
  {
    id: "song-of-moses-and-miriam",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Song of Moses and Miriam",
    bibleReference: "Exodus 15:1–21",
    chronologicalOrder: 107,
    parentChapterId: null,
    unlockRequirement: "red-sea",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Israel sings the first victory hymn.",
  },
  {
    id: "waters-of-marah",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Waters of Marah",
    bibleReference: "Exodus 15:22–27",
    chronologicalOrder: 108,
    parentChapterId: null,
    unlockRequirement: "song-of-moses-and-miriam",
    status: "comingSoon",
    estimatedGameplayType: "Puzzle",
    description: "Bitter water made sweet; a statute of testing.",
  },
  {
    id: "manna-and-quail",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Manna and Quail",
    bibleReference: "Exodus 16",
    chronologicalOrder: 109,
    parentChapterId: null,
    unlockRequirement: "waters-of-marah",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Teaching"],
    description: "Bread from heaven; Sabbath provision taught.",
  },
  {
    id: "water-from-the-rock-rephidim",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Water from the Rock at Rephidim",
    bibleReference: "Exodus 17:1–7",
    chronologicalOrder: 110,
    parentChapterId: null,
    unlockRequirement: "manna-and-quail",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Massah and Meribah — is the Lord among us?",
  },
  {
    id: "amalek-defeated",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Amalek Defeated",
    bibleReference: "Exodus 17:8–16",
    chronologicalOrder: 111,
    parentChapterId: null,
    unlockRequirement: "water-from-the-rock-rephidim",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "Joshua fights; Moses' hands are held up.",
  },
  {
    id: "jethro-advises-moses",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Jethro Advises Moses",
    bibleReference: "Exodus 18",
    chronologicalOrder: 112,
    parentChapterId: null,
    unlockRequirement: "amalek-defeated",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Teaching"],
    description: "Shared judgeship — wisdom for governing a nation.",
  },
  {
    id: "arrival-at-sinai",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Arrival at Sinai",
    bibleReference: "Exodus 19",
    chronologicalOrder: 113,
    parentChapterId: null,
    unlockRequirement: "jethro-advises-moses",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Teaching"],
    description: "A kingdom of priests; the mountain trembles.",
  },
  {
    id: "ten-commandments",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "The Ten Commandments",
    bibleReference: "Exodus 20:1–21",
    chronologicalOrder: 114,
    parentChapterId: null,
    unlockRequirement: "arrival-at-sinai",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "The Decalogue spoken by God.",
  },
  {
    id: "book-of-the-covenant",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Book of the Covenant",
    bibleReference: "Exodus 20:22–23:33",
    chronologicalOrder: 115,
    parentChapterId: null,
    unlockRequirement: "ten-commandments",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Case laws of justice, worship, and social life.",
  },
  {
    id: "covenant-ratified",
    book: "exodus",
    section: "Wilderness to Sinai",
    displayName: "Covenant Ratified",
    bibleReference: "Exodus 24",
    chronologicalOrder: 116,
    parentChapterId: null,
    unlockRequirement: "book-of-the-covenant",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Story"],
    description: "Blood of the covenant; elders see God; Moses ascends.",
  },
  {
    id: "tabernacle-instructions",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "Tabernacle Instructions",
    bibleReference: "Exodus 25–27",
    chronologicalOrder: 117,
    parentChapterId: null,
    unlockRequirement: "covenant-ratified",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Tabernacle",
    description: "Ark, table, lampstand, curtains, and altar — heaven's pattern.",
  },
  {
    id: "priesthood-instructions",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "Priesthood Instructions",
    bibleReference: "Exodus 28–29",
    chronologicalOrder: 118,
    parentChapterId: null,
    unlockRequirement: "tabernacle-instructions",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Temple", "Teaching"],
    description: "Garments and consecration of Aaron and his sons.",
  },
  {
    id: "tabernacle-furniture-continued",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "Altar of Incense and Census Tax",
    bibleReference: "Exodus 30–31",
    chronologicalOrder: 119,
    parentChapterId: null,
    unlockRequirement: "priesthood-instructions",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Tabernacle",
    description: "Incense, basin, anointing oil, and craftsmen Bezalel and Oholiab.",
  },
  {
    id: "golden-calf",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "The Golden Calf",
    bibleReference: "Exodus 32",
    chronologicalOrder: 120,
    parentChapterId: null,
    unlockRequirement: "tabernacle-furniture-continued",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Idol at the foot of the mountain; Moses intercedes.",
  },
  {
    id: "moses-intercession",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "Moses' Intercession",
    bibleReference: "Exodus 33",
    chronologicalOrder: 121,
    parentChapterId: null,
    unlockRequirement: "golden-calf",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Teaching"],
    description: "Show me your glory — the cleft of the rock.",
  },
  {
    id: "new-stone-tablets",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "New Stone Tablets",
    bibleReference: "Exodus 34",
    chronologicalOrder: 122,
    parentChapterId: null,
    unlockRequirement: "moses-intercession",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Story"],
    description: "The Lord proclaims His name; covenant renewed.",
  },
  {
    id: "sabbath-and-contributions",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "Sabbath and Contributions",
    bibleReference: "Exodus 35:1–29",
    chronologicalOrder: 123,
    parentChapterId: null,
    unlockRequirement: "new-stone-tablets",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Willing hearts bring offerings for the sanctuary.",
  },
  {
    id: "construction-of-the-tabernacle",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "Construction of the Tabernacle",
    bibleReference: "Exodus 35:30–40:33",
    chronologicalOrder: 124,
    parentChapterId: null,
    unlockRequirement: "sabbath-and-contributions",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Tabernacle",
    description: "The dwelling is built exactly as the Lord commanded.",
  },
  {
    id: "glory-fills-the-tabernacle",
    book: "exodus",
    section: "Tabernacle & Apostasy",
    displayName: "Glory Fills the Tabernacle",
    bibleReference: "Exodus 40:34–38",
    chronologicalOrder: 125,
    parentChapterId: null,
    unlockRequirement: "construction-of-the-tabernacle",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Cloud and fire rest on the completed sanctuary.",
  },
  {
    id: "burnt-offering",
    book: "leviticus",
    section: "Offerings",
    displayName: "Burnt Offering",
    bibleReference: "Leviticus 1",
    chronologicalOrder: 126,
    parentChapterId: null,
    unlockRequirement: "glory-fills-the-tabernacle",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Whole burnt offering — complete dedication to God.",
  },
  {
    id: "grain-offering",
    book: "leviticus",
    section: "Offerings",
    displayName: "Grain Offering",
    bibleReference: "Leviticus 2",
    chronologicalOrder: 127,
    parentChapterId: null,
    unlockRequirement: "burnt-offering",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Fine flour, oil, and frankincense without leaven.",
  },
  {
    id: "peace-offering",
    book: "leviticus",
    section: "Offerings",
    displayName: "Peace Offering",
    bibleReference: "Leviticus 3",
    chronologicalOrder: 128,
    parentChapterId: null,
    unlockRequirement: "grain-offering",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Fellowship sacrifice shared before the Lord.",
  },
  {
    id: "sin-offering",
    book: "leviticus",
    section: "Offerings",
    displayName: "Sin Offering",
    bibleReference: "Leviticus 4:1–5:13",
    chronologicalOrder: 129,
    parentChapterId: null,
    unlockRequirement: "peace-offering",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Atonement for unintentional sin.",
  },
  {
    id: "guilt-offering",
    book: "leviticus",
    section: "Offerings",
    displayName: "Guilt Offering",
    bibleReference: "Leviticus 5:14–6:7",
    chronologicalOrder: 130,
    parentChapterId: null,
    unlockRequirement: "sin-offering",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Restitution plus sacrifice for trespass.",
  },
  {
    id: "priestly-portions",
    book: "leviticus",
    section: "Offerings",
    displayName: "Priestly Portions and Procedures",
    bibleReference: "Leviticus 6:8–7:38",
    chronologicalOrder: 131,
    parentChapterId: null,
    unlockRequirement: "guilt-offering",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "How priests handle each offering type.",
  },
  {
    id: "ordination-of-aaron",
    book: "leviticus",
    section: "Priests",
    displayName: "Ordination of Aaron and His Sons",
    bibleReference: "Leviticus 8",
    chronologicalOrder: 132,
    parentChapterId: null,
    unlockRequirement: "priestly-portions",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Temple", "Cutscene"],
    description: "Seven-day consecration of the priesthood.",
  },
  {
    id: "priests-begin-ministry",
    book: "leviticus",
    section: "Priests",
    displayName: "Priests Begin Ministry",
    bibleReference: "Leviticus 9",
    chronologicalOrder: 133,
    parentChapterId: null,
    unlockRequirement: "ordination-of-aaron",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "First public offerings; fire from the Lord.",
  },
  {
    id: "nadab-and-abihu",
    book: "leviticus",
    section: "Priests",
    displayName: "Nadab and Abihu",
    bibleReference: "Leviticus 10",
    chronologicalOrder: 134,
    parentChapterId: null,
    unlockRequirement: "priests-begin-ministry",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Unauthorized fire; holiness of the sanctuary.",
  },
  {
    id: "clean-and-unclean-animals",
    book: "leviticus",
    section: "Purity Laws",
    displayName: "Clean and Unclean Animals",
    bibleReference: "Leviticus 11",
    chronologicalOrder: 135,
    parentChapterId: null,
    unlockRequirement: "nadab-and-abihu",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Dietary holiness distinctions.",
  },
  {
    id: "purification-after-childbirth",
    book: "leviticus",
    section: "Purity Laws",
    displayName: "Purification after Childbirth",
    bibleReference: "Leviticus 12",
    chronologicalOrder: 136,
    parentChapterId: null,
    unlockRequirement: "clean-and-unclean-animals",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Rites of purification for mothers.",
  },
  {
    id: "laws-of-leprosy",
    book: "leviticus",
    section: "Purity Laws",
    displayName: "Laws of Skin Disease (Leprosy)",
    bibleReference: "Leviticus 13–14",
    chronologicalOrder: 137,
    parentChapterId: null,
    unlockRequirement: "purification-after-childbirth",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Diagnosis, isolation, and cleansing rites.",
  },
  {
    id: "bodily-discharges",
    book: "leviticus",
    section: "Purity Laws",
    displayName: "Bodily Discharges",
    bibleReference: "Leviticus 15",
    chronologicalOrder: 138,
    parentChapterId: null,
    unlockRequirement: "laws-of-leprosy",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Ritual purity related to bodily flows.",
  },
  {
    id: "day-of-atonement",
    book: "leviticus",
    section: "Day of Atonement & Holiness",
    displayName: "Day of Atonement (Yom Kippur)",
    bibleReference: "Leviticus 16",
    chronologicalOrder: 139,
    parentChapterId: null,
    unlockRequirement: "bodily-discharges",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Temple", "Teaching"],
    description: "Scapegoat and blood that cleanses the Most Holy Place.",
  },
  {
    id: "blood-and-central-sanctuary",
    book: "leviticus",
    section: "Day of Atonement & Holiness",
    displayName: "Blood and the Central Sanctuary",
    bibleReference: "Leviticus 17",
    chronologicalOrder: 140,
    parentChapterId: null,
    unlockRequirement: "day-of-atonement",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Life is in the blood; sacrifice only at the tent.",
  },
  {
    id: "sexual-holiness-laws",
    book: "leviticus",
    section: "Day of Atonement & Holiness",
    displayName: "Sexual Holiness Laws",
    bibleReference: "Leviticus 18",
    chronologicalOrder: 141,
    parentChapterId: null,
    unlockRequirement: "blood-and-central-sanctuary",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Boundaries that set Israel apart from the nations.",
  },
  {
    id: "holiness-code",
    book: "leviticus",
    section: "Day of Atonement & Holiness",
    displayName: "Holiness Code",
    bibleReference: "Leviticus 19–20",
    chronologicalOrder: 142,
    parentChapterId: null,
    unlockRequirement: "sexual-holiness-laws",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Law", "Teaching"],
    description: "Be holy, for I the Lord your God am holy.",
  },
  {
    id: "priestly-holiness",
    book: "leviticus",
    section: "Day of Atonement & Holiness",
    displayName: "Priestly Holiness Standards",
    bibleReference: "Leviticus 21–22",
    chronologicalOrder: 143,
    parentChapterId: null,
    unlockRequirement: "holiness-code",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Temple",
    description: "Higher standards for those who approach the altar.",
  },
  {
    id: "appointed-feasts",
    book: "leviticus",
    section: "Feasts & Covenant",
    displayName: "Appointed Feasts of the Lord",
    bibleReference: "Leviticus 23",
    chronologicalOrder: 144,
    parentChapterId: null,
    unlockRequirement: "priestly-holiness",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Timeline", "Teaching"],
    description: "Sabbath, Passover, Weeks, Trumpets, Atonement, Booths.",
  },
  {
    id: "lamp-and-showbread",
    book: "leviticus",
    section: "Feasts & Covenant",
    displayName: "Lamp and Showbread",
    bibleReference: "Leviticus 24:1–9",
    chronologicalOrder: 145,
    parentChapterId: null,
    unlockRequirement: "appointed-feasts",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Tabernacle",
    description: "Continual light and bread of the Presence.",
  },
  {
    id: "blasphemer-judged",
    book: "leviticus",
    section: "Feasts & Covenant",
    displayName: "The Blasphemer Judged",
    bibleReference: "Leviticus 24:10–23",
    chronologicalOrder: 146,
    parentChapterId: null,
    unlockRequirement: "lamp-and-showbread",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Lex talionis applied in the camp.",
  },
  {
    id: "sabbath-year-and-jubilee",
    book: "leviticus",
    section: "Feasts & Covenant",
    displayName: "Sabbath Year and Jubilee",
    bibleReference: "Leviticus 25",
    chronologicalOrder: 147,
    parentChapterId: null,
    unlockRequirement: "blasphemer-judged",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Law", "Teaching"],
    description: "Rest for the land; liberty proclaimed.",
  },
  {
    id: "blessings-and-curses-leviticus",
    book: "leviticus",
    section: "Feasts & Covenant",
    displayName: "Blessings and Curses",
    bibleReference: "Leviticus 26",
    chronologicalOrder: 148,
    parentChapterId: null,
    unlockRequirement: "sabbath-year-and-jubilee",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Teaching"],
    description: "Covenant consequences — obedience and exile foreshadowed.",
  },
  {
    id: "vows-and-valuations",
    book: "leviticus",
    section: "Feasts & Covenant",
    displayName: "Vows and Valuations",
    bibleReference: "Leviticus 27",
    chronologicalOrder: 149,
    parentChapterId: null,
    unlockRequirement: "blessings-and-curses-leviticus",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Redeeming persons, animals, and dedicated property.",
  },
  {
    id: "first-census",
    book: "numbers",
    section: "Census & Camp",
    displayName: "The First Census",
    bibleReference: "Numbers 1",
    chronologicalOrder: 150,
    parentChapterId: null,
    unlockRequirement: "vows-and-valuations",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Warriors counted by tribe.",
  },
  {
    id: "camp-arrangement",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Arrangement of the Camp",
    bibleReference: "Numbers 2",
    chronologicalOrder: 151,
    parentChapterId: null,
    unlockRequirement: "first-census",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Tribes encamped around the tabernacle.",
  },
  {
    id: "levites-set-apart",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Levites Set Apart",
    bibleReference: "Numbers 3–4",
    chronologicalOrder: 152,
    parentChapterId: null,
    unlockRequirement: "camp-arrangement",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Temple", "Teaching"],
    description: "Clans of Levi and their sacred duties.",
  },
  {
    id: "purity-of-the-camp",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Purity of the Camp",
    bibleReference: "Numbers 5",
    chronologicalOrder: 153,
    parentChapterId: null,
    unlockRequirement: "levites-set-apart",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Defilement, restitution, and the jealousy ordeal.",
  },
  {
    id: "nazirite-vow",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Nazirite Vow",
    bibleReference: "Numbers 6:1–21",
    chronologicalOrder: 154,
    parentChapterId: null,
    unlockRequirement: "purity-of-the-camp",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Special consecration of hair, drink, and contact.",
  },
  {
    id: "aaronic-blessing",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Aaronic Blessing",
    bibleReference: "Numbers 6:22–27",
    chronologicalOrder: 155,
    parentChapterId: null,
    unlockRequirement: "nazirite-vow",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "The Lord bless you and keep you.",
  },
  {
    id: "offerings-of-the-leaders",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Offerings of the Tribal Leaders",
    bibleReference: "Numbers 7",
    chronologicalOrder: 156,
    parentChapterId: null,
    unlockRequirement: "aaronic-blessing",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Twelve identical dedication offerings.",
  },
  {
    id: "lampstand-and-levite-cleansing",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Lampstand and Levite Cleansing",
    bibleReference: "Numbers 8",
    chronologicalOrder: 157,
    parentChapterId: null,
    unlockRequirement: "offerings-of-the-leaders",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Tabernacle",
    description: "Levites presented as a wave offering.",
  },
  {
    id: "second-passover",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Second Passover",
    bibleReference: "Numbers 9:1–14",
    chronologicalOrder: 158,
    parentChapterId: null,
    unlockRequirement: "lampstand-and-levite-cleansing",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Passover for the unclean and the traveler.",
  },
  {
    id: "cloud-guidance",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Cloud Guidance",
    bibleReference: "Numbers 9:15–23",
    chronologicalOrder: 159,
    parentChapterId: null,
    unlockRequirement: "second-passover",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Israel moves only when the cloud lifts.",
  },
  {
    id: "silver-trumpets",
    book: "numbers",
    section: "Census & Camp",
    displayName: "Silver Trumpets",
    bibleReference: "Numbers 10:1–10",
    chronologicalOrder: 160,
    parentChapterId: null,
    unlockRequirement: "cloud-guidance",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Signals for assembly, journey, and war.",
  },
  {
    id: "departure-from-sinai",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Departure from Sinai",
    bibleReference: "Numbers 10:11–36",
    chronologicalOrder: 161,
    parentChapterId: null,
    unlockRequirement: "silver-trumpets",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "The ark goes before; Rise up, O Lord.",
  },
  {
    id: "fire-and-quail-complaint",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Fire and Quail Complaint",
    bibleReference: "Numbers 11",
    chronologicalOrder: 162,
    parentChapterId: null,
    unlockRequirement: "departure-from-sinai",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Craving meat; seventy elders; graves of craving.",
  },
  {
    id: "miriam-and-aaron-oppose-moses",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Miriam and Aaron Oppose Moses",
    bibleReference: "Numbers 12",
    chronologicalOrder: 163,
    parentChapterId: null,
    unlockRequirement: "fire-and-quail-complaint",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Sibling rivalry; Miriam's leprosy; Moses' meekness.",
  },
  {
    id: "spies-sent-to-canaan",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Spies Sent to Canaan",
    bibleReference: "Numbers 13",
    chronologicalOrder: 164,
    parentChapterId: null,
    unlockRequirement: "miriam-and-aaron-oppose-moses",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Interactive Map"],
    description: "Twelve spies; giants and grapes.",
  },
  {
    id: "israel-refuses-the-land",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Israel Refuses the Land",
    bibleReference: "Numbers 14",
    chronologicalOrder: 165,
    parentChapterId: null,
    unlockRequirement: "spies-sent-to-canaan",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Rebellion; forty years appointed; failed invasion.",
  },
  {
    id: "supplemental-offerings-laws",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Supplemental Offering Laws",
    bibleReference: "Numbers 15",
    chronologicalOrder: 166,
    parentChapterId: null,
    unlockRequirement: "israel-refuses-the-land",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Offerings in the land; tassels for remembrance.",
  },
  {
    id: "korahs-rebellion",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Korah's Rebellion",
    bibleReference: "Numbers 16",
    chronologicalOrder: 167,
    parentChapterId: null,
    unlockRequirement: "supplemental-offerings-laws",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "Levite revolt; earth opens; censers become covering.",
  },
  {
    id: "aarons-rod",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Aaron's Rod Buds",
    bibleReference: "Numbers 17",
    chronologicalOrder: 168,
    parentChapterId: null,
    unlockRequirement: "korahs-rebellion",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Chosen priesthood confirmed overnight.",
  },
  {
    id: "duties-and-tithes-of-priests",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Duties and Tithes of Priests",
    bibleReference: "Numbers 18",
    chronologicalOrder: 169,
    parentChapterId: null,
    unlockRequirement: "aarons-rod",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Provision for those who serve the tent.",
  },
  {
    id: "red-heifer",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "The Red Heifer",
    bibleReference: "Numbers 19",
    chronologicalOrder: 170,
    parentChapterId: null,
    unlockRequirement: "duties-and-tithes-of-priests",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Water of purification from corpse uncleanness.",
  },
  {
    id: "waters-of-meribah",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Waters of Meribah",
    bibleReference: "Numbers 20:1–13",
    chronologicalOrder: 171,
    parentChapterId: null,
    unlockRequirement: "red-heifer",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Moses strikes the rock; barred from the land.",
  },
  {
    id: "edom-refuses-passage",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Edom Refuses Passage",
    bibleReference: "Numbers 20:14–21",
    chronologicalOrder: 172,
    parentChapterId: null,
    unlockRequirement: "waters-of-meribah",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Israel turns away from a closed road.",
  },
  {
    id: "death-of-aaron",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Death of Aaron",
    bibleReference: "Numbers 20:22–29",
    chronologicalOrder: 173,
    parentChapterId: null,
    unlockRequirement: "edom-refuses-passage",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Priestly succession on Mount Hor.",
  },
  {
    id: "bronze-serpent",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "The Bronze Serpent",
    bibleReference: "Numbers 21:4–9",
    chronologicalOrder: 174,
    parentChapterId: null,
    unlockRequirement: "death-of-aaron",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Teaching"],
    description: "Look and live — judgment and mercy in the wilderness.",
  },
  {
    id: "victories-over-sihon-og",
    book: "numbers",
    section: "Wilderness Journey",
    displayName: "Victories over Sihon and Og",
    bibleReference: "Numbers 21:10–35",
    chronologicalOrder: 175,
    parentChapterId: null,
    unlockRequirement: "bronze-serpent",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Interactive Map"],
    description: "Transjordan kingdoms fall to Israel.",
  },
  {
    id: "balak-and-balaam",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Balak and Balaam",
    bibleReference: "Numbers 22–24",
    chronologicalOrder: 176,
    parentChapterId: null,
    unlockRequirement: "victories-over-sihon-og",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Prophecy"],
    description: "A hired prophet blesses Israel against his will.",
  },
  {
    id: "balaams-donkey",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Balaam's Donkey",
    bibleReference: "Numbers 22:21–35",
    chronologicalOrder: 177,
    parentChapterId: null,
    unlockRequirement: "balak-and-balaam",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "A donkey sees the angel; a prophet is rebuked.",
  },
  {
    id: "balaams-oracles",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Balaam's Oracles",
    bibleReference: "Numbers 23–24",
    chronologicalOrder: 178,
    parentChapterId: null,
    unlockRequirement: "balaams-donkey",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Star out of Jacob; nations judged.",
  },
  {
    id: "baal-peor",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Baal of Peor",
    bibleReference: "Numbers 25",
    chronologicalOrder: 179,
    parentChapterId: null,
    unlockRequirement: "balaams-oracles",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Idolatry and immorality; Phinehas' zeal.",
  },
  {
    id: "second-census",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "The Second Census",
    bibleReference: "Numbers 26",
    chronologicalOrder: 180,
    parentChapterId: null,
    unlockRequirement: "baal-peor",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "A new generation counted for inheritance.",
  },
  {
    id: "daughters-of-zelophehad",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Daughters of Zelophehad",
    bibleReference: "Numbers 27:1–11",
    chronologicalOrder: 181,
    parentChapterId: null,
    unlockRequirement: "second-census",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Interactive Law"],
    description: "Inheritance rights for daughters without brothers.",
  },
  {
    id: "joshua-commissioned",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Joshua Commissioned",
    bibleReference: "Numbers 27:12–23",
    chronologicalOrder: 182,
    parentChapterId: null,
    unlockRequirement: "daughters-of-zelophehad",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Moses' successor receives authority before the people.",
  },
  {
    id: "calendar-of-offerings",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Calendar of Offerings",
    bibleReference: "Numbers 28–29",
    chronologicalOrder: 183,
    parentChapterId: null,
    unlockRequirement: "joshua-commissioned",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Daily, Sabbath, new moon, and festival sacrifices.",
  },
  {
    id: "vows-of-women",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Vows of Women",
    bibleReference: "Numbers 30",
    chronologicalOrder: 184,
    parentChapterId: null,
    unlockRequirement: "calendar-of-offerings",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Authority and responsibility in household vows.",
  },
  {
    id: "war-with-midian",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "War with Midian",
    bibleReference: "Numbers 31",
    chronologicalOrder: 185,
    parentChapterId: null,
    unlockRequirement: "vows-of-women",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "Judgment on Midian; spoils divided.",
  },
  {
    id: "transjordan-settlement",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Transjordan Settlement",
    bibleReference: "Numbers 32",
    chronologicalOrder: 186,
    parentChapterId: null,
    unlockRequirement: "war-with-midian",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Interactive Map"],
    description: "Reuben, Gad, and half-Manasseh settle east of Jordan.",
  },
  {
    id: "wilderness-itinerary",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Wilderness Itinerary",
    bibleReference: "Numbers 33",
    chronologicalOrder: 187,
    parentChapterId: null,
    unlockRequirement: "transjordan-settlement",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Map", "Interactive Timeline"],
    description: "Stages from Egypt to the plains of Moab.",
  },
  {
    id: "boundaries-of-canaan",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Boundaries of Canaan",
    bibleReference: "Numbers 34",
    chronologicalOrder: 188,
    parentChapterId: null,
    unlockRequirement: "wilderness-itinerary",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Borders of the promised inheritance.",
  },
  {
    id: "levitical-cities-and-refuge",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Levitical Cities and Cities of Refuge",
    bibleReference: "Numbers 35",
    chronologicalOrder: 189,
    parentChapterId: null,
    unlockRequirement: "boundaries-of-canaan",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Map", "Interactive Law"],
    description: "Asylum for manslayers; bloodguilt rules.",
  },
  {
    id: "marriage-within-tribe",
    book: "numbers",
    section: "Balaam & Final Preparation",
    displayName: "Marriage within the Tribe",
    bibleReference: "Numbers 36",
    chronologicalOrder: 190,
    parentChapterId: null,
    unlockRequirement: "levitical-cities-and-refuge",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Protecting tribal allotments through marriage rules.",
  },
  {
    id: "moses-final-addresses",
    book: "deuteronomy",
    section: "Covenant Sermons",
    displayName: "Moses' Final Addresses",
    bibleReference: "Deuteronomy 1–3",
    chronologicalOrder: 191,
    parentChapterId: null,
    unlockRequirement: "marriage-within-tribe",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Timeline"],
    description: "Retelling the journey from Horeb to the plains of Moab.",
  },
  {
    id: "call-to-obedience",
    book: "deuteronomy",
    section: "Covenant Sermons",
    displayName: "Call to Obedience",
    bibleReference: "Deuteronomy 4",
    chronologicalOrder: 192,
    parentChapterId: null,
    unlockRequirement: "moses-final-addresses",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Listen to the statutes; the Lord is God in heaven above.",
  },
  {
    id: "deuteronomy-ten-commandments",
    book: "deuteronomy",
    section: "Covenant Sermons",
    displayName: "Ten Commandments Restated",
    bibleReference: "Deuteronomy 5",
    chronologicalOrder: 193,
    parentChapterId: null,
    unlockRequirement: "call-to-obedience",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Horeb covenant rehearsed for a new generation.",
  },
  {
    id: "shema",
    book: "deuteronomy",
    section: "Covenant Sermons",
    displayName: "The Shema",
    bibleReference: "Deuteronomy 6",
    chronologicalOrder: 194,
    parentChapterId: null,
    unlockRequirement: "deuteronomy-ten-commandments",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Hear, O Israel — love the Lord with all your heart.",
  },
  {
    id: "holy-war-instructions",
    book: "deuteronomy",
    section: "Covenant Sermons",
    displayName: "Holy War Instructions",
    bibleReference: "Deuteronomy 7",
    chronologicalOrder: 195,
    parentChapterId: null,
    unlockRequirement: "shema",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Separation from Canaanite nations and idols.",
  },
  {
    id: "remember-the-wilderness",
    book: "deuteronomy",
    section: "Covenant Sermons",
    displayName: "Remember the Wilderness",
    bibleReference: "Deuteronomy 8",
    chronologicalOrder: 196,
    parentChapterId: null,
    unlockRequirement: "holy-war-instructions",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Man does not live by bread alone.",
  },
  {
    id: "not-for-your-righteousness",
    book: "deuteronomy",
    section: "Covenant Sermons",
    displayName: "Not for Your Righteousness",
    bibleReference: "Deuteronomy 9–10",
    chronologicalOrder: 197,
    parentChapterId: null,
    unlockRequirement: "remember-the-wilderness",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Golden calf remembered; circumcise your heart.",
  },
  {
    id: "blessing-and-curse-choice",
    book: "deuteronomy",
    section: "Covenant Sermons",
    displayName: "Blessing and Curse Choice",
    bibleReference: "Deuteronomy 11",
    chronologicalOrder: 198,
    parentChapterId: null,
    unlockRequirement: "not-for-your-righteousness",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Teaching"],
    description: "Obedience tied to the land's rain and fruitfulness.",
  },
  {
    id: "central-sanctuary-law",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Central Sanctuary Law",
    bibleReference: "Deuteronomy 12",
    chronologicalOrder: 199,
    parentChapterId: null,
    unlockRequirement: "blessing-and-curse-choice",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Worship at the place the Lord chooses.",
  },
  {
    id: "false-prophets-and-idolatry",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "False Prophets and Idolatry",
    bibleReference: "Deuteronomy 13",
    chronologicalOrder: 200,
    parentChapterId: null,
    unlockRequirement: "central-sanctuary-law",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Tests of loyalty when signs accompany deception.",
  },
  {
    id: "clean-foods-and-tithes",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Clean Foods and Tithes",
    bibleReference: "Deuteronomy 14",
    chronologicalOrder: 201,
    parentChapterId: null,
    unlockRequirement: "false-prophets-and-idolatry",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Dietary holiness and triennial charity tithe.",
  },
  {
    id: "sabbath-year-debts",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Sabbath Year and Debts",
    bibleReference: "Deuteronomy 15",
    chronologicalOrder: 202,
    parentChapterId: null,
    unlockRequirement: "clean-foods-and-tithes",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Release, generosity, and Hebrew servants.",
  },
  {
    id: "pilgrim-feasts-deuteronomy",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Pilgrim Feasts",
    bibleReference: "Deuteronomy 16:1–17",
    chronologicalOrder: 203,
    parentChapterId: null,
    unlockRequirement: "sabbath-year-debts",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Passover, Weeks, and Booths at the central place.",
  },
  {
    id: "judges-and-kings",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Judges and Kings",
    bibleReference: "Deuteronomy 16:18–17:20",
    chronologicalOrder: 204,
    parentChapterId: null,
    unlockRequirement: "pilgrim-feasts-deuteronomy",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Justice, witnesses, and the law of the king.",
  },
  {
    id: "levitical-priests-and-prophets",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Priests and the Prophet Like Moses",
    bibleReference: "Deuteronomy 18",
    chronologicalOrder: 205,
    parentChapterId: null,
    unlockRequirement: "judges-and-kings",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Law", "Interactive Prophecy"],
    description: "Priestly portion; a prophet like Moses promised.",
  },
  {
    id: "cities-of-refuge-deuteronomy",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Cities of Refuge",
    bibleReference: "Deuteronomy 19",
    chronologicalOrder: 206,
    parentChapterId: null,
    unlockRequirement: "levitical-priests-and-prophets",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Manslaughter, landmarks, and false witnesses.",
  },
  {
    id: "laws-of-warfare",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Laws of Warfare",
    bibleReference: "Deuteronomy 20",
    chronologicalOrder: 207,
    parentChapterId: null,
    unlockRequirement: "cities-of-refuge-deuteronomy",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Exemptions, terms of peace, and herem cities.",
  },
  {
    id: "unsolved-murder-and-family-laws",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Unsolved Murder and Family Laws",
    bibleReference: "Deuteronomy 21",
    chronologicalOrder: 208,
    parentChapterId: null,
    unlockRequirement: "laws-of-warfare",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Heifer rite, captive wives, inheritance, rebellious son.",
  },
  {
    id: "miscellaneous-holiness-laws",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Miscellaneous Holiness Laws",
    bibleReference: "Deuteronomy 22–23",
    chronologicalOrder: 209,
    parentChapterId: null,
    unlockRequirement: "unsolved-murder-and-family-laws",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Neighbor care, purity in camp, and assembly rules.",
  },
  {
    id: "marriage-and-commerce-laws",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Marriage and Commerce Laws",
    bibleReference: "Deuteronomy 24–25",
    chronologicalOrder: 210,
    parentChapterId: null,
    unlockRequirement: "miscellaneous-holiness-laws",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Law",
    description: "Divorce certificate, gleaning, levirate, honest weights.",
  },
  {
    id: "firstfruits-and-tithes-confession",
    book: "deuteronomy",
    section: "Law Code",
    displayName: "Firstfruits and Tithe Confession",
    bibleReference: "Deuteronomy 26",
    chronologicalOrder: 211,
    parentChapterId: null,
    unlockRequirement: "marriage-and-commerce-laws",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "A wandering Aramean was my father — liturgy of gratitude.",
  },
  {
    id: "shechem-ceremony-commands",
    book: "deuteronomy",
    section: "Covenant Renewal",
    displayName: "Shechem Ceremony Commands",
    bibleReference: "Deuteronomy 27",
    chronologicalOrder: 212,
    parentChapterId: null,
    unlockRequirement: "firstfruits-and-tithes-confession",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Blessings on Gerizim; curses on Ebal.",
  },
  {
    id: "blessings-and-curses-deuteronomy",
    book: "deuteronomy",
    section: "Covenant Renewal",
    displayName: "Blessings and Curses",
    bibleReference: "Deuteronomy 28",
    chronologicalOrder: 213,
    parentChapterId: null,
    unlockRequirement: "shechem-ceremony-commands",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Teaching"],
    description: "Covenant sanctions culminating in exile.",
  },
  {
    id: "covenant-in-moab",
    book: "deuteronomy",
    section: "Covenant Renewal",
    displayName: "Covenant in Moab",
    bibleReference: "Deuteronomy 29–30",
    chronologicalOrder: 214,
    parentChapterId: null,
    unlockRequirement: "blessings-and-curses-deuteronomy",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Teaching"],
    description: "Choose life — the word is near you.",
  },
  {
    id: "joshua-succeeds-moses",
    book: "deuteronomy",
    section: "Covenant Renewal",
    displayName: "Joshua Succeeds Moses",
    bibleReference: "Deuteronomy 31",
    chronologicalOrder: 215,
    parentChapterId: null,
    unlockRequirement: "covenant-in-moab",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Law written; song commissioned; Joshua charged.",
  },
  {
    id: "song-of-moses",
    book: "deuteronomy",
    section: "Covenant Renewal",
    displayName: "Song of Moses",
    bibleReference: "Deuteronomy 32",
    chronologicalOrder: 216,
    parentChapterId: null,
    unlockRequirement: "joshua-succeeds-moses",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Prophecy"],
    description: "Witness song against Israel's future unfaithfulness.",
  },
  {
    id: "moses-final-blessing",
    book: "deuteronomy",
    section: "Covenant Renewal",
    displayName: "Moses' Final Blessing",
    bibleReference: "Deuteronomy 33",
    chronologicalOrder: 217,
    parentChapterId: null,
    unlockRequirement: "song-of-moses",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Tribal blessings from the man of God.",
  },
  {
    id: "death-of-moses",
    book: "deuteronomy",
    section: "Covenant Renewal",
    displayName: "Death of Moses",
    bibleReference: "Deuteronomy 34",
    chronologicalOrder: 218,
    parentChapterId: null,
    unlockRequirement: "moses-final-blessing",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Pisgah view; burial by the Lord; no prophet like Moses.",
  },
  {
    id: "joshua-commissioned-as-leader",
    book: "joshua",
    section: "Conquest",
    displayName: "Joshua Commissioned",
    bibleReference: "Joshua 1",
    chronologicalOrder: 219,
    parentChapterId: null,
    unlockRequirement: "death-of-moses",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Be strong and courageous — cross this Jordan.",
  },
  {
    id: "rahabs-faith",
    book: "joshua",
    section: "Conquest",
    displayName: "Rahab's Faith",
    bibleReference: "Joshua 2",
    chronologicalOrder: 220,
    parentChapterId: null,
    unlockRequirement: "joshua-commissioned-as-leader",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Spies hidden; scarlet cord; a Canaanite joins Israel.",
  },
  {
    id: "crossing-the-jordan",
    book: "joshua",
    section: "Conquest",
    displayName: "Crossing the Jordan",
    bibleReference: "Joshua 3–4",
    chronologicalOrder: 221,
    parentChapterId: null,
    unlockRequirement: "rahabs-faith",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Cutscene"],
    description: "Ark in the river; twelve memorial stones.",
  },
  {
    id: "circumcision-at-gilgal",
    book: "joshua",
    section: "Conquest",
    displayName: "Circumcision at Gilgal",
    bibleReference: "Joshua 5:1–12",
    chronologicalOrder: 222,
    parentChapterId: null,
    unlockRequirement: "crossing-the-jordan",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Reproach of Egypt rolled away; Passover in the land.",
  },
  {
    id: "commander-of-the-lords-army",
    book: "joshua",
    section: "Conquest",
    displayName: "Commander of the Lord's Army",
    bibleReference: "Joshua 5:13–15",
    chronologicalOrder: 223,
    parentChapterId: null,
    unlockRequirement: "circumcision-at-gilgal",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Holy ground before Jericho.",
  },
  {
    id: "fall-of-jericho",
    book: "joshua",
    section: "Conquest",
    displayName: "Fall of Jericho",
    bibleReference: "Joshua 6",
    chronologicalOrder: 224,
    parentChapterId: null,
    unlockRequirement: "commander-of-the-lords-army",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Puzzle"],
    description: "Seven days of marching; walls collapse.",
  },
  {
    id: "achen-sin",
    book: "joshua",
    section: "Conquest",
    displayName: "Achan's Sin",
    bibleReference: "Joshua 7",
    chronologicalOrder: 225,
    parentChapterId: null,
    unlockRequirement: "fall-of-jericho",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Banned goods; defeat at Ai; judgment in the valley.",
  },
  {
    id: "conquest-of-ai",
    book: "joshua",
    section: "Conquest",
    displayName: "Conquest of Ai",
    bibleReference: "Joshua 8",
    chronologicalOrder: 226,
    parentChapterId: null,
    unlockRequirement: "achen-sin",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "Ambush succeeds; altar on Ebal; law read.",
  },
  {
    id: "gibeonite-deception",
    book: "joshua",
    section: "Conquest",
    displayName: "Gibeonite Deception",
    bibleReference: "Joshua 9",
    chronologicalOrder: 227,
    parentChapterId: null,
    unlockRequirement: "conquest-of-ai",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "Treaty by ruse; woodcutters for the sanctuary.",
  },
  {
    id: "sun-stands-still",
    book: "joshua",
    section: "Conquest",
    displayName: "Sun Stands Still",
    bibleReference: "Joshua 10",
    chronologicalOrder: 228,
    parentChapterId: null,
    unlockRequirement: "gibeonite-deception",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "Southern coalition defeated; long day of battle.",
  },
  {
    id: "northern-campaign",
    book: "joshua",
    section: "Conquest",
    displayName: "Northern Campaign",
    bibleReference: "Joshua 11",
    chronologicalOrder: 229,
    parentChapterId: null,
    unlockRequirement: "sun-stands-still",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Interactive Map"],
    description: "Hazor burned; the land rests from war.",
  },
  {
    id: "list-of-defeated-kings",
    book: "joshua",
    section: "Conquest",
    displayName: "List of Defeated Kings",
    bibleReference: "Joshua 12",
    chronologicalOrder: 230,
    parentChapterId: null,
    unlockRequirement: "northern-campaign",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Catalogue of conquests east and west of Jordan.",
  },
  {
    id: "land-still-to-possess",
    book: "joshua",
    section: "Allotment",
    displayName: "Land Still to Possess",
    bibleReference: "Joshua 13",
    chronologicalOrder: 231,
    parentChapterId: null,
    unlockRequirement: "list-of-defeated-kings",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Remaining territories; Transjordan allotments reviewed.",
  },
  {
    id: "calebs-inheritance",
    book: "joshua",
    section: "Allotment",
    displayName: "Caleb's Inheritance",
    bibleReference: "Joshua 14",
    chronologicalOrder: 232,
    parentChapterId: null,
    unlockRequirement: "land-still-to-possess",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Give me this mountain — Hebron for the faithful spy.",
  },
  {
    id: "allotment-of-judah",
    book: "joshua",
    section: "Allotment",
    displayName: "Allotment of Judah",
    bibleReference: "Joshua 15",
    chronologicalOrder: 233,
    parentChapterId: null,
    unlockRequirement: "calebs-inheritance",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Borders and cities of Judah.",
  },
  {
    id: "allotment-of-ephraim-manasseh",
    book: "joshua",
    section: "Allotment",
    displayName: "Allotment of Ephraim and Manasseh",
    bibleReference: "Joshua 16–17",
    chronologicalOrder: 234,
    parentChapterId: null,
    unlockRequirement: "allotment-of-judah",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Joseph's tribes and Zelophehad's daughters again.",
  },
  {
    id: "remaining-tribal-allotments",
    book: "joshua",
    section: "Allotment",
    displayName: "Remaining Tribal Allotments",
    bibleReference: "Joshua 18–19",
    chronologicalOrder: 235,
    parentChapterId: null,
    unlockRequirement: "allotment-of-ephraim-manasseh",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Shiloh survey; Benjamin through Naphtali; Joshua's city.",
  },
  {
    id: "cities-of-refuge-joshua",
    book: "joshua",
    section: "Allotment",
    displayName: "Cities of Refuge Established",
    bibleReference: "Joshua 20",
    chronologicalOrder: 236,
    parentChapterId: null,
    unlockRequirement: "remaining-tribal-allotments",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Asylum cities named in the land.",
  },
  {
    id: "levitical-cities-joshua",
    book: "joshua",
    section: "Allotment",
    displayName: "Levitical Cities Assigned",
    bibleReference: "Joshua 21",
    chronologicalOrder: 237,
    parentChapterId: null,
    unlockRequirement: "cities-of-refuge-joshua",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Forty-eight cities for Levi among the tribes.",
  },
  {
    id: "altar-of-witness",
    book: "joshua",
    section: "Allotment",
    displayName: "Altar of Witness",
    bibleReference: "Joshua 22",
    chronologicalOrder: 238,
    parentChapterId: null,
    unlockRequirement: "levitical-cities-joshua",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "Transjordan altar nearly sparks civil war.",
  },
  {
    id: "joshuas-farewell",
    book: "joshua",
    section: "Allotment",
    displayName: "Joshua's Farewell",
    bibleReference: "Joshua 23",
    chronologicalOrder: 239,
    parentChapterId: null,
    unlockRequirement: "altar-of-witness",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Cling to the Lord; do not mix with remaining nations.",
  },
  {
    id: "covenant-at-shechem",
    book: "joshua",
    section: "Allotment",
    displayName: "Covenant at Shechem",
    bibleReference: "Joshua 24",
    chronologicalOrder: 240,
    parentChapterId: null,
    unlockRequirement: "joshuas-farewell",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Teaching"],
    description: "Choose this day whom you will serve.",
  },
  {
    id: "incomplete-conquest",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Incomplete Conquest",
    bibleReference: "Judges 1",
    chronologicalOrder: 241,
    parentChapterId: null,
    unlockRequirement: "covenant-at-shechem",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Tribes fail to drive out remaining peoples.",
  },
  {
    id: "israel-forsakes-the-lord",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Israel Forsakes the Lord",
    bibleReference: "Judges 2",
    chronologicalOrder: 242,
    parentChapterId: null,
    unlockRequirement: "incomplete-conquest",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Timeline"],
    description: "The judges cycle: sin, oppression, cry, deliverance.",
  },
  {
    id: "othniel",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Othniel",
    bibleReference: "Judges 3:1–11",
    chronologicalOrder: 243,
    parentChapterId: null,
    unlockRequirement: "israel-forsakes-the-lord",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "First judge delivers from Cushan-rishathaim.",
  },
  {
    id: "ehud",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Ehud",
    bibleReference: "Judges 3:12–30",
    chronologicalOrder: 244,
    parentChapterId: null,
    unlockRequirement: "othniel",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Left-handed deliverer and the Moabite king.",
  },
  {
    id: "shamgar",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Shamgar",
    bibleReference: "Judges 3:31",
    chronologicalOrder: 245,
    parentChapterId: null,
    unlockRequirement: "ehud",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "Six hundred Philistines with an oxgoad.",
  },
  {
    id: "deborah-and-barak",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Deborah and Barak",
    bibleReference: "Judges 4",
    chronologicalOrder: 246,
    parentChapterId: null,
    unlockRequirement: "shamgar",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Prophetess, reluctant general, and Jael's tent peg.",
  },
  {
    id: "song-of-deborah",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Song of Deborah",
    bibleReference: "Judges 5",
    chronologicalOrder: 247,
    parentChapterId: null,
    unlockRequirement: "deborah-and-barak",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Victory hymn naming tribes and the stars in their courses.",
  },
  {
    id: "gideon-called",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Gideon Called",
    bibleReference: "Judges 6",
    chronologicalOrder: 248,
    parentChapterId: null,
    unlockRequirement: "song-of-deborah",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Threshing in a winepress; fleece; altar of Baal torn down.",
  },
  {
    id: "gideons-three-hundred",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Gideon's Three Hundred",
    bibleReference: "Judges 7",
    chronologicalOrder: 249,
    parentChapterId: null,
    unlockRequirement: "gideon-called",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Puzzle"],
    description: "Lapping water; trumpets, jars, and torches.",
  },
  {
    id: "gideon-aftermath",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Gideon Aftermath",
    bibleReference: "Judges 8",
    chronologicalOrder: 250,
    parentChapterId: null,
    unlockRequirement: "gideons-three-hundred",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Ephraim's quarrel; Midian's end; ephod snare.",
  },
  {
    id: "abimelech",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Abimelech",
    bibleReference: "Judges 9",
    chronologicalOrder: 251,
    parentChapterId: null,
    unlockRequirement: "gideon-aftermath",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Murderous king of Shechem; Jotham's parable; millstone.",
  },
  {
    id: "tola-and-jair",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Tola and Jair",
    bibleReference: "Judges 10:1–5",
    chronologicalOrder: 252,
    parentChapterId: null,
    unlockRequirement: "abimelech",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Minor judges who judged Israel between crises.",
  },
  {
    id: "jephthah",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Jephthah",
    bibleReference: "Judges 10:6–12:7",
    chronologicalOrder: 253,
    parentChapterId: null,
    unlockRequirement: "tola-and-jair",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Outcast deliverer; rash vow; conflict with Ephraim.",
  },
  {
    id: "ibzan-elon-abdon",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Ibzan, Elon, and Abdon",
    bibleReference: "Judges 12:8–15",
    chronologicalOrder: 254,
    parentChapterId: null,
    unlockRequirement: "jephthah",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Three minor judges and their households.",
  },
  {
    id: "samson-birth",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Birth of Samson",
    bibleReference: "Judges 13",
    chronologicalOrder: 255,
    parentChapterId: null,
    unlockRequirement: "ibzan-elon-abdon",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Nazirite from the womb announced by the angel.",
  },
  {
    id: "samson-riddles-and-revenge",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Samson's Riddles and Revenge",
    bibleReference: "Judges 14–15",
    chronologicalOrder: 256,
    parentChapterId: null,
    unlockRequirement: "samson-birth",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Philistine marriage, foxes, and jawbone of a donkey.",
  },
  {
    id: "samson-and-delilah",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Samson and Delilah",
    bibleReference: "Judges 16",
    chronologicalOrder: 257,
    parentChapterId: null,
    unlockRequirement: "samson-riddles-and-revenge",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Betrayal, captivity, and final victory in death.",
  },
  {
    id: "micahs-idol",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "Micah's Idol",
    bibleReference: "Judges 17–18",
    chronologicalOrder: 258,
    parentChapterId: null,
    unlockRequirement: "samson-and-delilah",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Private shrine; Danite migration and stolen priesthood.",
  },
  {
    id: "levites-concubine",
    book: "judges",
    section: "Cycles of the Judges",
    displayName: "The Levite's Concubine",
    bibleReference: "Judges 19–21",
    chronologicalOrder: 259,
    parentChapterId: null,
    unlockRequirement: "micahs-idol",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Gibeah's crime; civil war; near extinction of Benjamin.",
  },
  {
    id: "ruth-and-naomi",
    book: "ruth",
    section: "Redemption",
    displayName: "Ruth and Naomi",
    bibleReference: "Ruth 1",
    chronologicalOrder: 260,
    parentChapterId: null,
    unlockRequirement: "levites-concubine",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Famine, widowhood, and where you go I will go.",
  },
  {
    id: "ruth-gleans",
    book: "ruth",
    section: "Redemption",
    displayName: "Ruth Gleans in Boaz's Field",
    bibleReference: "Ruth 2",
    chronologicalOrder: 261,
    parentChapterId: null,
    unlockRequirement: "ruth-and-naomi",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Kindness under Yahweh's wings.",
  },
  {
    id: "threshing-floor",
    book: "ruth",
    section: "Redemption",
    displayName: "At the Threshing Floor",
    bibleReference: "Ruth 3",
    chronologicalOrder: 262,
    parentChapterId: null,
    unlockRequirement: "ruth-gleans",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "Midnight appeal for a kinsman-redeemer.",
  },
  {
    id: "boaz-redeems",
    book: "ruth",
    section: "Redemption",
    displayName: "Boaz Redeems Ruth",
    bibleReference: "Ruth 4",
    chronologicalOrder: 263,
    parentChapterId: null,
    unlockRequirement: "threshing-floor",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Genealogy"],
    description: "Legal redemption; Obed; genealogy to David.",
  },
  {
    id: "hannahs-prayer",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Hannah's Prayer",
    bibleReference: "1 Samuel 1–2:11",
    chronologicalOrder: 264,
    parentChapterId: null,
    unlockRequirement: "boaz-redeems",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Barrenness, vow, and the song of exaltation.",
  },
  {
    id: "corruption-of-elis-sons",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Corruption of Eli's Sons",
    bibleReference: "1 Samuel 2:12–36",
    chronologicalOrder: 265,
    parentChapterId: null,
    unlockRequirement: "hannahs-prayer",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Worthless priests; a faithful priest promised.",
  },
  {
    id: "lord-calls-samuel",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "The Lord Calls Samuel",
    bibleReference: "1 Samuel 3",
    chronologicalOrder: 266,
    parentChapterId: null,
    unlockRequirement: "corruption-of-elis-sons",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Speak, for your servant hears.",
  },
  {
    id: "ark-captured",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Ark Captured",
    bibleReference: "1 Samuel 4",
    chronologicalOrder: 267,
    parentChapterId: null,
    unlockRequirement: "lord-calls-samuel",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Ichabod — the glory has departed.",
  },
  {
    id: "ark-among-philistines",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Ark among the Philistines",
    bibleReference: "1 Samuel 5–6",
    chronologicalOrder: 268,
    parentChapterId: null,
    unlockRequirement: "ark-captured",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Dagon falls; golden tumors; return to Israel.",
  },
  {
    id: "samuel-judges-israel",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Samuel Judges Israel",
    bibleReference: "1 Samuel 7",
    chronologicalOrder: 269,
    parentChapterId: null,
    unlockRequirement: "ark-among-philistines",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Ebenezer — thus far the Lord has helped us.",
  },
  {
    id: "israel-demands-a-king",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Israel Demands a King",
    bibleReference: "1 Samuel 8",
    chronologicalOrder: 270,
    parentChapterId: null,
    unlockRequirement: "samuel-judges-israel",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Teaching"],
    description: "Rejecting the Lord's kingship for a human monarch.",
  },
  {
    id: "saul-anointed",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Saul Anointed",
    bibleReference: "1 Samuel 9–10",
    chronologicalOrder: 271,
    parentChapterId: null,
    unlockRequirement: "israel-demands-a-king",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Cutscene"],
    description: "Donkeys, a private anointing, and public selection.",
  },
  {
    id: "saul-delivers-jabesh",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Saul Delivers Jabesh-gilead",
    bibleReference: "1 Samuel 11",
    chronologicalOrder: 272,
    parentChapterId: null,
    unlockRequirement: "saul-anointed",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "First royal victory unites Israel.",
  },
  {
    id: "samuels-farewell-address",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Samuel's Farewell Address",
    bibleReference: "1 Samuel 12",
    chronologicalOrder: 273,
    parentChapterId: null,
    unlockRequirement: "saul-delivers-jabesh",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Witness against Israel; thunder in wheat harvest.",
  },
  {
    id: "sauls-unlawful-sacrifice",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Saul's Unlawful Sacrifice",
    bibleReference: "1 Samuel 13",
    chronologicalOrder: 274,
    parentChapterId: null,
    unlockRequirement: "samuels-farewell-address",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Impatience costs Saul a lasting dynasty.",
  },
  {
    id: "jonathan-attack",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Jonathan's Bold Attack",
    bibleReference: "1 Samuel 14",
    chronologicalOrder: 275,
    parentChapterId: null,
    unlockRequirement: "sauls-unlawful-sacrifice",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "Honey, lots, and near death of the prince.",
  },
  {
    id: "saul-rejected",
    book: "1-samuel",
    section: "Samuel and Saul",
    displayName: "Saul Rejected",
    bibleReference: "1 Samuel 15",
    chronologicalOrder: 276,
    parentChapterId: null,
    unlockRequirement: "jonathan-attack",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Amalek spared; to obey is better than sacrifice.",
  },
  {
    id: "david-anointed",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David Anointed",
    bibleReference: "1 Samuel 16",
    chronologicalOrder: 277,
    parentChapterId: null,
    unlockRequirement: "saul-rejected",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Cutscene"],
    description: "Man looks on the outward appearance; God looks on the heart.",
  },
  {
    id: "david-and-goliath",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David and Goliath",
    bibleReference: "1 Samuel 17",
    chronologicalOrder: 278,
    parentChapterId: null,
    unlockRequirement: "david-anointed",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "The battle is the Lord's.",
  },
  {
    id: "david-and-jonathan",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David and Jonathan",
    bibleReference: "1 Samuel 18:1–5",
    chronologicalOrder: 279,
    parentChapterId: null,
    unlockRequirement: "david-and-goliath",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Covenant friendship sealed in love.",
  },
  {
    id: "saul-envies-david",
    book: "1-samuel",
    section: "David Rising",
    displayName: "Saul Envies David",
    bibleReference: "1 Samuel 18:6–30",
    chronologicalOrder: 280,
    parentChapterId: null,
    unlockRequirement: "david-and-jonathan",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Spears thrown; bride-price of Philistine foreskins.",
  },
  {
    id: "david-flees-saul",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David Flees Saul",
    bibleReference: "1 Samuel 19–20",
    chronologicalOrder: 281,
    parentChapterId: null,
    unlockRequirement: "saul-envies-david",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Dialogue"],
    description: "Michal's ruse; Jonathan's arrows signal danger.",
  },
  {
    id: "david-at-nob-and-gath",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David at Nob and Gath",
    bibleReference: "1 Samuel 21",
    chronologicalOrder: 282,
    parentChapterId: null,
    unlockRequirement: "david-flees-saul",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Decision"],
    description: "Holy bread; feigned madness before Achish.",
  },
  {
    id: "david-gathers-outcasts",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David Gathers Outcasts",
    bibleReference: "1 Samuel 22",
    chronologicalOrder: 283,
    parentChapterId: null,
    unlockRequirement: "david-at-nob-and-gath",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Cave of Adullam; Doeg slaughters the priests.",
  },
  {
    id: "david-saves-keilah",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David Saves Keilah",
    bibleReference: "1 Samuel 23",
    chronologicalOrder: 284,
    parentChapterId: null,
    unlockRequirement: "david-gathers-outcasts",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Journey"],
    description: "Inquiry of the Lord; wilderness chase continues.",
  },
  {
    id: "david-spares-saul-cave",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David Spares Saul in the Cave",
    bibleReference: "1 Samuel 24",
    chronologicalOrder: 285,
    parentChapterId: null,
    unlockRequirement: "david-saves-keilah",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Corner of the robe; conscience and kingship ethics.",
  },
  {
    id: "nabal-and-abigail",
    book: "1-samuel",
    section: "David Rising",
    displayName: "Nabal and Abigail",
    bibleReference: "1 Samuel 25",
    chronologicalOrder: 286,
    parentChapterId: null,
    unlockRequirement: "david-spares-saul-cave",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Folly, wise intercession, and a new wife.",
  },
  {
    id: "david-spares-saul-again",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David Spares Saul Again",
    bibleReference: "1 Samuel 26",
    chronologicalOrder: 287,
    parentChapterId: null,
    unlockRequirement: "nabal-and-abigail",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Spear and jug taken; the Lord's anointed untouched.",
  },
  {
    id: "david-among-philistines",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David among the Philistines",
    bibleReference: "1 Samuel 27–28:2",
    chronologicalOrder: 288,
    parentChapterId: null,
    unlockRequirement: "david-spares-saul-again",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Decision"],
    description: "Ziklag refuge; precarious double life.",
  },
  {
    id: "saul-and-the-medium",
    book: "1-samuel",
    section: "David Rising",
    displayName: "Saul and the Medium of En-dor",
    bibleReference: "1 Samuel 28",
    chronologicalOrder: 289,
    parentChapterId: null,
    unlockRequirement: "david-among-philistines",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Forbidden consultation; Samuel's final word of doom.",
  },
  {
    id: "david-dismissed-from-battle",
    book: "1-samuel",
    section: "David Rising",
    displayName: "David Dismissed from Philistine Battle",
    bibleReference: "1 Samuel 29",
    chronologicalOrder: 290,
    parentChapterId: null,
    unlockRequirement: "saul-and-the-medium",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Lords of the Philistines refuse David's presence.",
  },
  {
    id: "ziklag-raided",
    book: "1-samuel",
    section: "David Rising",
    displayName: "Ziklag Raided",
    bibleReference: "1 Samuel 30",
    chronologicalOrder: 291,
    parentChapterId: null,
    unlockRequirement: "david-dismissed-from-battle",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Journey"],
    description: "Amalekite raid; recovery of captives and spoil.",
  },
  {
    id: "death-of-saul",
    book: "1-samuel",
    section: "David Rising",
    displayName: "Death of Saul",
    bibleReference: "1 Samuel 31",
    chronologicalOrder: 292,
    parentChapterId: null,
    unlockRequirement: "ziklag-raided",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Gilboa — Saul and his sons fall.",
  },
  {
    id: "david-hears-of-sauls-death",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David Hears of Saul's Death",
    bibleReference: "2 Samuel 1",
    chronologicalOrder: 293,
    parentChapterId: null,
    unlockRequirement: "death-of-saul",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Amalekite's lie; lament of the bow.",
  },
  {
    id: "david-king-of-judah",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David King of Judah",
    bibleReference: "2 Samuel 2",
    chronologicalOrder: 294,
    parentChapterId: null,
    unlockRequirement: "david-hears-of-sauls-death",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Hebron reign; civil war with Abner's forces.",
  },
  {
    id: "abner-and-ishbosheth",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Abner and Ish-bosheth",
    bibleReference: "2 Samuel 3–4",
    chronologicalOrder: 295,
    parentChapterId: null,
    unlockRequirement: "david-king-of-judah",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Defection, murder, and David's justice.",
  },
  {
    id: "david-king-over-all-israel",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David King over All Israel",
    bibleReference: "2 Samuel 5",
    chronologicalOrder: 296,
    parentChapterId: null,
    unlockRequirement: "abner-and-ishbosheth",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Jerusalem captured; Philistines defeated.",
  },
  {
    id: "ark-brought-to-jerusalem",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Ark Brought to Jerusalem",
    bibleReference: "2 Samuel 6",
    chronologicalOrder: 297,
    parentChapterId: null,
    unlockRequirement: "david-king-over-all-israel",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Uzzah; Michal; dancing before the Lord.",
  },
  {
    id: "davidic-covenant",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "The Davidic Covenant",
    bibleReference: "2 Samuel 7",
    chronologicalOrder: 298,
    parentChapterId: null,
    unlockRequirement: "ark-brought-to-jerusalem",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Prophecy"],
    description: "An everlasting house and throne promised.",
  },
  {
    id: "davids-victories",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David's Victories",
    bibleReference: "2 Samuel 8",
    chronologicalOrder: 299,
    parentChapterId: null,
    unlockRequirement: "davidic-covenant",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Interactive Map"],
    description: "Empire expands; justice and equity administered.",
  },
  {
    id: "david-and-mephibosheth",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David and Mephibosheth",
    bibleReference: "2 Samuel 9",
    chronologicalOrder: 300,
    parentChapterId: null,
    unlockRequirement: "davids-victories",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Covenant kindness to Jonathan's son.",
  },
  {
    id: "ammonite-war",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Ammonite War",
    bibleReference: "2 Samuel 10",
    chronologicalOrder: 301,
    parentChapterId: null,
    unlockRequirement: "david-and-mephibosheth",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "Humiliated envoys; Joab's divided battle.",
  },
  {
    id: "david-and-bathsheba",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David and Bathsheba",
    bibleReference: "2 Samuel 11",
    chronologicalOrder: 302,
    parentChapterId: null,
    unlockRequirement: "ammonite-war",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Adultery, cover-up, and Uriah's murder.",
  },
  {
    id: "nathan-confronts-david",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Nathan Confronts David",
    bibleReference: "2 Samuel 12",
    chronologicalOrder: 303,
    parentChapterId: null,
    unlockRequirement: "david-and-bathsheba",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Decision"],
    description: "You are the man — repentance and consequences.",
  },
  {
    id: "amnons-crime",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Amnon's Crime",
    bibleReference: "2 Samuel 13",
    chronologicalOrder: 304,
    parentChapterId: null,
    unlockRequirement: "nathan-confronts-david",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Tamar violated; Absalom's revenge begins.",
  },
  {
    id: "absalom-returns",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Absalom Returns",
    bibleReference: "2 Samuel 14",
    chronologicalOrder: 305,
    parentChapterId: null,
    unlockRequirement: "amnons-crime",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Joab's ruse with the wise woman of Tekoa.",
  },
  {
    id: "absaloms-rebellion",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Absalom's Rebellion",
    bibleReference: "2 Samuel 15–18",
    chronologicalOrder: 306,
    parentChapterId: null,
    unlockRequirement: "absalom-returns",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Theft of hearts; flight; forest battle; father's grief.",
  },
  {
    id: "david-restored",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David Restored",
    bibleReference: "2 Samuel 19–20",
    chronologicalOrder: 307,
    parentChapterId: null,
    unlockRequirement: "absaloms-rebellion",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Return across Jordan; Sheba's revolt.",
  },
  {
    id: "gibeonite-revenge",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Gibeonite Revenge",
    bibleReference: "2 Samuel 21:1–14",
    chronologicalOrder: 308,
    parentChapterId: null,
    unlockRequirement: "david-restored",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Famine, bloodguilt, and Rizpah's vigil.",
  },
  {
    id: "philistine-giants-defeated",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Philistine Giants Defeated",
    bibleReference: "2 Samuel 21:15–22",
    chronologicalOrder: 309,
    parentChapterId: null,
    unlockRequirement: "gibeonite-revenge",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "David's mighty men fell the giants.",
  },
  {
    id: "davids-song-of-deliverance",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David's Song of Deliverance",
    bibleReference: "2 Samuel 22",
    chronologicalOrder: 310,
    parentChapterId: null,
    unlockRequirement: "philistine-giants-defeated",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "The Lord is my rock — royal thanksgiving.",
  },
  {
    id: "davids-last-words",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David's Last Words",
    bibleReference: "2 Samuel 23:1–7",
    chronologicalOrder: 311,
    parentChapterId: null,
    unlockRequirement: "davids-song-of-deliverance",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Oracle of the sweet psalmist of Israel.",
  },
  {
    id: "davids-mighty-men",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "David's Mighty Men",
    bibleReference: "2 Samuel 23:8–39",
    chronologicalOrder: 312,
    parentChapterId: null,
    unlockRequirement: "davids-last-words",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "The Thirty and their exploits.",
  },
  {
    id: "census-and-plague",
    book: "2-samuel",
    section: "David's Kingdom",
    displayName: "Census and Plague",
    bibleReference: "2 Samuel 24",
    chronologicalOrder: 313,
    parentChapterId: null,
    unlockRequirement: "davids-mighty-men",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Numbering Israel; altar on Araunah's threshing floor.",
  },
  {
    id: "adoniijah-and-solomons-rise",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Adonijah and Solomon's Rise",
    bibleReference: "1 Kings 1",
    chronologicalOrder: 314,
    parentChapterId: null,
    unlockRequirement: "census-and-plague",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Succession crisis; Nathan and Bathsheba intervene.",
  },
  {
    id: "davids-charge-to-solomon",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "David's Charge to Solomon",
    bibleReference: "1 Kings 2",
    chronologicalOrder: 315,
    parentChapterId: null,
    unlockRequirement: "adoniijah-and-solomons-rise",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Be strong; settle unfinished justice.",
  },
  {
    id: "solomon-asks-for-wisdom",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Solomon Asks for Wisdom",
    bibleReference: "1 Kings 3",
    chronologicalOrder: 316,
    parentChapterId: null,
    unlockRequirement: "davids-charge-to-solomon",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Dream at Gibeon; two mothers and a child.",
  },
  {
    id: "solomons-administration",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Solomon's Administration",
    bibleReference: "1 Kings 4",
    chronologicalOrder: 317,
    parentChapterId: null,
    unlockRequirement: "solomon-asks-for-wisdom",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Officials, prosperity, and wisdom that spreads abroad.",
  },
  {
    id: "temple-construction",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Temple Construction",
    bibleReference: "1 Kings 5–7",
    chronologicalOrder: 318,
    parentChapterId: null,
    unlockRequirement: "solomons-administration",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Temple",
    description: "Alliance with Hiram; house of the Lord built.",
  },
  {
    id: "temple-dedication",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Temple Dedication",
    bibleReference: "1 Kings 8",
    chronologicalOrder: 319,
    parentChapterId: null,
    unlockRequirement: "temple-construction",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Teaching"],
    description: "Ark installed; Solomon's prayer; glory fills the house.",
  },
  {
    id: "lords-response-to-solomon",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Lord's Response to Solomon",
    bibleReference: "1 Kings 9:1–9",
    chronologicalOrder: 320,
    parentChapterId: null,
    unlockRequirement: "temple-dedication",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Covenant confirmed with temple warning.",
  },
  {
    id: "solomons-other-works",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Solomon's Other Works",
    bibleReference: "1 Kings 9:10–28",
    chronologicalOrder: 321,
    parentChapterId: null,
    unlockRequirement: "lords-response-to-solomon",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Cities, labor force, and Red Sea fleet.",
  },
  {
    id: "queen-of-sheba",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Queen of Sheba",
    bibleReference: "1 Kings 10",
    chronologicalOrder: 322,
    parentChapterId: null,
    unlockRequirement: "solomons-other-works",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Story"],
    description: "Hard questions; gold and glory peak.",
  },
  {
    id: "solomons-apostasy",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Solomon's Apostasy",
    bibleReference: "1 Kings 11",
    chronologicalOrder: 323,
    parentChapterId: null,
    unlockRequirement: "queen-of-sheba",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Foreign wives turn the heart; adversaries raised.",
  },
  {
    id: "kingdom-divides",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "The Kingdom Divides",
    bibleReference: "1 Kings 12",
    chronologicalOrder: 324,
    parentChapterId: null,
    unlockRequirement: "solomons-apostasy",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Rehoboam's folly; Jeroboam's calves.",
  },
  {
    id: "man-of-god-from-judah",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Man of God from Judah",
    bibleReference: "1 Kings 13",
    chronologicalOrder: 325,
    parentChapterId: null,
    unlockRequirement: "kingdom-divides",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Altar sign; disobedience to the word; lion judgment.",
  },
  {
    id: "jeroboams-dynasty-judged",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Jeroboam's Dynasty Judged",
    bibleReference: "1 Kings 14:1–20",
    chronologicalOrder: 326,
    parentChapterId: null,
    unlockRequirement: "man-of-god-from-judah",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Ahijah's hard word to Jeroboam's wife.",
  },
  {
    id: "rehoboam-and-early-judah",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Rehoboam and Early Judah",
    bibleReference: "1 Kings 14:21–31",
    chronologicalOrder: 327,
    parentChapterId: null,
    unlockRequirement: "jeroboams-dynasty-judged",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Shishak plunders the temple treasures.",
  },
  {
    id: "abijam-and-asa",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Abijam and Asa",
    bibleReference: "1 Kings 15:1–24",
    chronologicalOrder: 328,
    parentChapterId: null,
    unlockRequirement: "rehoboam-and-early-judah",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Mixed kings of Judah; Asa's reforms and treaty.",
  },
  {
    id: "nadab-baasha-elah-zimri-omri",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Nadab to Omri",
    bibleReference: "1 Kings 15:25–16:28",
    chronologicalOrder: 329,
    parentChapterId: null,
    unlockRequirement: "abijam-and-asa",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Timeline", "Story"],
    description: "Northern coups and the founding of Samaria.",
  },
  {
    id: "ahab-and-jezebel",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Ahab and Jezebel",
    bibleReference: "1 Kings 16:29–34",
    chronologicalOrder: 330,
    parentChapterId: null,
    unlockRequirement: "nadab-baasha-elah-zimri-omri",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Baal worship institutionalized in Israel.",
  },
  {
    id: "elijah-announces-drought",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Elijah Announces Drought",
    bibleReference: "1 Kings 17",
    chronologicalOrder: 331,
    parentChapterId: null,
    unlockRequirement: "ahab-and-jezebel",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Cherith ravens; Zarephath widow; raised son.",
  },
  {
    id: "elijah-on-carmel",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Elijah on Mount Carmel",
    bibleReference: "1 Kings 18",
    chronologicalOrder: 332,
    parentChapterId: null,
    unlockRequirement: "elijah-announces-drought",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "Fire from heaven; Baal's prophets fall.",
  },
  {
    id: "elijah-at-horeb",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Elijah at Horeb",
    bibleReference: "1 Kings 19",
    chronologicalOrder: 333,
    parentChapterId: null,
    unlockRequirement: "elijah-on-carmel",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Dialogue"],
    description: "Still small voice; Elisha called.",
  },
  {
    id: "benhadad-wars",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Ben-hadad Wars",
    bibleReference: "1 Kings 20",
    chronologicalOrder: 334,
    parentChapterId: null,
    unlockRequirement: "elijah-at-horeb",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "Ahab's victories and failure to devote Ben-hadad.",
  },
  {
    id: "naboths-vineyard",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Naboth's Vineyard",
    bibleReference: "1 Kings 21",
    chronologicalOrder: 335,
    parentChapterId: null,
    unlockRequirement: "benhadad-wars",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Judicial murder for a garden; dogs will lick blood.",
  },
  {
    id: "ahab-falls-at-ramoth",
    book: "1-kings",
    section: "Solomon & Divided Kingdom",
    displayName: "Ahab Falls at Ramoth-gilead",
    bibleReference: "1 Kings 22",
    chronologicalOrder: 336,
    parentChapterId: null,
    unlockRequirement: "naboths-vineyard",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Lying spirits; Micaiah's truth; random arrow.",
  },
  {
    id: "elijah-taken-up",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Elijah Taken Up",
    bibleReference: "2 Kings 2",
    chronologicalOrder: 337,
    parentChapterId: null,
    unlockRequirement: "ahab-falls-at-ramoth",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Story"],
    description: "Chariot of fire; Elisha receives the mantle.",
  },
  {
    id: "elisha-begins",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Elisha Begins Ministry",
    bibleReference: "2 Kings 2:19–25",
    chronologicalOrder: 338,
    parentChapterId: null,
    unlockRequirement: "elijah-taken-up",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Waters healed; bears and the mocking youths.",
  },
  {
    id: "moabite-war-elisha",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Moabite War",
    bibleReference: "2 Kings 3",
    chronologicalOrder: 339,
    parentChapterId: null,
    unlockRequirement: "elisha-begins",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "Ditches filled with water; Moab sees blood.",
  },
  {
    id: "widows-oil",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "The Widow's Oil",
    bibleReference: "2 Kings 4:1–7",
    chronologicalOrder: 340,
    parentChapterId: null,
    unlockRequirement: "moabite-war-elisha",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Miracle provision for a prophet's widow.",
  },
  {
    id: "shunammite-son",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Shunammite's Son Raised",
    bibleReference: "2 Kings 4:8–37",
    chronologicalOrder: 341,
    parentChapterId: null,
    unlockRequirement: "widows-oil",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Hospitality rewarded; death reversed.",
  },
  {
    id: "poison-stew-and-multiplied-loaves",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Poison Stew and Multiplied Loaves",
    bibleReference: "2 Kings 4:38–44",
    chronologicalOrder: 342,
    parentChapterId: null,
    unlockRequirement: "shunammite-son",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Death in the pot healed; barley loaves feed many.",
  },
  {
    id: "naaman-healed",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Naaman Healed",
    bibleReference: "2 Kings 5",
    chronologicalOrder: 343,
    parentChapterId: null,
    unlockRequirement: "poison-stew-and-multiplied-loaves",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Seven dips in the Jordan; Gehazi's greed.",
  },
  {
    id: "axe-head-floats",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Axe Head Floats",
    bibleReference: "2 Kings 6:1–7",
    chronologicalOrder: 344,
    parentChapterId: null,
    unlockRequirement: "naaman-healed",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Iron swims for the sons of the prophets.",
  },
  {
    id: "elisha-and-aramean-army",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Elisha and the Aramean Army",
    bibleReference: "2 Kings 6:8–23",
    chronologicalOrder: 345,
    parentChapterId: null,
    unlockRequirement: "axe-head-floats",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Open his eyes — chariots of fire.",
  },
  {
    id: "samaria-siege",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Siege of Samaria",
    bibleReference: "2 Kings 6:24–7:20",
    chronologicalOrder: 346,
    parentChapterId: null,
    unlockRequirement: "elisha-and-aramean-army",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Famine horror; four lepers; sudden deliverance.",
  },
  {
    id: "shunammite-land-restored",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Shunammite Land Restored",
    bibleReference: "2 Kings 8:1–6",
    chronologicalOrder: 347,
    parentChapterId: null,
    unlockRequirement: "samaria-siege",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Seven-year sojourn; property returned.",
  },
  {
    id: "hazeel-anointed",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Hazael Anointed by Proxy",
    bibleReference: "2 Kings 8:7–15",
    chronologicalOrder: 348,
    parentChapterId: null,
    unlockRequirement: "shunammite-land-restored",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Elisha weeps over coming Aramean cruelty.",
  },
  {
    id: "jehu-anointed",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Jehu Anointed",
    bibleReference: "2 Kings 9–10",
    chronologicalOrder: 349,
    parentChapterId: null,
    unlockRequirement: "hazeel-anointed",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "Judgment on Ahab's house; Baal wiped out; incomplete zeal.",
  },
  {
    id: "athaliah-and-joash",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Athaliah and Joash",
    bibleReference: "2 Kings 11–12",
    chronologicalOrder: 350,
    parentChapterId: null,
    unlockRequirement: "jehu-anointed",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Queen mother's massacre; boy king; temple repairs.",
  },
  {
    id: "jehoahaz-jehoash-israel",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Jehoahaz and Jehoash of Israel",
    bibleReference: "2 Kings 13",
    chronologicalOrder: 351,
    parentChapterId: null,
    unlockRequirement: "athaliah-and-joash",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Aramean oppression; Elisha's deathbed arrows.",
  },
  {
    id: "amaziah-jeroboam-ii-azariah",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Amaziah to Azariah",
    bibleReference: "2 Kings 14–15",
    chronologicalOrder: 352,
    parentChapterId: null,
    unlockRequirement: "jehoahaz-jehoash-israel",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Timeline", "Story"],
    description: "Mixed kings; Assyria's shadow lengthens.",
  },
  {
    id: "fall-of-samaria",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Fall of Samaria",
    bibleReference: "2 Kings 17",
    chronologicalOrder: 353,
    parentChapterId: null,
    unlockRequirement: "amaziah-jeroboam-ii-azariah",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Prophecy"],
    description: "Exile of Israel; origin of Samaritans explained.",
  },
  {
    id: "hezekiah-reforms",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Hezekiah's Reforms",
    bibleReference: "2 Kings 18",
    chronologicalOrder: 354,
    parentChapterId: null,
    unlockRequirement: "fall-of-samaria",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Trust in the Lord; Assyrian threat.",
  },
  {
    id: "assyrian-siege-of-jerusalem",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Assyrian Siege of Jerusalem",
    bibleReference: "2 Kings 19",
    chronologicalOrder: 355,
    parentChapterId: null,
    unlockRequirement: "hezekiah-reforms",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Story"],
    description: "Isaiah's word; angel strikes the camp.",
  },
  {
    id: "hezekiahs-illness-and-folly",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Hezekiah's Illness and Folly",
    bibleReference: "2 Kings 20",
    chronologicalOrder: 356,
    parentChapterId: null,
    unlockRequirement: "assyrian-siege-of-jerusalem",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Fifteen years added; Babylonian envoys shown treasures.",
  },
  {
    id: "manasseh-and-amon",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Manasseh and Amon",
    bibleReference: "2 Kings 21",
    chronologicalOrder: 357,
    parentChapterId: null,
    unlockRequirement: "hezekiahs-illness-and-folly",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Deepest idolatry; judgment decreed on Judah.",
  },
  {
    id: "josiahs-reform",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Josiah's Reform",
    bibleReference: "2 Kings 22–23",
    chronologicalOrder: 358,
    parentChapterId: null,
    unlockRequirement: "manasseh-and-amon",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Book of the Law found; covenant renewal; Passover.",
  },
  {
    id: "final-kings-of-judah",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Final Kings of Judah",
    bibleReference: "2 Kings 23:31–24:20",
    chronologicalOrder: 359,
    parentChapterId: null,
    unlockRequirement: "josiahs-reform",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Timeline",
    description: "Jehoahaz to Zedekiah under Egyptian and Babylonian pressure.",
  },
  {
    id: "fall-of-jerusalem",
    book: "2-kings",
    section: "Prophets, Fall of Samaria & Judah",
    displayName: "Fall of Jerusalem",
    bibleReference: "2 Kings 25",
    chronologicalOrder: 360,
    parentChapterId: null,
    unlockRequirement: "final-kings-of-judah",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Cutscene"],
    description: "Temple burned; exile; Jehoiachin released in Babylon.",
  },
  {
    id: "chronicles-from-adam",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Genealogies from Adam",
    bibleReference: "1 Chronicles 1",
    chronologicalOrder: 361,
    parentChapterId: null,
    unlockRequirement: "fall-of-jerusalem",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Adam to the nations — Chronicler's opening panorama.",
  },
  {
    id: "genealogies-of-israel",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Genealogies of Israel",
    bibleReference: "1 Chronicles 2–8",
    chronologicalOrder: 362,
    parentChapterId: null,
    unlockRequirement: "chronicles-from-adam",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Tribal lines with focus on Judah, Levi, and Benjamin.",
  },
  {
    id: "returning-exiles-listed",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Returning Exiles Listed",
    bibleReference: "1 Chronicles 9",
    chronologicalOrder: 363,
    parentChapterId: null,
    unlockRequirement: "genealogies-of-israel",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Jerusalem resettled; gatekeepers and singers.",
  },
  {
    id: "sauls-fall-chronicles",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Saul's Fall (Chronicles)",
    bibleReference: "1 Chronicles 10",
    chronologicalOrder: 364,
    parentChapterId: null,
    unlockRequirement: "returning-exiles-listed",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Unfaithfulness summarized; kingdom transferred.",
  },
  {
    id: "david-anointed-chronicles",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "David Anointed King (Chronicles)",
    bibleReference: "1 Chronicles 11–12",
    chronologicalOrder: 365,
    parentChapterId: null,
    unlockRequirement: "sauls-fall-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Educational Module"],
    description: "Mighty men and tribal support for David.",
  },
  {
    id: "ark-and-worship-organized",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Ark and Worship Organized",
    bibleReference: "1 Chronicles 13–16",
    chronologicalOrder: 366,
    parentChapterId: null,
    unlockRequirement: "david-anointed-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Teaching"],
    description: "Uzzah; blessing of Obed-edom; Asaph appointed.",
  },
  {
    id: "davidic-covenant-chronicles",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Davidic Covenant (Chronicles)",
    bibleReference: "1 Chronicles 17",
    chronologicalOrder: 367,
    parentChapterId: null,
    unlockRequirement: "ark-and-worship-organized",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "House, kingdom, and throne forever.",
  },
  {
    id: "davids-wars-chronicles",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "David's Wars (Chronicles)",
    bibleReference: "1 Chronicles 18–20",
    chronologicalOrder: 368,
    parentChapterId: null,
    unlockRequirement: "davidic-covenant-chronicles",
    status: "comingSoon",
    estimatedGameplayType: "Battle",
    description: "Victories catalogued for the Chronicler's audience.",
  },
  {
    id: "census-chronicles",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Census (Chronicles)",
    bibleReference: "1 Chronicles 21",
    chronologicalOrder: 369,
    parentChapterId: null,
    unlockRequirement: "davids-wars-chronicles",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Satan incites; threshing floor becomes temple site.",
  },
  {
    id: "temple-preparations",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Temple Preparations",
    bibleReference: "1 Chronicles 22–26",
    chronologicalOrder: 370,
    parentChapterId: null,
    unlockRequirement: "census-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Temple", "Educational Module"],
    description: "Materials, Levites, priests, musicians, gatekeepers.",
  },
  {
    id: "military-and-civil-officers",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "Military and Civil Officers",
    bibleReference: "1 Chronicles 27",
    chronologicalOrder: 371,
    parentChapterId: null,
    unlockRequirement: "temple-preparations",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Monthly divisions and royal stewards.",
  },
  {
    id: "david-commissions-solomon-chronicles",
    book: "1-chronicles",
    section: "Genealogies & David's Reign",
    displayName: "David Commissions Solomon",
    bibleReference: "1 Chronicles 28–29",
    chronologicalOrder: 372,
    parentChapterId: null,
    unlockRequirement: "military-and-civil-officers",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Cutscene"],
    description: "Plans given; freewill offerings; David prays and dies.",
  },
  {
    id: "solomon-asks-wisdom-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Solomon Asks for Wisdom (Chronicles)",
    bibleReference: "2 Chronicles 1",
    chronologicalOrder: 373,
    parentChapterId: null,
    unlockRequirement: "david-commissions-solomon-chronicles",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Gibeon theophany; kingdom established.",
  },
  {
    id: "temple-built-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Temple Built (Chronicles)",
    bibleReference: "2 Chronicles 2–5",
    chronologicalOrder: 374,
    parentChapterId: null,
    unlockRequirement: "solomon-asks-wisdom-chronicles",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Temple",
    description: "Construction and ark installation emphasized.",
  },
  {
    id: "temple-dedication-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Temple Dedication (Chronicles)",
    bibleReference: "2 Chronicles 6–7",
    chronologicalOrder: 375,
    parentChapterId: null,
    unlockRequirement: "temple-built-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Teaching"],
    description: "Prayer and fire; if my people who are called by my name…",
  },
  {
    id: "queen-of-sheba-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Queen of Sheba (Chronicles)",
    bibleReference: "2 Chronicles 8–9",
    chronologicalOrder: 376,
    parentChapterId: null,
    unlockRequirement: "temple-dedication-chronicles",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Works, wealth, and Solomon's end.",
  },
  {
    id: "rehoboam-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Rehoboam (Chronicles)",
    bibleReference: "2 Chronicles 10–12",
    chronologicalOrder: 377,
    parentChapterId: null,
    unlockRequirement: "queen-of-sheba-chronicles",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Division; humility after Shishak.",
  },
  {
    id: "abijah-asa-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Abijah and Asa (Chronicles)",
    bibleReference: "2 Chronicles 13–16",
    chronologicalOrder: 378,
    parentChapterId: null,
    unlockRequirement: "rehoboam-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Decision"],
    description: "Reliance on the Lord vs. reliance on physicians/treaties.",
  },
  {
    id: "jehoshaphat",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Jehoshaphat",
    bibleReference: "2 Chronicles 17–20",
    chronologicalOrder: 379,
    parentChapterId: null,
    unlockRequirement: "abijah-asa-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Teaching mission; alliance folly; choir-led victory.",
  },
  {
    id: "jehoram-to-joash-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Jehoram to Joash (Chronicles)",
    bibleReference: "2 Chronicles 21–24",
    chronologicalOrder: 380,
    parentChapterId: null,
    unlockRequirement: "jehoshaphat",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Letter from Elijah; Athaliah; temple repaired then abandoned.",
  },
  {
    id: "amaziah-uzziah-jotham",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Amaziah, Uzziah, and Jotham",
    bibleReference: "2 Chronicles 25–27",
    chronologicalOrder: 381,
    parentChapterId: null,
    unlockRequirement: "jehoram-to-joash-chronicles",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Pride after victory; Uzziah's leprosy.",
  },
  {
    id: "ahaz-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Ahaz (Chronicles)",
    bibleReference: "2 Chronicles 28",
    chronologicalOrder: 382,
    parentChapterId: null,
    unlockRequirement: "amaziah-uzziah-jotham",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Deep apostasy; prophet Oded saves captives.",
  },
  {
    id: "hezekiah-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Hezekiah (Chronicles)",
    bibleReference: "2 Chronicles 29–32",
    chronologicalOrder: 383,
    parentChapterId: null,
    unlockRequirement: "ahaz-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Temple"],
    description: "Temple cleansing; Passover; Assyrian deliverance.",
  },
  {
    id: "manasseh-repents",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Manasseh Repents",
    bibleReference: "2 Chronicles 33",
    chronologicalOrder: 384,
    parentChapterId: null,
    unlockRequirement: "hezekiah-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Exile, repentance, and partial restoration.",
  },
  {
    id: "josiah-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Josiah (Chronicles)",
    bibleReference: "2 Chronicles 34–35",
    chronologicalOrder: 385,
    parentChapterId: null,
    unlockRequirement: "manasseh-repents",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Reform; Passover; death at Megiddo.",
  },
  {
    id: "judah-to-exile-chronicles",
    book: "2-chronicles",
    section: "Judah's Kings to Exile",
    displayName: "Judah to Exile (Chronicles)",
    bibleReference: "2 Chronicles 36",
    chronologicalOrder: 386,
    parentChapterId: null,
    unlockRequirement: "josiah-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Prophecy"],
    description: "Last kings; temple burned; Cyrus decree foreshadowed.",
  },
  {
    id: "cyrus-decree",
    book: "ezra",
    section: "Return & Temple",
    displayName: "Cyrus' Decree",
    bibleReference: "Ezra 1",
    chronologicalOrder: 387,
    parentChapterId: null,
    unlockRequirement: "judah-to-exile-chronicles",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Prophecy"],
    description: "The Lord stirs a pagan king to rebuild the temple.",
  },
  {
    id: "returnees-listed-ezra",
    book: "ezra",
    section: "Return & Temple",
    displayName: "Returnees Listed",
    bibleReference: "Ezra 2",
    chronologicalOrder: 388,
    parentChapterId: null,
    unlockRequirement: "cyrus-decree",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Exiles who returned with Zerubbabel.",
  },
  {
    id: "altar-and-foundation",
    book: "ezra",
    section: "Return & Temple",
    displayName: "Altar and Foundation",
    bibleReference: "Ezra 3",
    chronologicalOrder: 389,
    parentChapterId: null,
    unlockRequirement: "returnees-listed-ezra",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Temple"],
    description: "Worship restored; foundation laid amid weeping and joy.",
  },
  {
    id: "opposition-to-building",
    book: "ezra",
    section: "Return & Temple",
    displayName: "Opposition to Building",
    bibleReference: "Ezra 4",
    chronologicalOrder: 390,
    parentChapterId: null,
    unlockRequirement: "altar-and-foundation",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Adversaries halt the work by imperial letter.",
  },
  {
    id: "temple-completed",
    book: "ezra",
    section: "Return & Temple",
    displayName: "Temple Completed",
    bibleReference: "Ezra 5–6",
    chronologicalOrder: 391,
    parentChapterId: null,
    unlockRequirement: "opposition-to-building",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Temple"],
    description: "Haggai and Zechariah spur completion under Darius.",
  },
  {
    id: "ezra-arrives",
    book: "ezra",
    section: "Return & Temple",
    displayName: "Ezra Arrives",
    bibleReference: "Ezra 7–8",
    chronologicalOrder: 392,
    parentChapterId: null,
    unlockRequirement: "temple-completed",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Interactive Genealogy"],
    description: "Scribe of the law; treasure and fasting for safety.",
  },
  {
    id: "intermarriage-crisis-ezra",
    book: "ezra",
    section: "Return & Temple",
    displayName: "Intermarriage Crisis",
    bibleReference: "Ezra 9–10",
    chronologicalOrder: 393,
    parentChapterId: null,
    unlockRequirement: "ezra-arrives",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Confession and covenant to put away foreign wives.",
  },
  {
    id: "nehemiahs-burden",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Nehemiah's Burden",
    bibleReference: "Nehemiah 1",
    chronologicalOrder: 394,
    parentChapterId: null,
    unlockRequirement: "intermarriage-crisis-ezra",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "News of ruined walls; prayer of a cupbearer.",
  },
  {
    id: "nehemiah-to-jerusalem",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Nehemiah Goes to Jerusalem",
    bibleReference: "Nehemiah 2",
    chronologicalOrder: 395,
    parentChapterId: null,
    unlockRequirement: "nehemiahs-burden",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Decision"],
    description: "Royal permission; night inspection; resolve to build.",
  },
  {
    id: "wall-builders",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Wall Builders",
    bibleReference: "Nehemiah 3",
    chronologicalOrder: 396,
    parentChapterId: null,
    unlockRequirement: "nehemiah-to-jerusalem",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Map",
    description: "Named crews repair section by section.",
  },
  {
    id: "opposition-to-the-wall",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Opposition to the Wall",
    bibleReference: "Nehemiah 4–6",
    chronologicalOrder: 397,
    parentChapterId: null,
    unlockRequirement: "wall-builders",
    status: "comingSoon",
    estimatedGameplayType: ["Battle", "Decision"],
    description: "Mockery, conspiracy, and unfinished work completed.",
  },
  {
    id: "genealogy-after-wall",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Genealogy after the Wall",
    bibleReference: "Nehemiah 7",
    chronologicalOrder: 398,
    parentChapterId: null,
    unlockRequirement: "opposition-to-the-wall",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Census of the restored community.",
  },
  {
    id: "ezra-reads-the-law",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Ezra Reads the Law",
    bibleReference: "Nehemiah 8",
    chronologicalOrder: 399,
    parentChapterId: null,
    unlockRequirement: "genealogy-after-wall",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Story"],
    description: "Water Gate assembly; joy of the Lord is your strength.",
  },
  {
    id: "national-confession",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "National Confession",
    bibleReference: "Nehemiah 9",
    chronologicalOrder: 400,
    parentChapterId: null,
    unlockRequirement: "ezra-reads-the-law",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Long prayer recounting covenant history.",
  },
  {
    id: "sealed-covenant",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Sealed Covenant",
    bibleReference: "Nehemiah 10",
    chronologicalOrder: 401,
    parentChapterId: null,
    unlockRequirement: "national-confession",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Written pledge of obedience and temple support.",
  },
  {
    id: "resettling-jerusalem",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Resettling Jerusalem",
    bibleReference: "Nehemiah 11–12",
    chronologicalOrder: 402,
    parentChapterId: null,
    unlockRequirement: "sealed-covenant",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Genealogy", "Interactive Map"],
    description: "Lots for residents; dedication of the wall.",
  },
  {
    id: "nehemiahs-final-reforms",
    book: "nehemiah",
    section: "Wall & Covenant",
    displayName: "Nehemiah's Final Reforms",
    bibleReference: "Nehemiah 13",
    chronologicalOrder: 403,
    parentChapterId: null,
    unlockRequirement: "resettling-jerusalem",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Tobiah expelled; Sabbath enforced; mixed marriages confronted.",
  },
  {
    id: "vashti-deposed",
    book: "esther",
    section: "Providence in Persia",
    displayName: "Vashti Deposed",
    bibleReference: "Esther 1",
    chronologicalOrder: 404,
    parentChapterId: null,
    unlockRequirement: "nehemiahs-final-reforms",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Persian banquet; queen's refusal; search for a new queen.",
  },
  {
    id: "esther-becomes-queen",
    book: "esther",
    section: "Providence in Persia",
    displayName: "Esther Becomes Queen",
    bibleReference: "Esther 2",
    chronologicalOrder: 405,
    parentChapterId: null,
    unlockRequirement: "vashti-deposed",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Hadassah chosen; Mordecai foils an assassination.",
  },
  {
    id: "hamans-plot",
    book: "esther",
    section: "Providence in Persia",
    displayName: "Haman's Plot",
    bibleReference: "Esther 3",
    chronologicalOrder: 406,
    parentChapterId: null,
    unlockRequirement: "esther-becomes-queen",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Refusal to bow; decree of annihilation.",
  },
  {
    id: "for-such-a-time",
    book: "esther",
    section: "Providence in Persia",
    displayName: "For Such a Time as This",
    bibleReference: "Esther 4",
    chronologicalOrder: 407,
    parentChapterId: null,
    unlockRequirement: "hamans-plot",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "If I perish, I perish.",
  },
  {
    id: "esthers-first-banquet",
    book: "esther",
    section: "Providence in Persia",
    displayName: "Esther's First Banquet",
    bibleReference: "Esther 5",
    chronologicalOrder: 408,
    parentChapterId: null,
    unlockRequirement: "for-such-a-time",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Courage before the king; Haman builds a gallows.",
  },
  {
    id: "mordecai-honored",
    book: "esther",
    section: "Providence in Persia",
    displayName: "Mordecai Honored",
    bibleReference: "Esther 6",
    chronologicalOrder: 409,
    parentChapterId: null,
    unlockRequirement: "esthers-first-banquet",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "The king cannot sleep; tables begin to turn.",
  },
  {
    id: "hamans-downfall",
    book: "esther",
    section: "Providence in Persia",
    displayName: "Haman's Downfall",
    bibleReference: "Esther 7",
    chronologicalOrder: 410,
    parentChapterId: null,
    unlockRequirement: "mordecai-honored",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Accusation at the second banquet.",
  },
  {
    id: "jews-deliverance",
    book: "esther",
    section: "Providence in Persia",
    displayName: "Jews' Deliverance",
    bibleReference: "Esther 8–9",
    chronologicalOrder: 411,
    parentChapterId: null,
    unlockRequirement: "hamans-downfall",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Battle"],
    description: "Counter-decree; Purim instituted.",
  },
  {
    id: "mordecais-greatness",
    book: "esther",
    section: "Providence in Persia",
    displayName: "Mordecai's Greatness",
    bibleReference: "Esther 10",
    chronologicalOrder: 412,
    parentChapterId: null,
    unlockRequirement: "jews-deliverance",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Closing note on Mordecai's advancement.",
  },
  {
    id: "job-prologue",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Job Prologue",
    bibleReference: "Job 1–2",
    chronologicalOrder: 413,
    parentChapterId: null,
    unlockRequirement: "mordecais-greatness",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Heavenly council; losses; Job does not sin with his lips.",
  },
  {
    id: "job-laments",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Job Laments",
    bibleReference: "Job 3",
    chronologicalOrder: 414,
    parentChapterId: null,
    unlockRequirement: "job-prologue",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Curse the day of my birth.",
  },
  {
    id: "eliphaz-first-speech",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Eliphaz — First Speech",
    bibleReference: "Job 4–5",
    chronologicalOrder: 415,
    parentChapterId: null,
    unlockRequirement: "job-laments",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Remember who ever perished being innocent?",
  },
  {
    id: "job-replies-eliphaz-1",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Job Replies to Eliphaz",
    bibleReference: "Job 6–7",
    chronologicalOrder: 416,
    parentChapterId: null,
    unlockRequirement: "eliphaz-first-speech",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Oh that my vexation were weighed.",
  },
  {
    id: "bildad-first-speech",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Bildad — First Speech",
    bibleReference: "Job 8",
    chronologicalOrder: 417,
    parentChapterId: null,
    unlockRequirement: "job-replies-eliphaz-1",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "If you seek God, he will restore you.",
  },
  {
    id: "job-replies-bildad-1",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Job Replies to Bildad",
    bibleReference: "Job 9–10",
    chronologicalOrder: 418,
    parentChapterId: null,
    unlockRequirement: "bildad-first-speech",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "How can a man be in the right before God?",
  },
  {
    id: "zophar-first-speech",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Zophar — First Speech",
    bibleReference: "Job 11",
    chronologicalOrder: 419,
    parentChapterId: null,
    unlockRequirement: "job-replies-bildad-1",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Can you find out the deep things of God?",
  },
  {
    id: "job-replies-zophar-1",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Job Replies to Zophar",
    bibleReference: "Job 12–14",
    chronologicalOrder: 420,
    parentChapterId: null,
    unlockRequirement: "zophar-first-speech",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "I desire to argue my case with God.",
  },
  {
    id: "second-speech-cycle",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Second Speech Cycle",
    bibleReference: "Job 15–21",
    chronologicalOrder: 421,
    parentChapterId: null,
    unlockRequirement: "job-replies-zophar-1",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Friends harden; Job longs for a redeemer.",
  },
  {
    id: "third-speech-cycle",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Third Speech Cycle",
    bibleReference: "Job 22–27",
    chronologicalOrder: 422,
    parentChapterId: null,
    unlockRequirement: "second-speech-cycle",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Accusations peak; Job maintains integrity.",
  },
  {
    id: "hymn-to-wisdom",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Hymn to Wisdom",
    bibleReference: "Job 28",
    chronologicalOrder: 423,
    parentChapterId: null,
    unlockRequirement: "third-speech-cycle",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Where shall wisdom be found? The fear of the Lord.",
  },
  {
    id: "jobs-final-defense",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Job's Final Defense",
    bibleReference: "Job 29–31",
    chronologicalOrder: 424,
    parentChapterId: null,
    unlockRequirement: "hymn-to-wisdom",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Oath of clearance — if I have walked with falsehood…",
  },
  {
    id: "elihu-speeches",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Elihu Speeches",
    bibleReference: "Job 32–37",
    chronologicalOrder: 425,
    parentChapterId: null,
    unlockRequirement: "jobs-final-defense",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Teaching"],
    description: "Young challenger rebukes both Job and the friends.",
  },
  {
    id: "lord-answers-job",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "The Lord Answers Job",
    bibleReference: "Job 38–41",
    chronologicalOrder: 426,
    parentChapterId: null,
    unlockRequirement: "elihu-speeches",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Teaching"],
    description: "Where were you when I laid the foundation of the earth?",
  },
  {
    id: "job-restored",
    book: "job",
    section: "Suffering & Wisdom",
    displayName: "Job Restored",
    bibleReference: "Job 42",
    chronologicalOrder: 427,
    parentChapterId: null,
    unlockRequirement: "lord-answers-job",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Repentance in dust; intercession; double restoration.",
  },
  {
    id: "psalm-1-2-portal",
    book: "psalms",
    section: "Book I (1–41)",
    displayName: "Psalms 1–2 — Portal to the Psalter",
    bibleReference: "Psalms 1–2",
    chronologicalOrder: 428,
    parentChapterId: null,
    unlockRequirement: "job-restored",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Two ways and the Lord's Anointed introduce the book.",
  },
  {
    id: "psalms-davidic-laments-book1",
    book: "psalms",
    section: "Book I (1–41)",
    displayName: "Davidic Laments (Book I)",
    bibleReference: "Psalms 3–7",
    chronologicalOrder: 429,
    parentChapterId: null,
    unlockRequirement: "psalm-1-2-portal",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Morning and night cries under pressure.",
  },
  {
    id: "psalm-8",
    book: "psalms",
    section: "Book I (1–41)",
    displayName: "Psalm 8 — Majesty and Humanity",
    bibleReference: "Psalm 8",
    chronologicalOrder: 430,
    parentChapterId: null,
    unlockRequirement: "psalms-davidic-laments-book1",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "What is man that you are mindful of him?",
  },
  {
    id: "psalms-9-14",
    book: "psalms",
    section: "Book I (1–41)",
    displayName: "Psalms 9–14 — Justice and Folly",
    bibleReference: "Psalms 9–14",
    chronologicalOrder: 431,
    parentChapterId: null,
    unlockRequirement: "psalm-8",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "From thanksgiving to the fool who says there is no God.",
  },
  {
    id: "psalm-15-24",
    book: "psalms",
    section: "Book I (1–41)",
    displayName: "Psalms 15–24 — Entrance and King",
    bibleReference: "Psalms 15–24",
    chronologicalOrder: 432,
    parentChapterId: null,
    unlockRequirement: "psalms-9-14",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Who may ascend? The king of glory enters.",
  },
  {
    id: "psalm-22-23-24",
    book: "psalms",
    section: "Book I (1–41)",
    displayName: "Psalms 22–24 — Suffering Shepherd King",
    bibleReference: "Psalms 22–24",
    chronologicalOrder: 433,
    parentChapterId: null,
    unlockRequirement: "psalm-15-24",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Prophecy"],
    description: "Forsaken cry; green pastures; ascending hill of the Lord.",
  },
  {
    id: "psalms-25-34",
    book: "psalms",
    section: "Book I (1–41)",
    displayName: "Psalms 25–34 — Trust and Deliverance",
    bibleReference: "Psalms 25–34",
    chronologicalOrder: 434,
    parentChapterId: null,
    unlockRequirement: "psalm-22-23-24",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Instruction, sanctuary longing, and tasted goodness.",
  },
  {
    id: "psalms-35-41",
    book: "psalms",
    section: "Book I (1–41)",
    displayName: "Psalms 35–41 — Close of Book I",
    bibleReference: "Psalms 35–41",
    chronologicalOrder: 435,
    parentChapterId: null,
    unlockRequirement: "psalms-25-34",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Enemies, sin acknowledged, and blessed is he who considers the poor.",
  },
  {
    id: "psalms-42-43",
    book: "psalms",
    section: "Book II (42–72)",
    displayName: "Psalms 42–43 — Thirst for God",
    bibleReference: "Psalms 42–43",
    chronologicalOrder: 436,
    parentChapterId: null,
    unlockRequirement: "psalms-35-41",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Why are you cast down, O my soul?",
  },
  {
    id: "psalm-45-48",
    book: "psalms",
    section: "Book II (42–72)",
    displayName: "Psalms 45–48 — King and Zion",
    bibleReference: "Psalms 45–48",
    chronologicalOrder: 437,
    parentChapterId: null,
    unlockRequirement: "psalms-42-43",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Royal wedding; God is our refuge; walk about Zion.",
  },
  {
    id: "psalm-51",
    book: "psalms",
    section: "Book II (42–72)",
    displayName: "Psalm 51 — Create in Me a Clean Heart",
    bibleReference: "Psalm 51",
    chronologicalOrder: 438,
    parentChapterId: null,
    unlockRequirement: "psalm-45-48",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Teaching"],
    description: "David's repentance after Nathan's confrontation.",
  },
  {
    id: "psalms-52-59",
    book: "psalms",
    section: "Book II (42–72)",
    displayName: "Psalms 52–59 — From Doeg to Enemies",
    bibleReference: "Psalms 52–59",
    chronologicalOrder: 439,
    parentChapterId: null,
    unlockRequirement: "psalm-51",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Historical superscriptions of pursuit and deliverance.",
  },
  {
    id: "psalms-60-68",
    book: "psalms",
    section: "Book II (42–72)",
    displayName: "Psalms 60–68 — National and Processional Songs",
    bibleReference: "Psalms 60–68",
    chronologicalOrder: 440,
    parentChapterId: null,
    unlockRequirement: "psalms-52-59",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Banner for those who fear; God shall arise.",
  },
  {
    id: "psalms-69-72",
    book: "psalms",
    section: "Book II (42–72)",
    displayName: "Psalms 69–72 — Close of Book II",
    bibleReference: "Psalms 69–72",
    chronologicalOrder: 441,
    parentChapterId: null,
    unlockRequirement: "psalms-60-68",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Teaching"],
    description: "Zeal for your house; Solomon's royal prayer ends Book II.",
  },
  {
    id: "psalm-73",
    book: "psalms",
    section: "Book III (73–89)",
    displayName: "Psalm 73 — Prosperity of the Wicked",
    bibleReference: "Psalm 73",
    chronologicalOrder: 442,
    parentChapterId: null,
    unlockRequirement: "psalms-69-72",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Until I went into the sanctuary of God.",
  },
  {
    id: "psalms-74-78",
    book: "psalms",
    section: "Book III (73–89)",
    displayName: "Psalms 74–78 — Community Memory",
    bibleReference: "Psalms 74–78",
    chronologicalOrder: 443,
    parentChapterId: null,
    unlockRequirement: "psalm-73",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Timeline"],
    description: "Sanctuary ruined; Asaph rehearses Israel's story.",
  },
  {
    id: "psalms-79-83",
    book: "psalms",
    section: "Book III (73–89)",
    displayName: "Psalms 79–83 — Asaph's National Cries",
    bibleReference: "Psalms 79–83",
    chronologicalOrder: 444,
    parentChapterId: null,
    unlockRequirement: "psalms-74-78",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Nations invade; God of hosts, restore us.",
  },
  {
    id: "psalms-84-89",
    book: "psalms",
    section: "Book III (73–89)",
    displayName: "Psalms 84–89 — Korahites and Ethan",
    bibleReference: "Psalms 84–89",
    chronologicalOrder: 445,
    parentChapterId: null,
    unlockRequirement: "psalms-79-83",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Prophecy"],
    description: "How lovely is your dwelling; will you hide forever?",
  },
  {
    id: "psalm-90",
    book: "psalms",
    section: "Book IV (90–106)",
    displayName: "Psalm 90 — Moses' Prayer",
    bibleReference: "Psalm 90",
    chronologicalOrder: 446,
    parentChapterId: null,
    unlockRequirement: "psalms-84-89",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Teach us to number our days.",
  },
  {
    id: "psalms-91-94",
    book: "psalms",
    section: "Book IV (90–106)",
    displayName: "Psalms 91–94 — Refuge and Reign",
    bibleReference: "Psalms 91–94",
    chronologicalOrder: 447,
    parentChapterId: null,
    unlockRequirement: "psalm-90",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Shadow of the Almighty; the Lord reigns.",
  },
  {
    id: "psalms-95-100",
    book: "psalms",
    section: "Book IV (90–106)",
    displayName: "Psalms 95–100 — Enthronement Psalms",
    bibleReference: "Psalms 95–100",
    chronologicalOrder: 448,
    parentChapterId: null,
    unlockRequirement: "psalms-91-94",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Oh come, let us sing; worship the King.",
  },
  {
    id: "psalms-101-106",
    book: "psalms",
    section: "Book IV (90–106)",
    displayName: "Psalms 101–106 — David to Historical Confession",
    bibleReference: "Psalms 101–106",
    chronologicalOrder: 449,
    parentChapterId: null,
    unlockRequirement: "psalms-95-100",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Timeline"],
    description: "Royal vow; blessing the Lord; recounting rebellion.",
  },
  {
    id: "psalm-107",
    book: "psalms",
    section: "Book V (107–150)",
    displayName: "Psalm 107 — Let the Redeemed Say So",
    bibleReference: "Psalm 107",
    chronologicalOrder: 450,
    parentChapterId: null,
    unlockRequirement: "psalms-101-106",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Four portraits of rescue and thanksgiving.",
  },
  {
    id: "psalms-108-110",
    book: "psalms",
    section: "Book V (107–150)",
    displayName: "Psalms 108–110 — King and Priest",
    bibleReference: "Psalms 108–110",
    chronologicalOrder: 451,
    parentChapterId: null,
    unlockRequirement: "psalm-107",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Sit at my right hand — priest forever after Melchizedek.",
  },
  {
    id: "psalms-111-118",
    book: "psalms",
    section: "Book V (107–150)",
    displayName: "Psalms 111–118 — Hallelujah and Egyptian Hallel",
    bibleReference: "Psalms 111–118",
    chronologicalOrder: 452,
    parentChapterId: null,
    unlockRequirement: "psalms-108-110",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Fear of the Lord; Passover praise culminating in 118.",
  },
  {
    id: "psalm-119",
    book: "psalms",
    section: "Book V (107–150)",
    displayName: "Psalm 119 — Torah Acrostic",
    bibleReference: "Psalm 119",
    chronologicalOrder: 453,
    parentChapterId: null,
    unlockRequirement: "psalms-111-118",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Educational Module"],
    description: "Twenty-two stanzas delighting in God's law.",
  },
  {
    id: "songs-of-ascents",
    book: "psalms",
    section: "Book V (107–150)",
    displayName: "Songs of Ascents",
    bibleReference: "Psalms 120–134",
    chronologicalOrder: 454,
    parentChapterId: null,
    unlockRequirement: "psalm-119",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Teaching"],
    description: "Pilgrim songs for the road to Zion.",
  },
  {
    id: "psalms-135-137",
    book: "psalms",
    section: "Book V (107–150)",
    displayName: "Psalms 135–137 — From Temple to Exile",
    bibleReference: "Psalms 135–137",
    chronologicalOrder: 455,
    parentChapterId: null,
    unlockRequirement: "songs-of-ascents",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Idols are silver; by the waters of Babylon.",
  },
  {
    id: "psalms-138-145",
    book: "psalms",
    section: "Book V (107–150)",
    displayName: "Psalms 138–145 — Final Davidic Collection",
    bibleReference: "Psalms 138–145",
    chronologicalOrder: 456,
    parentChapterId: null,
    unlockRequirement: "psalms-135-137",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Personal praise and the great Davidic acrostic.",
  },
  {
    id: "psalms-146-150",
    book: "psalms",
    section: "Book V (107–150)",
    displayName: "Psalms 146–150 — Final Hallelujahs",
    bibleReference: "Psalms 146–150",
    chronologicalOrder: 457,
    parentChapterId: null,
    unlockRequirement: "psalms-138-145",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Everything that has breath praise the Lord.",
  },
  {
    id: "proverbs-purpose",
    book: "proverbs",
    section: "Wisdom Instruction",
    displayName: "Purpose of Proverbs",
    bibleReference: "Proverbs 1:1–7",
    chronologicalOrder: 458,
    parentChapterId: null,
    unlockRequirement: "psalms-146-150",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "To know wisdom; the fear of the Lord is the beginning.",
  },
  {
    id: "proverbs-parental-appeals",
    book: "proverbs",
    section: "Wisdom Instruction",
    displayName: "Parental Appeals",
    bibleReference: "Proverbs 1:8–9:18",
    chronologicalOrder: 459,
    parentChapterId: null,
    unlockRequirement: "proverbs-purpose",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Two paths; Woman Wisdom vs. Folly.",
  },
  {
    id: "proverbs-solomon-collection-1",
    book: "proverbs",
    section: "Wisdom Instruction",
    displayName: "Solomon Collection I",
    bibleReference: "Proverbs 10–22:16",
    chronologicalOrder: 460,
    parentChapterId: null,
    unlockRequirement: "proverbs-parental-appeals",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Antithetic sayings shaping daily righteousness.",
  },
  {
    id: "words-of-the-wise",
    book: "proverbs",
    section: "Wisdom Instruction",
    displayName: "Words of the Wise",
    bibleReference: "Proverbs 22:17–24:34",
    chronologicalOrder: 461,
    parentChapterId: null,
    unlockRequirement: "proverbs-solomon-collection-1",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Thirty sayings and further counsel.",
  },
  {
    id: "hezekiah-collection",
    book: "proverbs",
    section: "Wisdom Instruction",
    displayName: "Hezekiah's Collection of Solomon",
    bibleReference: "Proverbs 25–29",
    chronologicalOrder: 462,
    parentChapterId: null,
    unlockRequirement: "words-of-the-wise",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Copied by Hezekiah's men — kingship and community.",
  },
  {
    id: "words-of-agur",
    book: "proverbs",
    section: "Wisdom Instruction",
    displayName: "Words of Agur",
    bibleReference: "Proverbs 30",
    chronologicalOrder: 463,
    parentChapterId: null,
    unlockRequirement: "hezekiah-collection",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "I am too stupid to be a man — numerical sayings.",
  },
  {
    id: "words-of-lemuel",
    book: "proverbs",
    section: "Wisdom Instruction",
    displayName: "Words of King Lemuel",
    bibleReference: "Proverbs 31:1–9",
    chronologicalOrder: 464,
    parentChapterId: null,
    unlockRequirement: "words-of-agur",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Mother's oracle on just kingship.",
  },
  {
    id: "woman-of-valor",
    book: "proverbs",
    section: "Wisdom Instruction",
    displayName: "Woman of Valor",
    bibleReference: "Proverbs 31:10–31",
    chronologicalOrder: 465,
    parentChapterId: null,
    unlockRequirement: "words-of-lemuel",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Educational Module"],
    description: "Acrostic portrait of covenantal excellence.",
  },
  {
    id: "ecclesiastes-vanity",
    book: "ecclesiastes",
    section: "Under the Sun",
    displayName: "Vanity of Vanities",
    bibleReference: "Ecclesiastes 1–2",
    chronologicalOrder: 466,
    parentChapterId: null,
    unlockRequirement: "woman-of-valor",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Qoheleth tests pleasure, work, and wisdom.",
  },
  {
    id: "a-time-for-everything",
    book: "ecclesiastes",
    section: "Under the Sun",
    displayName: "A Time for Everything",
    bibleReference: "Ecclesiastes 3",
    chronologicalOrder: 467,
    parentChapterId: null,
    unlockRequirement: "ecclesiastes-vanity",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "To everything there is a season.",
  },
  {
    id: "oppression-and-companionship",
    book: "ecclesiastes",
    section: "Under the Sun",
    displayName: "Oppression and Companionship",
    bibleReference: "Ecclesiastes 4–5",
    chronologicalOrder: 468,
    parentChapterId: null,
    unlockRequirement: "a-time-for-everything",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Two are better than one; fear God in the house of God.",
  },
  {
    id: "wealth-and-mortality",
    book: "ecclesiastes",
    section: "Under the Sun",
    displayName: "Wealth and Mortality",
    bibleReference: "Ecclesiastes 6–8",
    chronologicalOrder: 469,
    parentChapterId: null,
    unlockRequirement: "oppression-and-companionship",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Limits of wealth, reputation, and royal power.",
  },
  {
    id: "wisdom-under-limits",
    book: "ecclesiastes",
    section: "Under the Sun",
    displayName: "Wisdom under Limits",
    bibleReference: "Ecclesiastes 9–11",
    chronologicalOrder: 470,
    parentChapterId: null,
    unlockRequirement: "wealth-and-mortality",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Cast your bread; rejoice, yet know darkness comes.",
  },
  {
    id: "fear-god-keep-commandments",
    book: "ecclesiastes",
    section: "Under the Sun",
    displayName: "Fear God and Keep His Commandments",
    bibleReference: "Ecclesiastes 12",
    chronologicalOrder: 471,
    parentChapterId: null,
    unlockRequirement: "wisdom-under-limits",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Remember your Creator; the end of the matter.",
  },
  {
    id: "song-awakening-love",
    book: "song-of-songs",
    section: "Covenant Love",
    displayName: "Awakening Love",
    bibleReference: "Song of Songs 1–2",
    chronologicalOrder: 472,
    parentChapterId: null,
    unlockRequirement: "fear-god-keep-commandments",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Teaching"],
    description: "Let him kiss me — desire and delight.",
  },
  {
    id: "song-seeking-and-finding",
    book: "song-of-songs",
    section: "Covenant Love",
    displayName: "Seeking and Finding",
    bibleReference: "Song of Songs 3–5",
    chronologicalOrder: 473,
    parentChapterId: null,
    unlockRequirement: "song-awakening-love",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Night search; wedding procession; dream of loss.",
  },
  {
    id: "song-praise-of-the-beloved",
    book: "song-of-songs",
    section: "Covenant Love",
    displayName: "Praise of the Beloved",
    bibleReference: "Song of Songs 6–7",
    chronologicalOrder: 474,
    parentChapterId: null,
    unlockRequirement: "song-seeking-and-finding",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Mutual admiration in covenant intimacy.",
  },
  {
    id: "song-seal-of-love",
    book: "song-of-songs",
    section: "Covenant Love",
    displayName: "Love Strong as Death",
    bibleReference: "Song of Songs 8",
    chronologicalOrder: 475,
    parentChapterId: null,
    unlockRequirement: "song-praise-of-the-beloved",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Set me as a seal; many waters cannot quench love.",
  },
  {
    id: "isaiah-call",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Isaiah's Call",
    bibleReference: "Isaiah 6",
    chronologicalOrder: 476,
    parentChapterId: null,
    unlockRequirement: "song-seal-of-love",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Story"],
    description: "Holy, holy, holy — coal on the lips; here am I.",
  },
  {
    id: "isaiah-1-5-oracles",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Oracles of Chapters 1–5",
    bibleReference: "Isaiah 1–5",
    chronologicalOrder: 477,
    parentChapterId: null,
    unlockRequirement: "isaiah-call",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Lawsuit against Judah; vineyard song; woes.",
  },
  {
    id: "immanuel-sign",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Immanuel Sign",
    bibleReference: "Isaiah 7–8",
    chronologicalOrder: 478,
    parentChapterId: null,
    unlockRequirement: "isaiah-1-5-oracles",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Ahaz refuses a sign; a virgin shall conceive.",
  },
  {
    id: "unto-us-a-child",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Unto Us a Child Is Born",
    bibleReference: "Isaiah 9:1–7",
    chronologicalOrder: 479,
    parentChapterId: null,
    unlockRequirement: "immanuel-sign",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Wonderful Counselor; government on his shoulders.",
  },
  {
    id: "assyria-judged",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Assyria Judged",
    bibleReference: "Isaiah 10",
    chronologicalOrder: 480,
    parentChapterId: null,
    unlockRequirement: "unto-us-a-child",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Rod of anger discarded when its work is done.",
  },
  {
    id: "shoot-from-jesse",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Shoot from Jesse",
    bibleReference: "Isaiah 11–12",
    chronologicalOrder: 481,
    parentChapterId: null,
    unlockRequirement: "assyria-judged",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Spirit-resting Branch; songs of salvation.",
  },
  {
    id: "oracles-against-nations-isaiah",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Oracles against the Nations",
    bibleReference: "Isaiah 13–23",
    chronologicalOrder: 482,
    parentChapterId: null,
    unlockRequirement: "shoot-from-jesse",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Interactive Map"],
    description: "Babylon to Tyre — the Lord of all nations.",
  },
  {
    id: "isaiah-apocalypse",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Isaiah Apocalypse",
    bibleReference: "Isaiah 24–27",
    chronologicalOrder: 483,
    parentChapterId: null,
    unlockRequirement: "oracles-against-nations-isaiah",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Earth judged; death swallowed; vineyard kept.",
  },
  {
    id: "woes-and-zion",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Woes and Zion",
    bibleReference: "Isaiah 28–33",
    chronologicalOrder: 484,
    parentChapterId: null,
    unlockRequirement: "isaiah-apocalypse",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Drunk priests; Ariel; king in beauty.",
  },
  {
    id: "judgment-and-streams",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Judgment and Streams in the Desert",
    bibleReference: "Isaiah 34–35",
    chronologicalOrder: 485,
    parentChapterId: null,
    unlockRequirement: "woes-and-zion",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Edom judged; highway of holiness.",
  },
  {
    id: "hezekiah-narratives-isaiah",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Hezekiah Narratives",
    bibleReference: "Isaiah 36–39",
    chronologicalOrder: 486,
    parentChapterId: null,
    unlockRequirement: "judgment-and-streams",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Assyrian crisis; illness; Babylonian envoys.",
  },
  {
    id: "comfort-my-people",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Comfort My People",
    bibleReference: "Isaiah 40",
    chronologicalOrder: 487,
    parentChapterId: null,
    unlockRequirement: "hezekiah-narratives-isaiah",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Voice in the wilderness; Creator strength for the weary.",
  },
  {
    id: "servant-songs",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Servant Songs",
    bibleReference: "Isaiah 42; 49; 50; 52:13–53:12",
    chronologicalOrder: 488,
    parentChapterId: null,
    unlockRequirement: "comfort-my-people",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Chosen servant; light to nations; suffering and exaltation.",
  },
  {
    id: "cyrus-anointed",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Cyrus Anointed",
    bibleReference: "Isaiah 44:24–45:13",
    chronologicalOrder: 489,
    parentChapterId: null,
    unlockRequirement: "servant-songs",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Shepherd and anointed who rebuilds Jerusalem.",
  },
  {
    id: "idolatry-satire-isaiah",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Idolatry Satire",
    bibleReference: "Isaiah 44; 46",
    chronologicalOrder: 490,
    parentChapterId: null,
    unlockRequirement: "cyrus-anointed",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Carpenters make gods that cannot save.",
  },
  {
    id: "daughter-zion-restored",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Daughter Zion Restored",
    bibleReference: "Isaiah 49–55",
    chronologicalOrder: 491,
    parentChapterId: null,
    unlockRequirement: "idolatry-satire-isaiah",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Sing, O barren; everlasting covenant; come buy without money.",
  },
  {
    id: "true-fasting-and-glory",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "True Fasting and Glory",
    bibleReference: "Isaiah 56–59",
    chronologicalOrder: 492,
    parentChapterId: null,
    unlockRequirement: "daughter-zion-restored",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "House of prayer for all peoples; justice as worship.",
  },
  {
    id: "arise-shine",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Arise, Shine",
    bibleReference: "Isaiah 60–62",
    chronologicalOrder: 493,
    parentChapterId: null,
    unlockRequirement: "true-fasting-and-glory",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Nations come to your light; watchmen on walls.",
  },
  {
    id: "day-of-vengeance-and-new-creation",
    book: "isaiah",
    section: "Judgment & Hope",
    displayName: "Day of Vengeance and New Creation",
    bibleReference: "Isaiah 63–66",
    chronologicalOrder: 494,
    parentChapterId: null,
    unlockRequirement: "arise-shine",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Winepress; new heavens and new earth.",
  },
  {
    id: "jeremiah-call",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Jeremiah's Call",
    bibleReference: "Jeremiah 1",
    chronologicalOrder: 495,
    parentChapterId: null,
    unlockRequirement: "day-of-vengeance-and-new-creation",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Vision"],
    description: "Before I formed you; almond branch; boiling pot.",
  },
  {
    id: "jeremiah-early-oracles",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Early Oracles",
    bibleReference: "Jeremiah 2–6",
    chronologicalOrder: 496,
    parentChapterId: null,
    unlockRequirement: "jeremiah-call",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Broken cisterns; foe from the north.",
  },
  {
    id: "temple-sermon",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Temple Sermon",
    bibleReference: "Jeremiah 7–10",
    chronologicalOrder: 497,
    parentChapterId: null,
    unlockRequirement: "jeremiah-early-oracles",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Do not trust deceptive words — this is the temple of the Lord.",
  },
  {
    id: "covenant-broken-jeremiah",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Covenant Broken",
    bibleReference: "Jeremiah 11–13",
    chronologicalOrder: 498,
    parentChapterId: null,
    unlockRequirement: "temple-sermon",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Conspiracy; waistcloth ruined; wineskins.",
  },
  {
    id: "drought-and-complaint",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Drought and Complaint",
    bibleReference: "Jeremiah 14–15",
    chronologicalOrder: 499,
    parentChapterId: null,
    unlockRequirement: "covenant-broken-jeremiah",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Why is my pain unceasing?",
  },
  {
    id: "potter-and-flask",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Potter and Flask",
    bibleReference: "Jeremiah 18–19",
    chronologicalOrder: 500,
    parentChapterId: null,
    unlockRequirement: "drought-and-complaint",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Story"],
    description: "Clay reshaped; flask smashed in Topheth.",
  },
  {
    id: "jeremiah-persecuted",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Jeremiah Persecuted",
    bibleReference: "Jeremiah 20; 26; 37–38",
    chronologicalOrder: 501,
    parentChapterId: null,
    unlockRequirement: "potter-and-flask",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Stocks, death threats, cistern imprisonment.",
  },
  {
    id: "good-and-bad-figs",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Good and Bad Figs",
    bibleReference: "Jeremiah 24",
    chronologicalOrder: 502,
    parentChapterId: null,
    unlockRequirement: "jeremiah-persecuted",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Exiles as good figs; those remaining as bad.",
  },
  {
    id: "seventy-years",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Seventy Years",
    bibleReference: "Jeremiah 25; 29",
    chronologicalOrder: 503,
    parentChapterId: null,
    unlockRequirement: "good-and-bad-figs",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Letter to the exiles; seek the welfare of the city.",
  },
  {
    id: "cup-of-wrath-nations",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Cup of Wrath for the Nations",
    bibleReference: "Jeremiah 25:15–38",
    chronologicalOrder: 504,
    parentChapterId: null,
    unlockRequirement: "seventy-years",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "All nations drink the cup from the Lord's hand.",
  },
  {
    id: "yoke-and-false-prophets",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Yoke and False Prophets",
    bibleReference: "Jeremiah 27–28",
    chronologicalOrder: 505,
    parentChapterId: null,
    unlockRequirement: "cup-of-wrath-nations",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Hananiah breaks the yoke; truth costs.",
  },
  {
    id: "book-of-consolation",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Book of Consolation",
    bibleReference: "Jeremiah 30–33",
    chronologicalOrder: 506,
    parentChapterId: null,
    unlockRequirement: "yoke-and-false-prophets",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "New covenant written on the heart; righteous Branch.",
  },
  {
    id: "recabites",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "The Rechabites",
    bibleReference: "Jeremiah 35",
    chronologicalOrder: 507,
    parentChapterId: null,
    unlockRequirement: "book-of-consolation",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Obedience of a clan shames Judah.",
  },
  {
    id: "scroll-burned",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Scroll Burned and Rewritten",
    bibleReference: "Jeremiah 36",
    chronologicalOrder: 508,
    parentChapterId: null,
    unlockRequirement: "recabites",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Jehoiakim's knife; word of God cannot be destroyed.",
  },
  {
    id: "fall-narratives-jeremiah",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Fall Narratives",
    bibleReference: "Jeremiah 39–45",
    chronologicalOrder: 509,
    parentChapterId: null,
    unlockRequirement: "scroll-burned",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Jerusalem falls; Gedaliah; flight to Egypt; Baruch's promise.",
  },
  {
    id: "oracles-against-nations-jeremiah",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Oracles against the Nations",
    bibleReference: "Jeremiah 46–51",
    chronologicalOrder: 510,
    parentChapterId: null,
    unlockRequirement: "fall-narratives-jeremiah",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Interactive Map"],
    description: "Egypt to Babylon — judgment on the nations.",
  },
  {
    id: "jerusalem-falls-appendix",
    book: "jeremiah",
    section: "Prophet to the Nations",
    displayName: "Jerusalem Falls Appendix",
    bibleReference: "Jeremiah 52",
    chronologicalOrder: 511,
    parentChapterId: null,
    unlockRequirement: "oracles-against-nations-jeremiah",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Historical appendix paralleling Kings.",
  },
  {
    id: "lamentations-1",
    book: "lamentations",
    section: "Dirges for Zion",
    displayName: "Lamentations 1 — Lonely City",
    bibleReference: "Lamentations 1",
    chronologicalOrder: 512,
    parentChapterId: null,
    unlockRequirement: "jerusalem-falls-appendix",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "How lonely sits the city once full of people.",
  },
  {
    id: "lamentations-2",
    book: "lamentations",
    section: "Dirges for Zion",
    displayName: "Lamentations 2 — Lord as Enemy",
    bibleReference: "Lamentations 2",
    chronologicalOrder: 513,
    parentChapterId: null,
    unlockRequirement: "lamentations-1",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "The Lord has swallowed up without mercy.",
  },
  {
    id: "lamentations-3",
    book: "lamentations",
    section: "Dirges for Zion",
    displayName: "Lamentations 3 — Great Is Your Faithfulness",
    bibleReference: "Lamentations 3",
    chronologicalOrder: 514,
    parentChapterId: null,
    unlockRequirement: "lamentations-2",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Teaching"],
    description: "Hope in the steadfast love of the Lord.",
  },
  {
    id: "lamentations-4",
    book: "lamentations",
    section: "Dirges for Zion",
    displayName: "Lamentations 4 — Siege Horrors",
    bibleReference: "Lamentations 4",
    chronologicalOrder: 515,
    parentChapterId: null,
    unlockRequirement: "lamentations-3",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Sacred stones scattered; princes darken.",
  },
  {
    id: "lamentations-5",
    book: "lamentations",
    section: "Dirges for Zion",
    displayName: "Lamentations 5 — Communal Prayer",
    bibleReference: "Lamentations 5",
    chronologicalOrder: 516,
    parentChapterId: null,
    unlockRequirement: "lamentations-4",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Restore us to yourself, O Lord.",
  },
  {
    id: "ezekiel-throne-vision",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Throne-Chariot Vision",
    bibleReference: "Ezekiel 1–3",
    chronologicalOrder: 517,
    parentChapterId: null,
    unlockRequirement: "lamentations-5",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Story"],
    description: "Living creatures; scroll eaten; watchman appointed.",
  },
  {
    id: "siege-sign-acts",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Siege Sign-Acts",
    bibleReference: "Ezekiel 4–5",
    chronologicalOrder: 518,
    parentChapterId: null,
    unlockRequirement: "ezekiel-throne-vision",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Brick city; rationed food; hair divided three ways.",
  },
  {
    id: "oracles-of-judgment-ezekiel",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Oracles of Judgment",
    bibleReference: "Ezekiel 6–7",
    chronologicalOrder: 519,
    parentChapterId: null,
    unlockRequirement: "siege-sign-acts",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Against the mountains; the end has come.",
  },
  {
    id: "temple-abominations-vision",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Temple Abominations Vision",
    bibleReference: "Ezekiel 8–11",
    chronologicalOrder: 520,
    parentChapterId: null,
    unlockRequirement: "oracles-of-judgment-ezekiel",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Interactive Temple"],
    description: "Idolatry in the temple; glory departs.",
  },
  {
    id: "false-prophets-ezekiel",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "False Prophets and Elders",
    bibleReference: "Ezekiel 12–14",
    chronologicalOrder: 521,
    parentChapterId: null,
    unlockRequirement: "temple-abominations-vision",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Baggage exile; whitewashed walls; idolatrous inquirers.",
  },
  {
    id: "allegories-of-unfaithful",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Allegories of the Unfaithful",
    bibleReference: "Ezekiel 15–17; 19",
    chronologicalOrder: 522,
    parentChapterId: null,
    unlockRequirement: "false-prophets-ezekiel",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Useless vine; foundling bride; eagles and vine; lions.",
  },
  {
    id: "individual-responsibility",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Individual Responsibility",
    bibleReference: "Ezekiel 18",
    chronologicalOrder: 523,
    parentChapterId: null,
    unlockRequirement: "allegories-of-unfaithful",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "The soul who sins shall die — turn and live.",
  },
  {
    id: "history-of-rebellion",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "History of Rebellion",
    bibleReference: "Ezekiel 20",
    chronologicalOrder: 524,
    parentChapterId: null,
    unlockRequirement: "individual-responsibility",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Timeline",
    description: "From Egypt to the wilderness of the peoples.",
  },
  {
    id: "sword-and-oracles",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Sword and Further Oracles",
    bibleReference: "Ezekiel 21–24",
    chronologicalOrder: 525,
    parentChapterId: null,
    unlockRequirement: "history-of-rebellion",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Sword sharpened; Oholah and Oholibah; death of Ezekiel's wife.",
  },
  {
    id: "oracles-against-nations-ezekiel",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Oracles against the Nations",
    bibleReference: "Ezekiel 25–32",
    chronologicalOrder: 526,
    parentChapterId: null,
    unlockRequirement: "sword-and-oracles",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Interactive Map"],
    description: "Ammon to Egypt — surrounding nations judged.",
  },
  {
    id: "watchman-recommissioned",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Watchman Recommissioned",
    bibleReference: "Ezekiel 33",
    chronologicalOrder: 527,
    parentChapterId: null,
    unlockRequirement: "oracles-against-nations-ezekiel",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "After Jerusalem's fall — turn from evil and live.",
  },
  {
    id: "shepherds-and-sheep",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Shepherds and Sheep",
    bibleReference: "Ezekiel 34",
    chronologicalOrder: 528,
    parentChapterId: null,
    unlockRequirement: "watchman-recommissioned",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Bad shepherds judged; Davidic shepherd promised.",
  },
  {
    id: "against-edom-and-new-heart",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Against Edom; New Heart",
    bibleReference: "Ezekiel 35–36",
    chronologicalOrder: 529,
    parentChapterId: null,
    unlockRequirement: "shepherds-and-sheep",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Mount Seir; I will sprinkle clean water; heart of flesh.",
  },
  {
    id: "valley-of-dry-bones",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Valley of Dry Bones",
    bibleReference: "Ezekiel 37",
    chronologicalOrder: 530,
    parentChapterId: null,
    unlockRequirement: "against-edom-and-new-heart",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Interactive Prophecy"],
    description: "Can these bones live? Two sticks become one.",
  },
  {
    id: "gog-and-magog",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Gog and Magog",
    bibleReference: "Ezekiel 38–39",
    chronologicalOrder: 531,
    parentChapterId: null,
    unlockRequirement: "valley-of-dry-bones",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Northern invasion and burial of the hordes.",
  },
  {
    id: "temple-vision-ezekiel",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "Temple Vision",
    bibleReference: "Ezekiel 40–46",
    chronologicalOrder: 532,
    parentChapterId: null,
    unlockRequirement: "gog-and-magog",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Temple", "Interactive Vision"],
    description: "Measured sanctuary; glory returns; prince and offerings.",
  },
  {
    id: "river-and-allotments",
    book: "ezekiel",
    section: "Visions by the Chebar",
    displayName: "River and Allotments",
    bibleReference: "Ezekiel 47–48",
    chronologicalOrder: 533,
    parentChapterId: null,
    unlockRequirement: "temple-vision-ezekiel",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Interactive Map"],
    description: "River of life; tribal portions; Yahweh Shammah.",
  },
  {
    id: "daniel-in-babylon",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Daniel in Babylon",
    bibleReference: "Daniel 1",
    chronologicalOrder: 534,
    parentChapterId: null,
    unlockRequirement: "river-and-allotments",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Resolved not to defile himself; wisdom ten times better.",
  },
  {
    id: "nebuchadnezzars-statue-dream",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Nebuchadnezzar's Statue Dream",
    bibleReference: "Daniel 2",
    chronologicalOrder: 535,
    parentChapterId: null,
    unlockRequirement: "daniel-in-babylon",
    status: "comingSoon",
    estimatedGameplayType: ["Puzzle", "Interactive Vision"],
    description: "Kingdoms of gold to iron/clay; stone that becomes a mountain.",
  },
  {
    id: "fiery-furnace",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Fiery Furnace",
    bibleReference: "Daniel 3",
    chronologicalOrder: 536,
    parentChapterId: null,
    unlockRequirement: "nebuchadnezzars-statue-dream",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "We will not serve your gods — fourth man in the fire.",
  },
  {
    id: "nebuchadnezzar-humbled",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Nebuchadnezzar Humbled",
    bibleReference: "Daniel 4",
    chronologicalOrder: 537,
    parentChapterId: null,
    unlockRequirement: "fiery-furnace",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Vision"],
    description: "Tree cut down; seven times; reason restored.",
  },
  {
    id: "writing-on-the-wall",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Writing on the Wall",
    bibleReference: "Daniel 5",
    chronologicalOrder: 538,
    parentChapterId: null,
    unlockRequirement: "nebuchadnezzar-humbled",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Puzzle"],
    description: "Mene, mene, tekel, parsin — Babylon falls.",
  },
  {
    id: "lions-den",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Lions' Den",
    bibleReference: "Daniel 6",
    chronologicalOrder: 539,
    parentChapterId: null,
    unlockRequirement: "writing-on-the-wall",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Prayer windows open; mouth of lions shut.",
  },
  {
    id: "vision-of-four-beasts",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Vision of Four Beasts",
    bibleReference: "Daniel 7",
    chronologicalOrder: 540,
    parentChapterId: null,
    unlockRequirement: "lions-den",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Ancient of Days; Son of Man receives dominion.",
  },
  {
    id: "ram-and-goat",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Ram and Goat",
    bibleReference: "Daniel 8",
    chronologicalOrder: 541,
    parentChapterId: null,
    unlockRequirement: "vision-of-four-beasts",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Medo-Persia and Greece; little horn; sanctuary defiled.",
  },
  {
    id: "daniel-prays-seventy-weeks",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Daniel Prays; Seventy Weeks",
    bibleReference: "Daniel 9",
    chronologicalOrder: 542,
    parentChapterId: null,
    unlockRequirement: "ram-and-goat",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Interactive Prophecy"],
    description: "Confession for the city; seventy sevens decreed.",
  },
  {
    id: "final-vision-daniel",
    book: "daniel",
    section: "Courts & Visions",
    displayName: "Final Vision",
    bibleReference: "Daniel 10–12",
    chronologicalOrder: 543,
    parentChapterId: null,
    unlockRequirement: "daniel-prays-seventy-weeks",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Interactive Prophecy"],
    description: "Glorious man; kings of north and south; resurrection hope.",
  },
  {
    id: "hosea-marriage-sign",
    book: "hosea",
    section: "Hosea",
    displayName: "Hosea's Marriage Sign",
    bibleReference: "Hosea 1–3",
    chronologicalOrder: 544,
    parentChapterId: null,
    unlockRequirement: "final-vision-daniel",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Prophecy"],
    description: "Gomer; children of judgment; love purchased back.",
  },
  {
    id: "hosea-charges-israel",
    book: "hosea",
    section: "Hosea",
    displayName: "Charges against Israel",
    bibleReference: "Hosea 4–10",
    chronologicalOrder: 545,
    parentChapterId: null,
    unlockRequirement: "hosea-marriage-sign",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "No knowledge of God; empty vine; calf of Samaria.",
  },
  {
    id: "hosea-gods-compassion",
    book: "hosea",
    section: "Hosea",
    displayName: "God's Compassion",
    bibleReference: "Hosea 11–14",
    chronologicalOrder: 546,
    parentChapterId: null,
    unlockRequirement: "hosea-charges-israel",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Teaching"],
    description: "When Israel was a child I loved him; return, O Israel.",
  },
  {
    id: "joel-locust-plague",
    book: "joel",
    section: "Joel",
    displayName: "Locust Plague",
    bibleReference: "Joel 1–2:17",
    chronologicalOrder: 547,
    parentChapterId: null,
    unlockRequirement: "hosea-gods-compassion",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Prophecy"],
    description: "Nation of locusts; rend your hearts; solemn assembly.",
  },
  {
    id: "joel-spirit-poured-out",
    book: "joel",
    section: "Joel",
    displayName: "Spirit Poured Out",
    bibleReference: "Joel 2:18–32",
    chronologicalOrder: 548,
    parentChapterId: null,
    unlockRequirement: "joel-locust-plague",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Afterward I will pour out my Spirit on all flesh.",
  },
  {
    id: "joel-valley-of-decision",
    book: "joel",
    section: "Joel",
    displayName: "Valley of Decision",
    bibleReference: "Joel 3",
    chronologicalOrder: 549,
    parentChapterId: null,
    unlockRequirement: "joel-spirit-poured-out",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Nations judged; the Lord dwells in Zion.",
  },
  {
    id: "amos-oracles-nations",
    book: "amos",
    section: "Amos",
    displayName: "Oracles against the Nations",
    bibleReference: "Amos 1–2",
    chronologicalOrder: 550,
    parentChapterId: null,
    unlockRequirement: "joel-valley-of-decision",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "For three transgressions and for four…",
  },
  {
    id: "amos-words-to-israel",
    book: "amos",
    section: "Amos",
    displayName: "Words to Israel",
    bibleReference: "Amos 3–6",
    chronologicalOrder: 551,
    parentChapterId: null,
    unlockRequirement: "amos-oracles-nations",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Let justice roll down like waters.",
  },
  {
    id: "amos-visions",
    book: "amos",
    section: "Amos",
    displayName: "Visions of Judgment and Restoration",
    bibleReference: "Amos 7–9",
    chronologicalOrder: 552,
    parentChapterId: null,
    unlockRequirement: "amos-words-to-israel",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Interactive Prophecy"],
    description: "Locusts, fire, plumb line, summer fruit; booth of David raised.",
  },
  {
    id: "obadiah-against-edom",
    book: "obadiah",
    section: "Obadiah",
    displayName: "Against Edom",
    bibleReference: "Obadiah 1",
    chronologicalOrder: 553,
    parentChapterId: null,
    unlockRequirement: "amos-visions",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Pride of the heights; day of the Lord near upon all nations.",
  },
  {
    id: "jonah-flees",
    book: "jonah",
    section: "Jonah",
    displayName: "Jonah Flees",
    bibleReference: "Jonah 1",
    chronologicalOrder: 554,
    parentChapterId: null,
    unlockRequirement: "obadiah-against-edom",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Journey"],
    description: "Tarshish instead of Nineveh; storm and great fish.",
  },
  {
    id: "jonah-prays",
    book: "jonah",
    section: "Jonah",
    displayName: "Jonah Prays",
    bibleReference: "Jonah 2",
    chronologicalOrder: 555,
    parentChapterId: null,
    unlockRequirement: "jonah-flees",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Salvation belongs to the Lord — from the belly of Sheol.",
  },
  {
    id: "jonah-preaches",
    book: "jonah",
    section: "Jonah",
    displayName: "Jonah Preaches",
    bibleReference: "Jonah 3",
    chronologicalOrder: 556,
    parentChapterId: null,
    unlockRequirement: "jonah-prays",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Yet forty days; Nineveh repents in sackcloth.",
  },
  {
    id: "jonah-angry",
    book: "jonah",
    section: "Jonah",
    displayName: "Jonah Angry at Mercy",
    bibleReference: "Jonah 4",
    chronologicalOrder: 557,
    parentChapterId: null,
    unlockRequirement: "jonah-preaches",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "Plant, worm, and wind — should I not pity Nineveh?",
  },
  {
    id: "micah-judgment",
    book: "micah",
    section: "Micah",
    displayName: "Judgment on Samaria and Judah",
    bibleReference: "Micah 1–3",
    chronologicalOrder: 558,
    parentChapterId: null,
    unlockRequirement: "jonah-angry",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Prophet strips bare; rulers who hate good.",
  },
  {
    id: "micah-mountain-of-the-lord",
    book: "micah",
    section: "Micah",
    displayName: "Mountain of the Lord",
    bibleReference: "Micah 4–5",
    chronologicalOrder: 559,
    parentChapterId: null,
    unlockRequirement: "micah-judgment",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Swords into plowshares; ruler from Bethlehem.",
  },
  {
    id: "micah-lawsuit",
    book: "micah",
    section: "Micah",
    displayName: "Covenant Lawsuit",
    bibleReference: "Micah 6–7",
    chronologicalOrder: 560,
    parentChapterId: null,
    unlockRequirement: "micah-mountain-of-the-lord",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Prophecy"],
    description: "What does the Lord require? Do justice, love kindness, walk humbly.",
  },
  {
    id: "nahum-against-nineveh",
    book: "nahum",
    section: "Nahum",
    displayName: "Against Nineveh",
    bibleReference: "Nahum 1–3",
    chronologicalOrder: 561,
    parentChapterId: null,
    unlockRequirement: "micah-lawsuit",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "The Lord is slow to anger — yet Nineveh's end is decreed.",
  },
  {
    id: "habakkuk-complaint",
    book: "habakkuk",
    section: "Habakkuk",
    displayName: "Habakkuk's Complaint",
    bibleReference: "Habakkuk 1",
    chronologicalOrder: 562,
    parentChapterId: null,
    unlockRequirement: "nahum-against-nineveh",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Why do you idly look at traitors?",
  },
  {
    id: "habakkuk-watch-and-woes",
    book: "habakkuk",
    section: "Habakkuk",
    displayName: "Watch and Woes",
    bibleReference: "Habakkuk 2",
    chronologicalOrder: 563,
    parentChapterId: null,
    unlockRequirement: "habakkuk-complaint",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "The righteous shall live by his faith.",
  },
  {
    id: "habakkuk-prayer",
    book: "habakkuk",
    section: "Habakkuk",
    displayName: "Habakkuk's Prayer",
    bibleReference: "Habakkuk 3",
    chronologicalOrder: 564,
    parentChapterId: null,
    unlockRequirement: "habakkuk-watch-and-woes",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Dialogue"],
    description: "Yet I will rejoice in the Lord.",
  },
  {
    id: "zephaniah-day-of-the-lord",
    book: "zephaniah",
    section: "Zephaniah",
    displayName: "Day of the Lord",
    bibleReference: "Zephaniah 1–2",
    chronologicalOrder: 565,
    parentChapterId: null,
    unlockRequirement: "habakkuk-prayer",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Day of wrath; seek humility; oracles on nations.",
  },
  {
    id: "zephaniah-restoration",
    book: "zephaniah",
    section: "Zephaniah",
    displayName: "Joyful Restoration",
    bibleReference: "Zephaniah 3",
    chronologicalOrder: 566,
    parentChapterId: null,
    unlockRequirement: "zephaniah-day-of-the-lord",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "The King of Israel, the Lord, is in your midst.",
  },
  {
    id: "haggai-rebuild-temple",
    book: "haggai",
    section: "Haggai",
    displayName: "Rebuild the Temple",
    bibleReference: "Haggai 1",
    chronologicalOrder: 567,
    parentChapterId: null,
    unlockRequirement: "zephaniah-restoration",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Interactive Prophecy"],
    description: "Is it a time for paneled houses while the house lies waste?",
  },
  {
    id: "haggai-glory-and-zerubbabel",
    book: "haggai",
    section: "Haggai",
    displayName: "Greater Glory; Zerubbabel Signet",
    bibleReference: "Haggai 2",
    chronologicalOrder: 568,
    parentChapterId: null,
    unlockRequirement: "haggai-rebuild-temple",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Latter house glory; shaken nations; chosen governor.",
  },
  {
    id: "zechariah-night-visions",
    book: "zechariah",
    section: "Zechariah",
    displayName: "Eight Night Visions",
    bibleReference: "Zechariah 1–6",
    chronologicalOrder: 569,
    parentChapterId: null,
    unlockRequirement: "haggai-glory-and-zerubbabel",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Horses, horns, measuring line, lampstand, flying scroll, chariots.",
  },
  {
    id: "zechariah-fasting-to-feasting",
    book: "zechariah",
    section: "Zechariah",
    displayName: "Fasting to Feasting",
    bibleReference: "Zechariah 7–8",
    chronologicalOrder: 570,
    parentChapterId: null,
    unlockRequirement: "zechariah-night-visions",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Execute true justice; old men and children in the streets.",
  },
  {
    id: "zechariah-oracles-of-the-king",
    book: "zechariah",
    section: "Zechariah",
    displayName: "Oracles of the Coming King",
    bibleReference: "Zechariah 9–11",
    chronologicalOrder: 571,
    parentChapterId: null,
    unlockRequirement: "zechariah-fasting-to-feasting",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "King on a donkey; thirty pieces of silver; worthless shepherd.",
  },
  {
    id: "zechariah-final-oracles",
    book: "zechariah",
    section: "Zechariah",
    displayName: "Final Oracles",
    bibleReference: "Zechariah 12–14",
    chronologicalOrder: 572,
    parentChapterId: null,
    unlockRequirement: "zechariah-oracles-of-the-king",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Pierced one; fountain opened; Lord will be king over all the earth.",
  },
  {
    id: "malachi-gods-love",
    book: "malachi",
    section: "Malachi",
    displayName: "God's Love and Corrupt Priests",
    bibleReference: "Malachi 1–2",
    chronologicalOrder: 573,
    parentChapterId: null,
    unlockRequirement: "zechariah-final-oracles",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "I have loved Jacob; polluted offerings; faithless marriages.",
  },
  {
    id: "malachi-messenger",
    book: "malachi",
    section: "Malachi",
    displayName: "Messenger of the Covenant",
    bibleReference: "Malachi 3–4",
    chronologicalOrder: 574,
    parentChapterId: null,
    unlockRequirement: "malachi-gods-love",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Refiner's fire; tithes; sun of righteousness; Elijah to come.",
  },
  {
    id: "matthew-genealogy",
    book: "matthew",
    section: "Birth & Early Ministry",
    displayName: "Genealogy of Jesus (Matthew)",
    bibleReference: "Matthew 1:1–17",
    chronologicalOrder: 575,
    parentChapterId: null,
    unlockRequirement: "malachi-messenger",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Genealogy",
    description: "Abraham to David to exile to the Christ — fourteen generations.",
  },
  {
    id: "birth-of-jesus-matthew",
    book: "matthew",
    section: "Birth & Early Ministry",
    displayName: "Birth of Jesus (Matthew)",
    bibleReference: "Matthew 1:18–25",
    chronologicalOrder: 576,
    parentChapterId: null,
    unlockRequirement: "matthew-genealogy",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Joseph's dream; Immanuel born.",
  },
  {
    id: "visit-of-the-magi",
    book: "matthew",
    section: "Birth & Early Ministry",
    displayName: "Visit of the Magi",
    bibleReference: "Matthew 2:1–12",
    chronologicalOrder: 577,
    parentChapterId: null,
    unlockRequirement: "birth-of-jesus-matthew",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Story"],
    description: "Star; gifts; worship of the newborn king.",
  },
  {
    id: "flight-to-egypt",
    book: "matthew",
    section: "Birth & Early Ministry",
    displayName: "Flight to Egypt",
    bibleReference: "Matthew 2:13–23",
    chronologicalOrder: 578,
    parentChapterId: null,
    unlockRequirement: "visit-of-the-magi",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Herod's massacre; out of Egypt I called my son.",
  },
  {
    id: "john-the-baptist-matthew",
    book: "matthew",
    section: "Birth & Early Ministry",
    displayName: "John the Baptist (Matthew)",
    bibleReference: "Matthew 3",
    chronologicalOrder: 579,
    parentChapterId: null,
    unlockRequirement: "flight-to-egypt",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Voice in the wilderness; Jesus baptized.",
  },
  {
    id: "temptation-of-jesus",
    book: "matthew",
    section: "Birth & Early Ministry",
    displayName: "Temptation of Jesus",
    bibleReference: "Matthew 4:1–11",
    chronologicalOrder: 580,
    parentChapterId: null,
    unlockRequirement: "john-the-baptist-matthew",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Wilderness testing — Scripture against the tempter.",
  },
  {
    id: "jesus-begins-galilee",
    book: "matthew",
    section: "Birth & Early Ministry",
    displayName: "Jesus Begins in Galilee",
    bibleReference: "Matthew 4:12–25",
    chronologicalOrder: 581,
    parentChapterId: null,
    unlockRequirement: "temptation-of-jesus",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Story"],
    description: "Repent; fishers of men; crowds follow.",
  },
  {
    id: "sermon-on-the-mount",
    book: "matthew",
    section: "Sermon on the Mount",
    displayName: "Sermon on the Mount",
    bibleReference: "Matthew 5–7",
    chronologicalOrder: 582,
    parentChapterId: null,
    unlockRequirement: "jesus-begins-galilee",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Kingdom ethic from the mountain.",
  },
  {
    id: "beatitudes",
    book: "matthew",
    section: "Sermon on the Mount",
    displayName: "The Beatitudes",
    bibleReference: "Matthew 5:1–12",
    chronologicalOrder: 583,
    parentChapterId: null,
    unlockRequirement: "sermon-on-the-mount",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Blessed are the poor in spirit…",
  },
  {
    id: "antitheses",
    book: "matthew",
    section: "Sermon on the Mount",
    displayName: "Antitheses of the Law",
    bibleReference: "Matthew 5:17–48",
    chronologicalOrder: 584,
    parentChapterId: null,
    unlockRequirement: "beatitudes",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "You have heard… but I say to you.",
  },
  {
    id: "lords-prayer-matthew",
    book: "matthew",
    section: "Sermon on the Mount",
    displayName: "The Lord's Prayer",
    bibleReference: "Matthew 6:5–15",
    chronologicalOrder: 585,
    parentChapterId: null,
    unlockRequirement: "antitheses",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Pray then like this.",
  },
  {
    id: "two-ways-matthew",
    book: "matthew",
    section: "Sermon on the Mount",
    displayName: "Two Ways",
    bibleReference: "Matthew 7:13–29",
    chronologicalOrder: 586,
    parentChapterId: null,
    unlockRequirement: "lords-prayer-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Narrow gate; house on rock or sand.",
  },
  {
    id: "matthew-healing-series",
    book: "matthew",
    section: "Miracles & Mission",
    displayName: "Healing Series",
    bibleReference: "Matthew 8–9",
    chronologicalOrder: 587,
    parentChapterId: null,
    unlockRequirement: "two-ways-matthew",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Exploration"],
    description: "Leper, centurion, storms, demoniacs, paralytic, ruler's daughter.",
  },
  {
    id: "matthew-mission-of-twelve",
    book: "matthew",
    section: "Miracles & Mission",
    displayName: "Mission of the Twelve",
    bibleReference: "Matthew 10",
    chronologicalOrder: 588,
    parentChapterId: null,
    unlockRequirement: "matthew-healing-series",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Teaching"],
    description: "Sent to the lost sheep of Israel.",
  },
  {
    id: "matthew-johns-question",
    book: "matthew",
    section: "Miracles & Mission",
    displayName: "John's Question and Woes",
    bibleReference: "Matthew 11",
    chronologicalOrder: 589,
    parentChapterId: null,
    unlockRequirement: "matthew-mission-of-twelve",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Are you the one? Come to me, all who labor.",
  },
  {
    id: "matthew-lord-of-sabbath",
    book: "matthew",
    section: "Miracles & Mission",
    displayName: "Lord of the Sabbath",
    bibleReference: "Matthew 12",
    chronologicalOrder: 590,
    parentChapterId: null,
    unlockRequirement: "matthew-johns-question",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Greater than the temple; sign of Jonah.",
  },
  {
    id: "parable-sower-matthew",
    book: "matthew",
    section: "Parables of the Kingdom",
    displayName: "Parable of the Sower",
    bibleReference: "Matthew 13:1–23",
    chronologicalOrder: 591,
    parentChapterId: null,
    unlockRequirement: "matthew-lord-of-sabbath",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Four soils; hearing the word of the kingdom.",
  },
  {
    id: "parable-weeds",
    book: "matthew",
    section: "Parables of the Kingdom",
    displayName: "Parable of the Weeds",
    bibleReference: "Matthew 13:24–30, 36–43",
    chronologicalOrder: 592,
    parentChapterId: null,
    unlockRequirement: "parable-sower-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Wheat and weeds until harvest.",
  },
  {
    id: "parable-mustard-leaven",
    book: "matthew",
    section: "Parables of the Kingdom",
    displayName: "Mustard Seed and Leaven",
    bibleReference: "Matthew 13:31–33",
    chronologicalOrder: 593,
    parentChapterId: null,
    unlockRequirement: "parable-weeds",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Kingdom growth from small beginnings.",
  },
  {
    id: "parable-hidden-treasure-pearl",
    book: "matthew",
    section: "Parables of the Kingdom",
    displayName: "Hidden Treasure and Pearl",
    bibleReference: "Matthew 13:44–46",
    chronologicalOrder: 594,
    parentChapterId: null,
    unlockRequirement: "parable-mustard-leaven",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Joyful surrender for the kingdom's worth.",
  },
  {
    id: "parable-net",
    book: "matthew",
    section: "Parables of the Kingdom",
    displayName: "Parable of the Net",
    bibleReference: "Matthew 13:47–50",
    chronologicalOrder: 595,
    parentChapterId: null,
    unlockRequirement: "parable-hidden-treasure-pearl",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Good fish and bad sorted at the end of the age.",
  },
  {
    id: "feeding-five-thousand-matthew",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Feeding the Five Thousand",
    bibleReference: "Matthew 14:13–21",
    chronologicalOrder: 596,
    parentChapterId: null,
    unlockRequirement: "parable-net",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Five loaves and two fish.",
  },
  {
    id: "walking-on-water-matthew",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Walking on Water",
    bibleReference: "Matthew 14:22–33",
    chronologicalOrder: 597,
    parentChapterId: null,
    unlockRequirement: "feeding-five-thousand-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Take heart; it is I.",
  },
  {
    id: "peters-confession-matthew",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Peter's Confession",
    bibleReference: "Matthew 16:13–28",
    chronologicalOrder: 598,
    parentChapterId: null,
    unlockRequirement: "walking-on-water-matthew",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "You are the Christ; take up your cross.",
  },
  {
    id: "transfiguration-matthew",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Transfiguration",
    bibleReference: "Matthew 17:1–13",
    chronologicalOrder: 599,
    parentChapterId: null,
    unlockRequirement: "peters-confession-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Face shining like the sun; This is my beloved Son.",
  },
  {
    id: "temple-tax-and-humility",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Temple Tax and Humility",
    bibleReference: "Matthew 17:24–18:14",
    chronologicalOrder: 600,
    parentChapterId: null,
    unlockRequirement: "transfiguration-matthew",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Teaching"],
    description: "Coin in the fish; become like children.",
  },
  {
    id: "parable-unforgiving-servant",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Unforgiving Servant",
    bibleReference: "Matthew 18:21–35",
    chronologicalOrder: 601,
    parentChapterId: null,
    unlockRequirement: "temple-tax-and-humility",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Forgive seventy times seven.",
  },
  {
    id: "teaching-on-divorce-riches",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Divorce, Children, and Riches",
    bibleReference: "Matthew 19",
    chronologicalOrder: 602,
    parentChapterId: null,
    unlockRequirement: "parable-unforgiving-servant",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "What God has joined; rich young man.",
  },
  {
    id: "parable-laborers-vineyard",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Laborers in the Vineyard",
    bibleReference: "Matthew 20:1–16",
    chronologicalOrder: 603,
    parentChapterId: null,
    unlockRequirement: "teaching-on-divorce-riches",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Last will be first — generous master.",
  },
  {
    id: "triumphal-entry-matthew",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Triumphal Entry",
    bibleReference: "Matthew 21:1–11",
    chronologicalOrder: 604,
    parentChapterId: null,
    unlockRequirement: "parable-laborers-vineyard",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Hosanna to the Son of David.",
  },
  {
    id: "temple-cleansing-matthew",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Temple Cleansing",
    bibleReference: "Matthew 21:12–17",
    chronologicalOrder: 605,
    parentChapterId: null,
    unlockRequirement: "triumphal-entry-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "House of prayer; children's praise.",
  },
  {
    id: "parable-two-sons-tenants-wedding",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Two Sons, Tenants, and Wedding Feast",
    bibleReference: "Matthew 21:28–22:14",
    chronologicalOrder: 606,
    parentChapterId: null,
    unlockRequirement: "temple-cleansing-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Kingdom transferred; invitation refused.",
  },
  {
    id: "questions-in-the-temple-matthew",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Questions in the Temple",
    bibleReference: "Matthew 22:15–46",
    chronologicalOrder: 607,
    parentChapterId: null,
    unlockRequirement: "parable-two-sons-tenants-wedding",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Taxes, resurrection, great commandment, David's Lord.",
  },
  {
    id: "seven-woes",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Seven Woes",
    bibleReference: "Matthew 23",
    chronologicalOrder: 608,
    parentChapterId: null,
    unlockRequirement: "questions-in-the-temple-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Woe to you, scribes and Pharisees, hypocrites.",
  },
  {
    id: "olivet-discourse-matthew",
    book: "matthew",
    section: "Toward Jerusalem",
    displayName: "Olivet Discourse",
    bibleReference: "Matthew 24–25",
    chronologicalOrder: 609,
    parentChapterId: null,
    unlockRequirement: "seven-woes",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Prophecy", "Teaching"],
    description: "Signs; ten virgins; talents; sheep and goats.",
  },
  {
    id: "last-supper-matthew",
    book: "matthew",
    section: "Passion & Resurrection",
    displayName: "Last Supper",
    bibleReference: "Matthew 26:1–35",
    chronologicalOrder: 610,
    parentChapterId: null,
    unlockRequirement: "olivet-discourse-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Passover; betrayal foretold; bread and cup.",
  },
  {
    id: "gethsemane-matthew",
    book: "matthew",
    section: "Passion & Resurrection",
    displayName: "Gethsemane",
    bibleReference: "Matthew 26:36–56",
    chronologicalOrder: 611,
    parentChapterId: null,
    unlockRequirement: "last-supper-matthew",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Not as I will, but as you will.",
  },
  {
    id: "trial-of-jesus-matthew",
    book: "matthew",
    section: "Passion & Resurrection",
    displayName: "Trial of Jesus",
    bibleReference: "Matthew 26:57–27:26",
    chronologicalOrder: 612,
    parentChapterId: null,
    unlockRequirement: "gethsemane-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Sanhedrin; Peter's denial; Pilate; Barabbas.",
  },
  {
    id: "crucifixion-matthew",
    book: "matthew",
    section: "Passion & Resurrection",
    displayName: "Crucifixion",
    bibleReference: "Matthew 27:27–66",
    chronologicalOrder: 613,
    parentChapterId: null,
    unlockRequirement: "trial-of-jesus-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Mockery; darkness; veil torn; burial.",
  },
  {
    id: "resurrection-matthew",
    book: "matthew",
    section: "Passion & Resurrection",
    displayName: "Resurrection",
    bibleReference: "Matthew 28:1–15",
    chronologicalOrder: 614,
    parentChapterId: null,
    unlockRequirement: "crucifixion-matthew",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "He is not here, for he has risen.",
  },
  {
    id: "great-commission",
    book: "matthew",
    section: "Passion & Resurrection",
    displayName: "Great Commission",
    bibleReference: "Matthew 28:16–20",
    chronologicalOrder: 615,
    parentChapterId: null,
    unlockRequirement: "resurrection-matthew",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Make disciples of all nations.",
  },
  {
    id: "mark-beginning",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Beginning of the Gospel",
    bibleReference: "Mark 1",
    chronologicalOrder: 616,
    parentChapterId: null,
    unlockRequirement: "great-commission",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Baptist; baptism; temptation; first healings and preaching.",
  },
  {
    id: "mark-authority-contested",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Authority Contested",
    bibleReference: "Mark 2–3",
    chronologicalOrder: 617,
    parentChapterId: null,
    unlockRequirement: "mark-beginning",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Paralytic forgiven; Sabbath Lord; family and opponents.",
  },
  {
    id: "mark-parables",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Kingdom Parables (Mark)",
    bibleReference: "Mark 4",
    chronologicalOrder: 618,
    parentChapterId: null,
    unlockRequirement: "mark-authority-contested",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Sower; lamp; seed growing secretly; mustard seed.",
  },
  {
    id: "mark-power-over-chaos",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Power over Chaos",
    bibleReference: "Mark 4:35–5:43",
    chronologicalOrder: 619,
    parentChapterId: null,
    unlockRequirement: "mark-parables",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Storm stilled; Legion; hemorrhaging woman; Jairus' daughter.",
  },
  {
    id: "mark-rejected-and-sends",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Rejected at Home; Twelve Sent",
    bibleReference: "Mark 6:1–13",
    chronologicalOrder: 620,
    parentChapterId: null,
    unlockRequirement: "mark-power-over-chaos",
    status: "comingSoon",
    estimatedGameplayType: "Journey",
    description: "Prophet without honor; mission with staff and sandals.",
  },
  {
    id: "mark-baptist-death",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Death of John the Baptist",
    bibleReference: "Mark 6:14–29",
    chronologicalOrder: 621,
    parentChapterId: null,
    unlockRequirement: "mark-rejected-and-sends",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Herod's banquet and the prophet's head.",
  },
  {
    id: "mark-feedings-and-walking",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Feedings and Walking on Water",
    bibleReference: "Mark 6:30–56",
    chronologicalOrder: 622,
    parentChapterId: null,
    unlockRequirement: "mark-baptist-death",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Five thousand fed; ghost on the sea.",
  },
  {
    id: "mark-tradition-and-gentiles",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Tradition and Gentile Faith",
    bibleReference: "Mark 7",
    chronologicalOrder: 623,
    parentChapterId: null,
    unlockRequirement: "mark-feedings-and-walking",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Story"],
    description: "What defiles; Syrophoenician woman's faith.",
  },
  {
    id: "mark-confession-and-cross",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Confession and the Cross",
    bibleReference: "Mark 8–9:1",
    chronologicalOrder: 624,
    parentChapterId: null,
    unlockRequirement: "mark-tradition-and-gentiles",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "You are the Christ; deny yourself.",
  },
  {
    id: "mark-transfiguration-exorcism",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Transfiguration and Hard Exorcism",
    bibleReference: "Mark 9:2–29",
    chronologicalOrder: 625,
    parentChapterId: null,
    unlockRequirement: "mark-confession-and-cross",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Beloved Son; this kind by prayer.",
  },
  {
    id: "mark-discipleship-on-the-way",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Discipleship on the Way",
    bibleReference: "Mark 9:30–10:52",
    chronologicalOrder: 626,
    parentChapterId: null,
    unlockRequirement: "mark-transfiguration-exorcism",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Servanthood; divorce; rich man; Bartimaeus.",
  },
  {
    id: "mark-jerusalem-ministry",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Jerusalem Ministry",
    bibleReference: "Mark 11–12",
    chronologicalOrder: 627,
    parentChapterId: null,
    unlockRequirement: "mark-discipleship-on-the-way",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Entry; fig tree; tenants; greatest commandment; widow's mite.",
  },
  {
    id: "mark-olivet",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Olivet Discourse (Mark)",
    bibleReference: "Mark 13",
    chronologicalOrder: 628,
    parentChapterId: null,
    unlockRequirement: "mark-jerusalem-ministry",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Watch — no one knows the day or hour.",
  },
  {
    id: "mark-passion",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Passion (Mark)",
    bibleReference: "Mark 14–15",
    chronologicalOrder: 629,
    parentChapterId: null,
    unlockRequirement: "mark-olivet",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Anointing; supper; Gethsemane; trials; crucifixion.",
  },
  {
    id: "mark-resurrection",
    book: "mark",
    section: "Gospel of Mark",
    displayName: "Resurrection (Mark)",
    bibleReference: "Mark 16",
    chronologicalOrder: 630,
    parentChapterId: null,
    unlockRequirement: "mark-passion",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Empty tomb; trembling and astonishment; longer ending witness.",
  },
  {
    id: "luke-prologue",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Luke's Prologue",
    bibleReference: "Luke 1:1–4",
    chronologicalOrder: 631,
    parentChapterId: null,
    unlockRequirement: "mark-resurrection",
    status: "comingSoon",
    estimatedGameplayType: "Educational Module",
    description: "Orderly account for Theophilus.",
  },
  {
    id: "annunciations",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Annunciations to Zechariah and Mary",
    bibleReference: "Luke 1:5–56",
    chronologicalOrder: 632,
    parentChapterId: null,
    unlockRequirement: "luke-prologue",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "John promised; Magnificat.",
  },
  {
    id: "birth-of-john",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Birth of John",
    bibleReference: "Luke 1:57–80",
    chronologicalOrder: 633,
    parentChapterId: null,
    unlockRequirement: "annunciations",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Benedictus — the dawn from on high.",
  },
  {
    id: "birth-of-jesus-luke",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Birth of Jesus (Luke)",
    bibleReference: "Luke 2:1–20",
    chronologicalOrder: 634,
    parentChapterId: null,
    unlockRequirement: "birth-of-john",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Census; manger; shepherds and angels.",
  },
  {
    id: "presentation-and-boy-jesus",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Presentation and Boy Jesus",
    bibleReference: "Luke 2:21–52",
    chronologicalOrder: 635,
    parentChapterId: null,
    unlockRequirement: "birth-of-jesus-luke",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Simeon and Anna; about my Father's business.",
  },
  {
    id: "luke-baptist-and-genealogy",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Baptist and Genealogy (Luke)",
    bibleReference: "Luke 3",
    chronologicalOrder: 636,
    parentChapterId: null,
    unlockRequirement: "presentation-and-boy-jesus",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Genealogy"],
    description: "Baptism; Adam to Christ genealogy.",
  },
  {
    id: "luke-temptation-nazareth",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Temptation and Nazareth Sermon",
    bibleReference: "Luke 4",
    chronologicalOrder: 637,
    parentChapterId: null,
    unlockRequirement: "luke-baptist-and-genealogy",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Story"],
    description: "Isaiah fulfilled; prophet not accepted in hometown.",
  },
  {
    id: "luke-early-miracles-call",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Early Miracles and Call",
    bibleReference: "Luke 5–6",
    chronologicalOrder: 638,
    parentChapterId: null,
    unlockRequirement: "luke-temptation-nazareth",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Catch of fish; twelve appointed; sermon on the plain.",
  },
  {
    id: "luke-centurion-widow-son",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Centurion and Widow's Son",
    bibleReference: "Luke 7:1–17",
    chronologicalOrder: 639,
    parentChapterId: null,
    unlockRequirement: "luke-early-miracles-call",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Authority and compassion in Capernaum and Nain.",
  },
  {
    id: "luke-sinful-woman",
    book: "luke",
    section: "Birth & Galilean Ministry",
    displayName: "Sinful Woman Forgiven",
    bibleReference: "Luke 7:36–50",
    chronologicalOrder: 640,
    parentChapterId: null,
    unlockRequirement: "luke-centurion-widow-son",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Who loves more? Your faith has saved you.",
  },
  {
    id: "parable-good-samaritan",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Parable of the Good Samaritan",
    bibleReference: "Luke 10:25–37",
    chronologicalOrder: 641,
    parentChapterId: null,
    unlockRequirement: "luke-sinful-woman",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Who is my neighbor?",
  },
  {
    id: "mary-and-martha",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Mary and Martha",
    bibleReference: "Luke 10:38–42",
    chronologicalOrder: 642,
    parentChapterId: null,
    unlockRequirement: "parable-good-samaritan",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "One thing is necessary.",
  },
  {
    id: "luke-lords-prayer-persistence",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Lord's Prayer and Persistence",
    bibleReference: "Luke 11:1–13",
    chronologicalOrder: 643,
    parentChapterId: null,
    unlockRequirement: "mary-and-martha",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Ask, seek, knock.",
  },
  {
    id: "parable-rich-fool",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Parable of the Rich Fool",
    bibleReference: "Luke 12:13–21",
    chronologicalOrder: 644,
    parentChapterId: null,
    unlockRequirement: "luke-lords-prayer-persistence",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Fool — this night your soul is required.",
  },
  {
    id: "parable-barren-fig-mustard",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Barren Fig; Mustard and Leaven",
    bibleReference: "Luke 13",
    chronologicalOrder: 645,
    parentChapterId: null,
    unlockRequirement: "parable-rich-fool",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Repent or perish; kingdom growth.",
  },
  {
    id: "parable-great-banquet-luke",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Great Banquet",
    bibleReference: "Luke 14",
    chronologicalOrder: 646,
    parentChapterId: null,
    unlockRequirement: "parable-barren-fig-mustard",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Invite the poor; count the cost of discipleship.",
  },
  {
    id: "parables-lost-sheep-coin-son",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Lost Sheep, Coin, and Son",
    bibleReference: "Luke 15",
    chronologicalOrder: 647,
    parentChapterId: null,
    unlockRequirement: "parable-great-banquet-luke",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Joy in heaven over one sinner who repents.",
  },
  {
    id: "parable-shrewd-manager-rich-man",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Shrewd Manager and Rich Man & Lazarus",
    bibleReference: "Luke 16",
    chronologicalOrder: 648,
    parentChapterId: null,
    unlockRequirement: "parables-lost-sheep-coin-son",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Faithful in little; chasm fixed.",
  },
  {
    id: "ten-lepers",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Ten Lepers",
    bibleReference: "Luke 17:11–19",
    chronologicalOrder: 649,
    parentChapterId: null,
    unlockRequirement: "parable-shrewd-manager-rich-man",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "One returns — a Samaritan — to give thanks.",
  },
  {
    id: "parable-persistent-widow-pharisee",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Persistent Widow and Pharisee & Tax Collector",
    bibleReference: "Luke 18:1–14",
    chronologicalOrder: 650,
    parentChapterId: null,
    unlockRequirement: "ten-lepers",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Pray always; God be merciful to me, a sinner.",
  },
  {
    id: "zacchaeus",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Zacchaeus",
    bibleReference: "Luke 19:1–10",
    chronologicalOrder: 651,
    parentChapterId: null,
    unlockRequirement: "parable-persistent-widow-pharisee",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Son of Man came to seek and to save the lost.",
  },
  {
    id: "parable-minas",
    book: "luke",
    section: "Parables & Journey",
    displayName: "Parable of the Minas",
    bibleReference: "Luke 19:11–27",
    chronologicalOrder: 652,
    parentChapterId: null,
    unlockRequirement: "zacchaeus",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Do business until I come.",
  },
  {
    id: "luke-entry-temple",
    book: "luke",
    section: "Passion & Resurrection",
    displayName: "Entry and Temple Teaching",
    bibleReference: "Luke 19:28–21:38",
    chronologicalOrder: 653,
    parentChapterId: null,
    unlockRequirement: "parable-minas",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Interactive Prophecy"],
    description: "Weeping over Jerusalem; widow's mite; Olivet signs.",
  },
  {
    id: "luke-last-supper",
    book: "luke",
    section: "Passion & Resurrection",
    displayName: "Last Supper (Luke)",
    bibleReference: "Luke 22:1–38",
    chronologicalOrder: 654,
    parentChapterId: null,
    unlockRequirement: "luke-entry-temple",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "New covenant in my blood; dispute about greatness.",
  },
  {
    id: "luke-arrest-trials",
    book: "luke",
    section: "Passion & Resurrection",
    displayName: "Arrest and Trials (Luke)",
    bibleReference: "Luke 22:39–23:25",
    chronologicalOrder: 655,
    parentChapterId: null,
    unlockRequirement: "luke-last-supper",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Sweat like blood; before council, Pilate, and Herod.",
  },
  {
    id: "luke-crucifixion",
    book: "luke",
    section: "Passion & Resurrection",
    displayName: "Crucifixion (Luke)",
    bibleReference: "Luke 23:26–56",
    chronologicalOrder: 656,
    parentChapterId: null,
    unlockRequirement: "luke-arrest-trials",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Father forgive them; paradise today; centurion's praise.",
  },
  {
    id: "emmaus-road",
    book: "luke",
    section: "Passion & Resurrection",
    displayName: "Road to Emmaus",
    bibleReference: "Luke 24:13–35",
    chronologicalOrder: 657,
    parentChapterId: null,
    unlockRequirement: "luke-crucifixion",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Dialogue"],
    description: "Scriptures opened; known in the breaking of bread.",
  },
  {
    id: "luke-resurrection-appearances",
    book: "luke",
    section: "Passion & Resurrection",
    displayName: "Resurrection Appearances (Luke)",
    bibleReference: "Luke 24:36–53",
    chronologicalOrder: 658,
    parentChapterId: null,
    unlockRequirement: "emmaus-road",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Peace be with you; ascension blessing.",
  },
  {
    id: "john-prologue",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Prologue — The Word",
    bibleReference: "John 1:1–18",
    chronologicalOrder: 659,
    parentChapterId: null,
    unlockRequirement: "luke-resurrection-appearances",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "In the beginning was the Word.",
  },
  {
    id: "john-first-disciples",
    book: "john",
    section: "Signs & Discourses",
    displayName: "First Disciples",
    bibleReference: "John 1:19–51",
    chronologicalOrder: 660,
    parentChapterId: null,
    unlockRequirement: "john-prologue",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "Behold the Lamb; come and see.",
  },
  {
    id: "wedding-at-cana",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Wedding at Cana",
    bibleReference: "John 2:1–12",
    chronologicalOrder: 661,
    parentChapterId: null,
    unlockRequirement: "john-first-disciples",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "First sign — water to wine.",
  },
  {
    id: "temple-cleansing-john",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Temple Cleansing (John)",
    bibleReference: "John 2:13–25",
    chronologicalOrder: 662,
    parentChapterId: null,
    unlockRequirement: "wedding-at-cana",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Zeal for your house will consume me.",
  },
  {
    id: "nicodemus",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Nicodemus",
    bibleReference: "John 3",
    chronologicalOrder: 663,
    parentChapterId: null,
    unlockRequirement: "temple-cleansing-john",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Teaching"],
    description: "You must be born again; God so loved the world.",
  },
  {
    id: "woman-at-the-well",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Woman at the Well",
    bibleReference: "John 4",
    chronologicalOrder: 664,
    parentChapterId: null,
    unlockRequirement: "nicodemus",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Story"],
    description: "Living water; Messiah declared; harvest white.",
  },
  {
    id: "healing-at-bethesda",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Healing at Bethesda",
    bibleReference: "John 5",
    chronologicalOrder: 665,
    parentChapterId: null,
    unlockRequirement: "woman-at-the-well",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Rise, take up your bed; equality with the Father.",
  },
  {
    id: "feeding-and-bread-of-life",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Feeding and Bread of Life",
    bibleReference: "John 6",
    chronologicalOrder: 666,
    parentChapterId: null,
    unlockRequirement: "healing-at-bethesda",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Teaching"],
    description: "Five thousand; walking on water; I am the bread of life.",
  },
  {
    id: "living-water-and-light",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Living Water and Light of the World",
    bibleReference: "John 7–8",
    chronologicalOrder: 667,
    parentChapterId: null,
    unlockRequirement: "feeding-and-bread-of-life",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Dialogue"],
    description: "Streams of living water; before Abraham was, I am.",
  },
  {
    id: "man-born-blind",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Man Born Blind",
    bibleReference: "John 9",
    chronologicalOrder: 668,
    parentChapterId: null,
    unlockRequirement: "living-water-and-light",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "I was blind, now I see.",
  },
  {
    id: "good-shepherd",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Good Shepherd",
    bibleReference: "John 10",
    chronologicalOrder: 669,
    parentChapterId: null,
    unlockRequirement: "man-born-blind",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "I lay down my life for the sheep.",
  },
  {
    id: "lazarus-raised",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Lazarus Raised",
    bibleReference: "John 11",
    chronologicalOrder: 670,
    parentChapterId: null,
    unlockRequirement: "good-shepherd",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "I am the resurrection and the life.",
  },
  {
    id: "mary-anoints-jesus",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Mary Anoints Jesus",
    bibleReference: "John 12:1–11",
    chronologicalOrder: 671,
    parentChapterId: null,
    unlockRequirement: "lazarus-raised",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Perfume for burial; poor always with you.",
  },
  {
    id: "triumphal-entry-john",
    book: "john",
    section: "Signs & Discourses",
    displayName: "Triumphal Entry (John)",
    bibleReference: "John 12:12–50",
    chronologicalOrder: 672,
    parentChapterId: null,
    unlockRequirement: "mary-anoints-jesus",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "Greeks seek Jesus; lifted up, I will draw all people.",
  },
  {
    id: "footwashing",
    book: "john",
    section: "Upper Room to Resurrection",
    displayName: "Footwashing",
    bibleReference: "John 13",
    chronologicalOrder: 673,
    parentChapterId: null,
    unlockRequirement: "triumphal-entry-john",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Teaching"],
    description: "If I then, your Lord and Teacher, have washed your feet…",
  },
  {
    id: "farewell-discourse",
    book: "john",
    section: "Upper Room to Resurrection",
    displayName: "Farewell Discourse",
    bibleReference: "John 14–16",
    chronologicalOrder: 674,
    parentChapterId: null,
    unlockRequirement: "footwashing",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Way, truth, life; vine and branches; Spirit of truth.",
  },
  {
    id: "high-priestly-prayer",
    book: "john",
    section: "Upper Room to Resurrection",
    displayName: "High Priestly Prayer",
    bibleReference: "John 17",
    chronologicalOrder: 675,
    parentChapterId: null,
    unlockRequirement: "farewell-discourse",
    status: "comingSoon",
    estimatedGameplayType: "Dialogue",
    description: "That they may be one as we are one.",
  },
  {
    id: "john-arrest-trials",
    book: "john",
    section: "Upper Room to Resurrection",
    displayName: "Arrest and Trials (John)",
    bibleReference: "John 18",
    chronologicalOrder: 676,
    parentChapterId: null,
    unlockRequirement: "high-priestly-prayer",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "I am he; Peter's denial; kingdom not of this world.",
  },
  {
    id: "john-crucifixion",
    book: "john",
    section: "Upper Room to Resurrection",
    displayName: "Crucifixion (John)",
    bibleReference: "John 19",
    chronologicalOrder: 677,
    parentChapterId: null,
    unlockRequirement: "john-arrest-trials",
    status: "comingSoon",
    estimatedGameplayType: "Cutscene",
    description: "It is finished; blood and water; burial by Joseph and Nicodemus.",
  },
  {
    id: "john-resurrection",
    book: "john",
    section: "Upper Room to Resurrection",
    displayName: "Resurrection (John)",
    bibleReference: "John 20",
    chronologicalOrder: 678,
    parentChapterId: null,
    unlockRequirement: "john-crucifixion",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Mary Magdalene; peace; Thomas — my Lord and my God.",
  },
  {
    id: "john-breakfast-by-the-sea",
    book: "john",
    section: "Upper Room to Resurrection",
    displayName: "Breakfast by the Sea",
    bibleReference: "John 21",
    chronologicalOrder: 679,
    parentChapterId: null,
    unlockRequirement: "john-resurrection",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Catch of fish; do you love me? Feed my sheep.",
  },
  {
    id: "ascension-and-successor",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Ascension and Matthias",
    bibleReference: "Acts 1",
    chronologicalOrder: 680,
    parentChapterId: null,
    unlockRequirement: "john-breakfast-by-the-sea",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "You will be my witnesses; lot falls on Matthias.",
  },
  {
    id: "pentecost",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Pentecost",
    bibleReference: "Acts 2",
    chronologicalOrder: 681,
    parentChapterId: null,
    unlockRequirement: "ascension-and-successor",
    status: "comingSoon",
    estimatedGameplayType: ["Cutscene", "Story"],
    description: "Spirit poured out; Peter's sermon; three thousand added.",
  },
  {
    id: "lame-man-healed-acts",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Lame Man Healed",
    bibleReference: "Acts 3–4",
    chronologicalOrder: 682,
    parentChapterId: null,
    unlockRequirement: "pentecost",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Dialogue"],
    description: "Silver and gold I have none; no other name under heaven.",
  },
  {
    id: "ananiahs-and-sapphira",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Ananias and Sapphira",
    bibleReference: "Acts 5:1–11",
    chronologicalOrder: 683,
    parentChapterId: null,
    unlockRequirement: "lame-man-healed-acts",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Lying to the Holy Spirit.",
  },
  {
    id: "apostles-persecuted",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Apostles Persecuted",
    bibleReference: "Acts 5:12–42",
    chronologicalOrder: 684,
    parentChapterId: null,
    unlockRequirement: "ananiahs-and-sapphira",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "We must obey God rather than men.",
  },
  {
    id: "seven-chosen",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Seven Chosen",
    bibleReference: "Acts 6",
    chronologicalOrder: 685,
    parentChapterId: null,
    unlockRequirement: "apostles-persecuted",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Servants for the widows; Stephen full of grace.",
  },
  {
    id: "stephens-speech-and-death",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Stephen's Speech and Death",
    bibleReference: "Acts 7",
    chronologicalOrder: 686,
    parentChapterId: null,
    unlockRequirement: "seven-chosen",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Story"],
    description: "History of Israel; first martyr; Saul approving.",
  },
  {
    id: "philip-in-samaria-and-eunuch",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Philip in Samaria and the Ethiopian",
    bibleReference: "Acts 8",
    chronologicalOrder: 687,
    parentChapterId: null,
    unlockRequirement: "stephens-speech-and-death",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Story"],
    description: "Simon the magician; chariot Bible study; baptism.",
  },
  {
    id: "sauls-conversion",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Saul's Conversion",
    bibleReference: "Acts 9:1–31",
    chronologicalOrder: 688,
    parentChapterId: null,
    unlockRequirement: "philip-in-samaria-and-eunuch",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Cutscene"],
    description: "Road to Damascus; scales fall; Barnabas advocates.",
  },
  {
    id: "peter-aeneas-dorcas",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Aeneas and Dorcas",
    bibleReference: "Acts 9:32–43",
    chronologicalOrder: 689,
    parentChapterId: null,
    unlockRequirement: "sauls-conversion",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Peter's healings in Lydda and Joppa.",
  },
  {
    id: "cornelius",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Cornelius",
    bibleReference: "Acts 10–11:18",
    chronologicalOrder: 690,
    parentChapterId: null,
    unlockRequirement: "peter-aeneas-dorcas",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Sheet vision; Gentiles receive the Spirit.",
  },
  {
    id: "church-at-antioch",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Church at Antioch",
    bibleReference: "Acts 11:19–30",
    chronologicalOrder: 691,
    parentChapterId: null,
    unlockRequirement: "cornelius",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Called Christians; relief for Judea.",
  },
  {
    id: "peter-freed-from-prison",
    book: "acts",
    section: "Jerusalem & Judea",
    displayName: "Peter Freed from Prison",
    bibleReference: "Acts 12",
    chronologicalOrder: 692,
    parentChapterId: null,
    unlockRequirement: "church-at-antioch",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Angel opens the gate; Herod struck down.",
  },
  {
    id: "first-missionary-journey",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "First Missionary Journey",
    bibleReference: "Acts 13–14",
    chronologicalOrder: 693,
    parentChapterId: null,
    unlockRequirement: "peter-freed-from-prison",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Story"],
    description: "Cyprus to Galatia; Jews and Gentiles; stoning at Lystra.",
  },
  {
    id: "jerusalem-council",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Jerusalem Council",
    bibleReference: "Acts 15:1–35",
    chronologicalOrder: 694,
    parentChapterId: null,
    unlockRequirement: "first-missionary-journey",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Dialogue"],
    description: "Salvation by grace; letter to Gentile believers.",
  },
  {
    id: "second-missionary-journey",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Second Missionary Journey",
    bibleReference: "Acts 15:36–18:22",
    chronologicalOrder: 695,
    parentChapterId: null,
    unlockRequirement: "jerusalem-council",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Story"],
    description: "Macedonia call; Philippi; Thessalonica; Athens; Corinth.",
  },
  {
    id: "philippi-conversion-stories",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Philippi Conversions",
    bibleReference: "Acts 16",
    chronologicalOrder: 696,
    parentChapterId: null,
    unlockRequirement: "second-missionary-journey",
    status: "comingSoon",
    estimatedGameplayType: ["Story", "Decision"],
    description: "Lydia; earthquake; jailer's household.",
  },
  {
    id: "paul-in-athens",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Paul in Athens",
    bibleReference: "Acts 17:16–34",
    chronologicalOrder: 697,
    parentChapterId: null,
    unlockRequirement: "philippi-conversion-stories",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Teaching"],
    description: "Altar to an unknown god; Areopagus address.",
  },
  {
    id: "third-missionary-journey",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Third Missionary Journey",
    bibleReference: "Acts 18:23–21:16",
    chronologicalOrder: 698,
    parentChapterId: null,
    unlockRequirement: "paul-in-athens",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Story"],
    description: "Ephesus riot; Macedonia; farewell to elders.",
  },
  {
    id: "ephesus-riot",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Ephesus Riot",
    bibleReference: "Acts 19",
    chronologicalOrder: 699,
    parentChapterId: null,
    unlockRequirement: "third-missionary-journey",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Sons of Sceva; books burned; great is Artemis.",
  },
  {
    id: "paul-arrested-in-jerusalem",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Paul Arrested in Jerusalem",
    bibleReference: "Acts 21–23",
    chronologicalOrder: 700,
    parentChapterId: null,
    unlockRequirement: "ephesus-riot",
    status: "comingSoon",
    estimatedGameplayType: "Story",
    description: "Temple uproar; defenses; plot; transfer to Felix.",
  },
  {
    id: "paul-before-felix-festus-agrippa",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Before Felix, Festus, and Agrippa",
    bibleReference: "Acts 24–26",
    chronologicalOrder: 701,
    parentChapterId: null,
    unlockRequirement: "paul-arrested-in-jerusalem",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Story"],
    description: "Almost you persuade me to be a Christian.",
  },
  {
    id: "voyage-to-rome",
    book: "acts",
    section: "Missionary Journeys",
    displayName: "Voyage to Rome",
    bibleReference: "Acts 27–28",
    chronologicalOrder: 702,
    parentChapterId: null,
    unlockRequirement: "paul-before-felix-festus-agrippa",
    status: "comingSoon",
    estimatedGameplayType: ["Journey", "Story"],
    description: "Storm; shipwreck on Malta; gospel unhindered in Rome.",
  },
  {
    id: "romans-gospel-of-god",
    book: "romans",
    section: "Romans",
    displayName: "Gospel of God",
    bibleReference: "Romans 1:1–17",
    chronologicalOrder: 703,
    parentChapterId: null,
    unlockRequirement: "voyage-to-rome",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Not ashamed of the gospel — righteousness by faith.",
  },
  {
    id: "romans-universal-sin",
    book: "romans",
    section: "Romans",
    displayName: "Universal Sin",
    bibleReference: "Romans 1:18–3:20",
    chronologicalOrder: 704,
    parentChapterId: null,
    unlockRequirement: "romans-gospel-of-god",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "All have sinned; Jews and Greeks under sin.",
  },
  {
    id: "romans-justification",
    book: "romans",
    section: "Romans",
    displayName: "Justification by Faith",
    bibleReference: "Romans 3:21–5:21",
    chronologicalOrder: 705,
    parentChapterId: null,
    unlockRequirement: "romans-universal-sin",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Abraham justified; peace with God; Adam and Christ.",
  },
  {
    id: "romans-sanctification",
    book: "romans",
    section: "Romans",
    displayName: "New Life in Christ",
    bibleReference: "Romans 6–8",
    chronologicalOrder: 706,
    parentChapterId: null,
    unlockRequirement: "romans-justification",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Dead to sin; Spirit of adoption; more than conquerors.",
  },
  {
    id: "romans-israel",
    book: "romans",
    section: "Romans",
    displayName: "Israel and God's Mercy",
    bibleReference: "Romans 9–11",
    chronologicalOrder: 707,
    parentChapterId: null,
    unlockRequirement: "romans-sanctification",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "Vessels of mercy; remnant; all Israel mystery.",
  },
  {
    id: "romans-living-sacrifice",
    book: "romans",
    section: "Romans",
    displayName: "Living Sacrifice",
    bibleReference: "Romans 12–15",
    chronologicalOrder: 708,
    parentChapterId: null,
    unlockRequirement: "romans-israel",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Renewed mind; love; weak and strong.",
  },
  {
    id: "romans-greetings",
    book: "romans",
    section: "Romans",
    displayName: "Greetings and Travel Plans",
    bibleReference: "Romans 16",
    chronologicalOrder: 709,
    parentChapterId: null,
    unlockRequirement: "romans-living-sacrifice",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Commended coworkers; warning about dividers.",
  },
  {
    id: "1cor-divisions",
    book: "1-corinthians",
    section: "1 Corinthians",
    displayName: "Divisions in Corinth",
    bibleReference: "1 Corinthians 1–4",
    chronologicalOrder: 710,
    parentChapterId: null,
    unlockRequirement: "romans-greetings",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Boasting in the Lord; stewards of mysteries.",
  },
  {
    id: "1cor-church-discipline",
    book: "1-corinthians",
    section: "1 Corinthians",
    displayName: "Church Discipline and Lawsuits",
    bibleReference: "1 Corinthians 5–6",
    chronologicalOrder: 711,
    parentChapterId: null,
    unlockRequirement: "1cor-divisions",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Purge the leaven; you were washed.",
  },
  {
    id: "1cor-marriage-and-singleness",
    book: "1-corinthians",
    section: "1 Corinthians",
    displayName: "Marriage and Singleness",
    bibleReference: "1 Corinthians 7",
    chronologicalOrder: 712,
    parentChapterId: null,
    unlockRequirement: "1cor-church-discipline",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Remain as you are; undivided devotion.",
  },
  {
    id: "1cor-food-and-idolatry",
    book: "1-corinthians",
    section: "1 Corinthians",
    displayName: "Food and Idolatry",
    bibleReference: "1 Corinthians 8–10",
    chronologicalOrder: 713,
    parentChapterId: null,
    unlockRequirement: "1cor-marriage-and-singleness",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Knowledge puffs up; flee idolatry; do all to God's glory.",
  },
  {
    id: "1cor-worship-order",
    book: "1-corinthians",
    section: "1 Corinthians",
    displayName: "Worship Order and Lord's Supper",
    bibleReference: "1 Corinthians 11",
    chronologicalOrder: 714,
    parentChapterId: null,
    unlockRequirement: "1cor-food-and-idolatry",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Headship signs; discerning the body.",
  },
  {
    id: "1cor-spiritual-gifts",
    book: "1-corinthians",
    section: "1 Corinthians",
    displayName: "Spiritual Gifts and Love",
    bibleReference: "1 Corinthians 12–14",
    chronologicalOrder: 715,
    parentChapterId: null,
    unlockRequirement: "1cor-worship-order",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "One body; more excellent way; orderly prophecy.",
  },
  {
    id: "1cor-resurrection",
    book: "1-corinthians",
    section: "1 Corinthians",
    displayName: "Resurrection",
    bibleReference: "1 Corinthians 15",
    chronologicalOrder: 716,
    parentChapterId: null,
    unlockRequirement: "1cor-spiritual-gifts",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Of first importance; raised imperishable.",
  },
  {
    id: "1cor-collection-and-plans",
    book: "1-corinthians",
    section: "1 Corinthians",
    displayName: "Collection and Travel Plans",
    bibleReference: "1 Corinthians 16",
    chronologicalOrder: 717,
    parentChapterId: null,
    unlockRequirement: "1cor-resurrection",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Standing firm; Maranatha.",
  },
  {
    id: "2cor-comfort-and-plans",
    book: "2-corinthians",
    section: "2 Corinthians",
    displayName: "Comfort and Changed Plans",
    bibleReference: "2 Corinthians 1–2",
    chronologicalOrder: 718,
    parentChapterId: null,
    unlockRequirement: "1cor-collection-and-plans",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Father of mercies; aroma of Christ.",
  },
  {
    id: "2cor-ministers-of-new-covenant",
    book: "2-corinthians",
    section: "2 Corinthians",
    displayName: "Ministers of the New Covenant",
    bibleReference: "2 Corinthians 3–5",
    chronologicalOrder: 719,
    parentChapterId: null,
    unlockRequirement: "2cor-comfort-and-plans",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Veil removed; jars of clay; ambassadors.",
  },
  {
    id: "2cor-holy-separation-collection",
    book: "2-corinthians",
    section: "2 Corinthians",
    displayName: "Holy Separation and Collection",
    bibleReference: "2 Corinthians 6–9",
    chronologicalOrder: 720,
    parentChapterId: null,
    unlockRequirement: "2cor-ministers-of-new-covenant",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Unequal yokes; cheerful giving.",
  },
  {
    id: "2cor-paul-defends-apostleship",
    book: "2-corinthians",
    section: "2 Corinthians",
    displayName: "Paul Defends Apostleship",
    bibleReference: "2 Corinthians 10–13",
    chronologicalOrder: 721,
    parentChapterId: null,
    unlockRequirement: "2cor-holy-separation-collection",
    status: "comingSoon",
    estimatedGameplayType: ["Dialogue", "Interactive Letter"],
    description: "Thorn in the flesh; examine yourselves.",
  },
  {
    id: "galatians-true-gospel",
    book: "galatians",
    section: "Galatians",
    displayName: "No Other Gospel",
    bibleReference: "Galatians 1–2",
    chronologicalOrder: 722,
    parentChapterId: null,
    unlockRequirement: "2cor-paul-defends-apostleship",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Apostleship from Christ; confronting Cephas.",
  },
  {
    id: "galatians-faith-not-law",
    book: "galatians",
    section: "Galatians",
    displayName: "Faith, Not Law",
    bibleReference: "Galatians 3–4",
    chronologicalOrder: 723,
    parentChapterId: null,
    unlockRequirement: "galatians-true-gospel",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Abraham's children; schoolmaster; heirs through Christ.",
  },
  {
    id: "galatians-freedom-and-spirit",
    book: "galatians",
    section: "Galatians",
    displayName: "Freedom and the Spirit",
    bibleReference: "Galatians 5–6",
    chronologicalOrder: 724,
    parentChapterId: null,
    unlockRequirement: "galatians-faith-not-law",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Teaching"],
    description: "Fruit of the Spirit; bear one another's burdens.",
  },
  {
    id: "ephesians-blessings-in-christ",
    book: "ephesians",
    section: "Ephesians",
    displayName: "Every Spiritual Blessing",
    bibleReference: "Ephesians 1–2",
    chronologicalOrder: 725,
    parentChapterId: null,
    unlockRequirement: "galatians-freedom-and-spirit",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Chosen; made alive; one new humanity.",
  },
  {
    id: "ephesians-mystery-and-unity",
    book: "ephesians",
    section: "Ephesians",
    displayName: "Mystery and Unity",
    bibleReference: "Ephesians 3–4",
    chronologicalOrder: 726,
    parentChapterId: null,
    unlockRequirement: "ephesians-blessings-in-christ",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Gentile heirs; one body; put on the new self.",
  },
  {
    id: "ephesians-walk-and-armor",
    book: "ephesians",
    section: "Ephesians",
    displayName: "Walk in Love; Armor of God",
    bibleReference: "Ephesians 5–6",
    chronologicalOrder: 727,
    parentChapterId: null,
    unlockRequirement: "ephesians-mystery-and-unity",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Household codes; stand against the schemes of the devil.",
  },
  {
    id: "philippians-joy-in-chains",
    book: "philippians",
    section: "Philippians",
    displayName: "Joy in Chains",
    bibleReference: "Philippians 1",
    chronologicalOrder: 728,
    parentChapterId: null,
    unlockRequirement: "ephesians-walk-and-armor",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "To live is Christ; advance of the gospel.",
  },
  {
    id: "philippians-humility-of-christ",
    book: "philippians",
    section: "Philippians",
    displayName: "Humility of Christ",
    bibleReference: "Philippians 2",
    chronologicalOrder: 729,
    parentChapterId: null,
    unlockRequirement: "philippians-joy-in-chains",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Emptied himself; work out your salvation.",
  },
  {
    id: "philippians-pressing-on",
    book: "philippians",
    section: "Philippians",
    displayName: "Pressing On",
    bibleReference: "Philippians 3–4",
    chronologicalOrder: 730,
    parentChapterId: null,
    unlockRequirement: "philippians-humility-of-christ",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Count all as loss; rejoice always; contentment.",
  },
  {
    id: "colossians-supremacy-of-christ",
    book: "colossians",
    section: "Colossians",
    displayName: "Supremacy of Christ",
    bibleReference: "Colossians 1–2",
    chronologicalOrder: 731,
    parentChapterId: null,
    unlockRequirement: "philippians-pressing-on",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Image of the invisible God; fullness dwells bodily.",
  },
  {
    id: "colossians-raised-with-christ",
    book: "colossians",
    section: "Colossians",
    displayName: "Raised with Christ",
    bibleReference: "Colossians 3–4",
    chronologicalOrder: 732,
    parentChapterId: null,
    unlockRequirement: "colossians-supremacy-of-christ",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Set your minds above; household life; speech seasoned with salt.",
  },
  {
    id: "1thess-model-church",
    book: "1-thessalonians",
    section: "1 Thessalonians",
    displayName: "Model Church",
    bibleReference: "1 Thessalonians 1–3",
    chronologicalOrder: 733,
    parentChapterId: null,
    unlockRequirement: "colossians-raised-with-christ",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Faith, love, hope; Timothy's good report.",
  },
  {
    id: "1thess-holy-living-and-parousia",
    book: "1-thessalonians",
    section: "1 Thessalonians",
    displayName: "Holy Living and the Parousia",
    bibleReference: "1 Thessalonians 4–5",
    chronologicalOrder: 734,
    parentChapterId: null,
    unlockRequirement: "1thess-model-church",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Prophecy"],
    description: "Caught up together; children of light.",
  },
  {
    id: "2thess-relief-and-man-of-lawlessness",
    book: "2-thessalonians",
    section: "2 Thessalonians",
    displayName: "Relief and the Man of Lawlessness",
    bibleReference: "2 Thessalonians 1–2",
    chronologicalOrder: 735,
    parentChapterId: null,
    unlockRequirement: "1thess-holy-living-and-parousia",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "When the Lord Jesus is revealed; standing firm.",
  },
  {
    id: "2thess-work-and-steadfastness",
    book: "2-thessalonians",
    section: "2 Thessalonians",
    displayName: "Work and Steadfastness",
    bibleReference: "2 Thessalonians 3",
    chronologicalOrder: 736,
    parentChapterId: null,
    unlockRequirement: "2thess-relief-and-man-of-lawlessness",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Do not grow weary in doing good.",
  },
  {
    id: "1tim-charge-and-worship",
    book: "1-timothy",
    section: "1 Timothy",
    displayName: "Charge and Worship",
    bibleReference: "1 Timothy 1–2",
    chronologicalOrder: 737,
    parentChapterId: null,
    unlockRequirement: "2thess-work-and-steadfastness",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Wage the good warfare; pray for all people.",
  },
  {
    id: "1tim-leaders-and-godliness",
    book: "1-timothy",
    section: "1 Timothy",
    displayName: "Leaders and Godliness",
    bibleReference: "1 Timothy 3–4",
    chronologicalOrder: 738,
    parentChapterId: null,
    unlockRequirement: "1tim-charge-and-worship",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Qualifications; mystery of godliness; train for godliness.",
  },
  {
    id: "1tim-care-of-the-church",
    book: "1-timothy",
    section: "1 Timothy",
    displayName: "Care of the Church",
    bibleReference: "1 Timothy 5–6",
    chronologicalOrder: 739,
    parentChapterId: null,
    unlockRequirement: "1tim-leaders-and-godliness",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Widows, elders, contentment; fight the good fight.",
  },
  {
    id: "2tim-fan-the-gift",
    book: "2-timothy",
    section: "2 Timothy",
    displayName: "Fan into Flame the Gift",
    bibleReference: "2 Timothy 1–2",
    chronologicalOrder: 740,
    parentChapterId: null,
    unlockRequirement: "1tim-care-of-the-church",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Not a spirit of fear; entrust to faithful people.",
  },
  {
    id: "2tim-preach-the-word",
    book: "2-timothy",
    section: "2 Timothy",
    displayName: "Preach the Word",
    bibleReference: "2 Timothy 3–4",
    chronologicalOrder: 741,
    parentChapterId: null,
    unlockRequirement: "2tim-fan-the-gift",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "All Scripture God-breathed; I have fought the good fight.",
  },
  {
    id: "titus-elders-and-sound-doctrine",
    book: "titus",
    section: "Titus",
    displayName: "Elders and Sound Doctrine",
    bibleReference: "Titus 1–2",
    chronologicalOrder: 742,
    parentChapterId: null,
    unlockRequirement: "2tim-preach-the-word",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Appoint elders; grace trains us to renounce ungodliness.",
  },
  {
    id: "titus-ready-for-good-works",
    book: "titus",
    section: "Titus",
    displayName: "Ready for Good Works",
    bibleReference: "Titus 3",
    chronologicalOrder: 743,
    parentChapterId: null,
    unlockRequirement: "titus-elders-and-sound-doctrine",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "He saved us — devote yourselves to good works.",
  },
  {
    id: "philemon-appeal",
    book: "philemon",
    section: "Philemon",
    displayName: "Appeal for Onesimus",
    bibleReference: "Philemon 1",
    chronologicalOrder: 744,
    parentChapterId: null,
    unlockRequirement: "titus-ready-for-good-works",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Letter", "Decision"],
    description: "No longer as a slave but a beloved brother.",
  },
  {
    id: "hebrews-superior-son",
    book: "hebrews",
    section: "Hebrews",
    displayName: "Superior Son",
    bibleReference: "Hebrews 1–2",
    chronologicalOrder: 745,
    parentChapterId: null,
    unlockRequirement: "philemon-appeal",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "God has spoken by his Son; crowned with glory.",
  },
  {
    id: "hebrews-rest-and-high-priest",
    book: "hebrews",
    section: "Hebrews",
    displayName: "Rest and High Priest",
    bibleReference: "Hebrews 3–5",
    chronologicalOrder: 746,
    parentChapterId: null,
    unlockRequirement: "hebrews-superior-son",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Today if you hear his voice; Melchizedek order.",
  },
  {
    id: "hebrews-better-covenant",
    book: "hebrews",
    section: "Hebrews",
    displayName: "Better Covenant",
    bibleReference: "Hebrews 6–8",
    chronologicalOrder: 747,
    parentChapterId: null,
    unlockRequirement: "hebrews-rest-and-high-priest",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Anchor of the soul; mediator of a better covenant.",
  },
  {
    id: "hebrews-better-sacrifice",
    book: "hebrews",
    section: "Hebrews",
    displayName: "Better Sacrifice",
    bibleReference: "Hebrews 9–10",
    chronologicalOrder: 748,
    parentChapterId: null,
    unlockRequirement: "hebrews-better-covenant",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Temple"],
    description: "Blood that cleanses conscience; draw near with confidence.",
  },
  {
    id: "hebrews-faith-hall",
    book: "hebrews",
    section: "Hebrews",
    displayName: "Hall of Faith",
    bibleReference: "Hebrews 11",
    chronologicalOrder: 749,
    parentChapterId: null,
    unlockRequirement: "hebrews-better-sacrifice",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Genealogy", "Teaching"],
    description: "By faith the elders received their commendation.",
  },
  {
    id: "hebrews-endurance",
    book: "hebrews",
    section: "Hebrews",
    displayName: "Endurance and Worship",
    bibleReference: "Hebrews 12–13",
    chronologicalOrder: 750,
    parentChapterId: null,
    unlockRequirement: "hebrews-faith-hall",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Teaching"],
    description: "Cloud of witnesses; outside the camp; continual sacrifice of praise.",
  },
  {
    id: "james-trials-and-word",
    book: "james",
    section: "James",
    displayName: "Trials and the Word",
    bibleReference: "James 1",
    chronologicalOrder: 751,
    parentChapterId: null,
    unlockRequirement: "hebrews-endurance",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Count it joy; be doers of the word.",
  },
  {
    id: "james-faith-and-works",
    book: "james",
    section: "James",
    displayName: "Faith and Works",
    bibleReference: "James 2",
    chronologicalOrder: 752,
    parentChapterId: null,
    unlockRequirement: "james-trials-and-word",
    status: "comingSoon",
    estimatedGameplayType: "Decision",
    description: "Faith apart from works is dead.",
  },
  {
    id: "james-tongue-and-wisdom",
    book: "james",
    section: "James",
    displayName: "Tongue and Wisdom",
    bibleReference: "James 3",
    chronologicalOrder: 753,
    parentChapterId: null,
    unlockRequirement: "james-faith-and-works",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Taming the tongue; wisdom from above.",
  },
  {
    id: "james-worldliness-and-patience",
    book: "james",
    section: "James",
    displayName: "Worldliness and Patience",
    bibleReference: "James 4–5",
    chronologicalOrder: 754,
    parentChapterId: null,
    unlockRequirement: "james-tongue-and-wisdom",
    status: "comingSoon",
    estimatedGameplayType: ["Decision", "Teaching"],
    description: "Submit to God; the Judge is standing at the door.",
  },
  {
    id: "1peter-living-hope",
    book: "1-peter",
    section: "1 Peter",
    displayName: "Living Hope",
    bibleReference: "1 Peter 1–2:10",
    chronologicalOrder: 755,
    parentChapterId: null,
    unlockRequirement: "james-worldliness-and-patience",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Born again to a living hope; living stones.",
  },
  {
    id: "1peter-exile-ethics",
    book: "1-peter",
    section: "1 Peter",
    displayName: "Exile Ethics",
    bibleReference: "1 Peter 2:11–4:19",
    chronologicalOrder: 756,
    parentChapterId: null,
    unlockRequirement: "1peter-living-hope",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Decision"],
    description: "Honor everyone; suffer as a Christian.",
  },
  {
    id: "1peter-shepherd-the-flock",
    book: "1-peter",
    section: "1 Peter",
    displayName: "Shepherd the Flock",
    bibleReference: "1 Peter 5",
    chronologicalOrder: 757,
    parentChapterId: null,
    unlockRequirement: "1peter-exile-ethics",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Humble yourselves; casting all your anxieties on him.",
  },
  {
    id: "2peter-precious-promises",
    book: "2-peter",
    section: "2 Peter",
    displayName: "Precious Promises",
    bibleReference: "2 Peter 1",
    chronologicalOrder: 758,
    parentChapterId: null,
    unlockRequirement: "1peter-shepherd-the-flock",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Partakers of the divine nature; confirm your calling.",
  },
  {
    id: "2peter-false-teachers",
    book: "2-peter",
    section: "2 Peter",
    displayName: "False Teachers",
    bibleReference: "2 Peter 2",
    chronologicalOrder: 759,
    parentChapterId: null,
    unlockRequirement: "2peter-precious-promises",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Destructive heresies; better never to have known.",
  },
  {
    id: "2peter-day-of-the-lord",
    book: "2-peter",
    section: "2 Peter",
    displayName: "Day of the Lord",
    bibleReference: "2 Peter 3",
    chronologicalOrder: 760,
    parentChapterId: null,
    unlockRequirement: "2peter-false-teachers",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Prophecy",
    description: "New heavens and a new earth in which righteousness dwells.",
  },
  {
    id: "1john-word-of-life",
    book: "1-john",
    section: "1 John",
    displayName: "Word of Life",
    bibleReference: "1 John 1–2",
    chronologicalOrder: 761,
    parentChapterId: null,
    unlockRequirement: "2peter-day-of-the-lord",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "God is light; antichrists; abide in him.",
  },
  {
    id: "1john-love-one-another",
    book: "1-john",
    section: "1 John",
    displayName: "Love One Another",
    bibleReference: "1 John 3–4",
    chronologicalOrder: 762,
    parentChapterId: null,
    unlockRequirement: "1john-word-of-life",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "We love because he first loved us.",
  },
  {
    id: "1john-assurance",
    book: "1-john",
    section: "1 John",
    displayName: "Assurance",
    bibleReference: "1 John 5",
    chronologicalOrder: 763,
    parentChapterId: null,
    unlockRequirement: "1john-love-one-another",
    status: "comingSoon",
    estimatedGameplayType: "Teaching",
    description: "Whoever has the Son has life.",
  },
  {
    id: "2john-truth-and-love",
    book: "2-john",
    section: "2 John",
    displayName: "Truth and Love",
    bibleReference: "2 John 1",
    chronologicalOrder: 764,
    parentChapterId: null,
    unlockRequirement: "1john-assurance",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Walk in truth; do not receive false teachers.",
  },
  {
    id: "3john-hospitality-and-diotrephes",
    book: "3-john",
    section: "3 John",
    displayName: "Hospitality and Diotrephes",
    bibleReference: "3 John 1",
    chronologicalOrder: 765,
    parentChapterId: null,
    unlockRequirement: "2john-truth-and-love",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Imitate good; Demetrius has received a good testimony.",
  },
  {
    id: "jude-contend-for-the-faith",
    book: "jude",
    section: "Jude",
    displayName: "Contend for the Faith",
    bibleReference: "Jude 1",
    chronologicalOrder: 766,
    parentChapterId: null,
    unlockRequirement: "3john-hospitality-and-diotrephes",
    status: "comingSoon",
    estimatedGameplayType: ["Teaching", "Interactive Letter"],
    description: "Keep yourselves in the love of God; to him who is able.",
  },
  {
    id: "revelation-prologue",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Prologue and Vision of the Son",
    bibleReference: "Revelation 1",
    chronologicalOrder: 767,
    parentChapterId: null,
    unlockRequirement: "jude-contend-for-the-faith",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Cutscene"],
    description: "Alpha and Omega; among the lampstands.",
  },
  {
    id: "letter-to-ephesus",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Letter to Ephesus",
    bibleReference: "Revelation 2:1–7",
    chronologicalOrder: 768,
    parentChapterId: null,
    unlockRequirement: "revelation-prologue",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Lost first love — remember, repent, return.",
  },
  {
    id: "letter-to-smyrna",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Letter to Smyrna",
    bibleReference: "Revelation 2:8–11",
    chronologicalOrder: 769,
    parentChapterId: null,
    unlockRequirement: "letter-to-ephesus",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Faithful unto death; crown of life.",
  },
  {
    id: "letter-to-pergimum",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Letter to Pergamum",
    bibleReference: "Revelation 2:12–17",
    chronologicalOrder: 770,
    parentChapterId: null,
    unlockRequirement: "letter-to-smyrna",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Where Satan's throne is; hidden manna.",
  },
  {
    id: "letter-to-thyatira",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Letter to Thyatira",
    bibleReference: "Revelation 2:18–29",
    chronologicalOrder: 771,
    parentChapterId: null,
    unlockRequirement: "letter-to-pergimum",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Jezebel tolerated; authority over nations.",
  },
  {
    id: "letter-to-sardis",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Letter to Sardis",
    bibleReference: "Revelation 3:1–6",
    chronologicalOrder: 772,
    parentChapterId: null,
    unlockRequirement: "letter-to-thyatira",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "You have the reputation of being alive.",
  },
  {
    id: "letter-to-philadelphia",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Letter to Philadelphia",
    bibleReference: "Revelation 3:7–13",
    chronologicalOrder: 773,
    parentChapterId: null,
    unlockRequirement: "letter-to-sardis",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Open door; pillar in the temple.",
  },
  {
    id: "letter-to-laodicea",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Letter to Laodicea",
    bibleReference: "Revelation 3:14–22",
    chronologicalOrder: 774,
    parentChapterId: null,
    unlockRequirement: "letter-to-philadelphia",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Letter",
    description: "Lukewarm; behold I stand at the door and knock.",
  },
  {
    id: "throne-room",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Throne Room",
    bibleReference: "Revelation 4",
    chronologicalOrder: 775,
    parentChapterId: null,
    unlockRequirement: "letter-to-laodicea",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Holy, holy, holy is the Lord God Almighty.",
  },
  {
    id: "scroll-and-lamb",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Scroll and the Lamb",
    bibleReference: "Revelation 5",
    chronologicalOrder: 776,
    parentChapterId: null,
    unlockRequirement: "throne-room",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Worthy is the Lamb who was slain.",
  },
  {
    id: "seven-seals",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Seven Seals",
    bibleReference: "Revelation 6–8:1",
    chronologicalOrder: 777,
    parentChapterId: null,
    unlockRequirement: "scroll-and-lamb",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Horsemen; martyrs; silence in heaven.",
  },
  {
    id: "144000-and-great-multitude",
    book: "revelation",
    section: "Apocalypse",
    displayName: "144,000 and Great Multitude",
    bibleReference: "Revelation 7",
    chronologicalOrder: 778,
    parentChapterId: null,
    unlockRequirement: "seven-seals",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Sealed servants; washed robes in the blood of the Lamb.",
  },
  {
    id: "seven-trumpets",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Seven Trumpets",
    bibleReference: "Revelation 8:2–11:19",
    chronologicalOrder: 779,
    parentChapterId: null,
    unlockRequirement: "144000-and-great-multitude",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Judgments on earth; two witnesses; kingdom proclaimed.",
  },
  {
    id: "woman-dragon-beasts",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Woman, Dragon, and Beasts",
    bibleReference: "Revelation 12–13",
    chronologicalOrder: 780,
    parentChapterId: null,
    unlockRequirement: "seven-trumpets",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "War in heaven; beasts from sea and earth.",
  },
  {
    id: "144000-and-three-angels",
    book: "revelation",
    section: "Apocalypse",
    displayName: "144,000 and Three Angels",
    bibleReference: "Revelation 14",
    chronologicalOrder: 781,
    parentChapterId: null,
    unlockRequirement: "woman-dragon-beasts",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "New song; eternal gospel; harvest of the earth.",
  },
  {
    id: "seven-bowls",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Seven Bowls",
    bibleReference: "Revelation 15–16",
    chronologicalOrder: 782,
    parentChapterId: null,
    unlockRequirement: "144000-and-three-angels",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Song of Moses and the Lamb; bowls of wrath.",
  },
  {
    id: "babylon-the-great",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Babylon the Great",
    bibleReference: "Revelation 17–18",
    chronologicalOrder: 783,
    parentChapterId: null,
    unlockRequirement: "seven-bowls",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Harlot judged; merchants weep; come out of her.",
  },
  {
    id: "marriage-supper-and-rider",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Marriage Supper and Rider on the White Horse",
    bibleReference: "Revelation 19",
    chronologicalOrder: 784,
    parentChapterId: null,
    unlockRequirement: "babylon-the-great",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Hallelujah; Faithful and True.",
  },
  {
    id: "millennium-and-judgment",
    book: "revelation",
    section: "Apocalypse",
    displayName: "Millennium and Final Judgment",
    bibleReference: "Revelation 20",
    chronologicalOrder: 785,
    parentChapterId: null,
    unlockRequirement: "marriage-supper-and-rider",
    status: "comingSoon",
    estimatedGameplayType: "Interactive Vision",
    description: "Satan bound; great white throne; book of life.",
  },
  {
    id: "new-heaven-and-new-earth",
    book: "revelation",
    section: "Apocalypse",
    displayName: "New Heaven and New Earth",
    bibleReference: "Revelation 21–22",
    chronologicalOrder: 786,
    parentChapterId: null,
    unlockRequirement: "millennium-and-judgment",
    status: "comingSoon",
    estimatedGameplayType: ["Interactive Vision", "Cutscene"],
    description: "Behold, I am making all things new — Amen. Come, Lord Jesus.",
  },
];
